/* tslint:disable */
/* eslint-disable */
/**
 * Revix.Api.Dashboard Api
 * Revix Public Api
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AccessTokenDto
 */
export interface AccessTokenDto {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenDto
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenDto
     */
    'tokenExpiry'?: string | null;
}
/**
 * 
 * @export
 * @interface ActiveProductDto
 */
export interface ActiveProductDto {
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'symbol'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'type': ActiveProductDtoTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ActiveProductDto
     */
    'displayOrder': number;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveProductDto
     */
    'isDepositable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveProductDto
     */
    'isWithdrawable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveProductDto
     */
    'isBuyable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveProductDto
     */
    'isSellable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveProductDto
     */
    'isAutoBuyable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActiveProductDto
     */
    'isTracked': boolean;
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'launchedAt': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ActiveProductDto
     */
    'colors': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'factsheetUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'methodologyUrl'?: string | null;
    /**
     * 
     * @type {Array<TagDto>}
     * @memberof ActiveProductDto
     */
    'tags': Array<TagDto>;
    /**
     * 
     * @type {string}
     * @memberof ActiveProductDto
     */
    'redeemableTo'?: string | null;
}

export const ActiveProductDtoTypeEnum = {
    Fiat: 'Fiat',
    Crypto: 'Crypto',
    Bundle: 'Bundle',
    Reward: 'Reward',
    Stake: 'Stake',
    Locked: 'Locked',
    PrivateCredit: 'PrivateCredit',
    Stock: 'Stock',
    Stablecoin: 'Stablecoin'
} as const;

export type ActiveProductDtoTypeEnum = typeof ActiveProductDtoTypeEnum[keyof typeof ActiveProductDtoTypeEnum];

/**
 * 
 * @export
 * @interface AggregatedPortfolioQueryResponse
 */
export interface AggregatedPortfolioQueryResponse {
    /**
     * 
     * @type {number}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'portfolioBalance': number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'cashBalance': number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'cashReserved': number;
    /**
     * 
     * @type {boolean}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'canDeposit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'canWithdraw'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'canLock'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'canUnlock'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'portfolioGainPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'portfolioGainAmount': number;
    /**
     * 
     * @type {Array<ProductHoldings>}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'productHoldings': Array<ProductHoldings>;
    /**
     * 
     * @type {GetRewardsDetailsQueryResponse}
     * @memberof AggregatedPortfolioQueryResponse
     */
    'rewardsDetailsQueryResponse': GetRewardsDetailsQueryResponse;
}
/**
 * 
 * @export
 * @interface AmountBlockDto
 */
export interface AmountBlockDto {
    /**
     * 
     * @type {boolean}
     * @memberof AmountBlockDto
     */
    'isPercentage': boolean;
    /**
     * 
     * @type {number}
     * @memberof AmountBlockDto
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface AskConversationRequestDto
 */
export interface AskConversationRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AskConversationRequestDto
     */
    'question': string;
    /**
     * 
     * @type {Array<ConversationHistoryDto>}
     * @memberof AskConversationRequestDto
     */
    'history': Array<ConversationHistoryDto>;
    /**
     * 
     * @type {ConfigurationsDto}
     * @memberof AskConversationRequestDto
     */
    'configurations': ConfigurationsDto;
    /**
     * 
     * @type {Array<AvailableAssetDto>}
     * @memberof AskConversationRequestDto
     */
    'availableAssets': Array<AvailableAssetDto>;
    /**
     * 
     * @type {PortfolioSummaryDto}
     * @memberof AskConversationRequestDto
     */
    'portfolioSummary': PortfolioSummaryDto;
    /**
     * 
     * @type {Array<AssetBreakdownDto>}
     * @memberof AskConversationRequestDto
     */
    'assetBreakdown'?: Array<AssetBreakdownDto> | null;
}
/**
 * 
 * @export
 * @interface AskConversationResponseDto
 */
export interface AskConversationResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AskConversationResponseDto
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof AskConversationResponseDto
     */
    'aggregatedText': string;
    /**
     * 
     * @type {string}
     * @memberof AskConversationResponseDto
     */
    'response'?: string | null;
}
/**
 * 
 * @export
 * @interface AskRequestDto
 */
export interface AskRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AskRequestDto
     */
    'question': string;
    /**
     * 
     * @type {string}
     * @memberof AskRequestDto
     */
    'pageName': string;
    /**
     * 
     * @type {ConfigurationsDto}
     * @memberof AskRequestDto
     */
    'configurations': ConfigurationsDto;
    /**
     * 
     * @type {Array<AvailableAssetDto>}
     * @memberof AskRequestDto
     */
    'availableAssets': Array<AvailableAssetDto>;
    /**
     * 
     * @type {string}
     * @memberof AskRequestDto
     */
    'model'?: string | null;
    /**
     * 
     * @type {PortfolioSummaryDto}
     * @memberof AskRequestDto
     */
    'portfolioSummary': PortfolioSummaryDto;
    /**
     * 
     * @type {Array<AssetBreakdownDto>}
     * @memberof AskRequestDto
     */
    'assetBreakdown'?: Array<AssetBreakdownDto> | null;
}
/**
 * 
 * @export
 * @interface AskResponseDto
 */
export interface AskResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AskResponseDto
     */
    'conversationId': string;
    /**
     * 
     * @type {string}
     * @memberof AskResponseDto
     */
    'aggregatedText': string;
    /**
     * 
     * @type {any}
     * @memberof AskResponseDto
     */
    'finalJson'?: any | null;
}
/**
 * 
 * @export
 * @interface AssetAggregateDto
 */
export interface AssetAggregateDto {
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'typeCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetAggregateDto
     */
    'categoryCodes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'symbol': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'iconUrl': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'alertAssetCode': string;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'alertMinValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'reservesMax'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'reservesUpper'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'reservesRecommended'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'reservesLower'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'reservesMin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'transactionMin'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'transactionMax'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'isTracked'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'isBase'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'isDisplay'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'isInternal'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetAggregateDto
     */
    'aliases': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'longName': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'pluralName': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AssetAggregateDto
     */
    'colors': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'navigation'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'hasFacts'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'keywords': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'methodology': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'factsheet': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'whitepaper': string;
    /**
     * 
     * @type {boolean}
     * @memberof AssetAggregateDto
     */
    'active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'launchedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'updatedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'createdAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetAggregateDto
     */
    'displayOrder'?: number | null;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof AssetAggregateDto
     */
    'tags': Array<Tag>;
    /**
     * 
     * @type {Array<AssetTag>}
     * @memberof AssetAggregateDto
     */
    'assetTags': Array<AssetTag>;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'category': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'network': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'disclaimer': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'constituents': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'targetWeight': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'distributions': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'endpointId': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'holdings': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'referralCode': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'totalExpenseRatio': string;
    /**
     * 
     * @type {string}
     * @memberof AssetAggregateDto
     */
    'rebalancingFrequency': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AssetAggregateDto
     */
    'productCopy': { [key: string]: any; };
}
/**
 * 
 * @export
 * @interface AssetBreakdownDto
 */
export interface AssetBreakdownDto {
    /**
     * 
     * @type {string}
     * @memberof AssetBreakdownDto
     */
    'assetCode': string;
    /**
     * 
     * @type {number}
     * @memberof AssetBreakdownDto
     */
    'assetValue': number;
    /**
     * 
     * @type {number}
     * @memberof AssetBreakdownDto
     */
    'allTimeReturnValue': number;
    /**
     * 
     * @type {number}
     * @memberof AssetBreakdownDto
     */
    'allTimeReturnPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof AssetBreakdownDto
     */
    'weighting': number;
}
/**
 * 
 * @export
 * @interface AssetTag
 */
export interface AssetTag {
    /**
     * 
     * @type {string}
     * @memberof AssetTag
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AssetTag
     */
    'displayName': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof AssetTag
     */
    'colors': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface AuthResponse
 */
export interface AuthResponse {
    /**
     * 
     * @type {boolean}
     * @memberof AuthResponse
     */
    'success': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthResponse
     */
    'twoFactorRequired': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AuthResponse
     */
    'twoFactorRegistrationRequired': boolean;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'zendeskToken': string;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'tokenExpires': string;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'statusReason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AuthResponse
     */
    'status'?: string | null;
}
/**
 * 
 * @export
 * @interface AvailableAssetDto
 */
export interface AvailableAssetDto {
    /**
     * 
     * @type {string}
     * @memberof AvailableAssetDto
     */
    'assetCode': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAssetDto
     */
    'assetName': string;
    /**
     * 
     * @type {string}
     * @memberof AvailableAssetDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof AvailableAssetDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof AvailableAssetDto
     */
    'returnValue': number;
    /**
     * 
     * @type {number}
     * @memberof AvailableAssetDto
     */
    'returnPercentage': number;
    /**
     * 
     * @type {Array<BreakdownItemDto>}
     * @memberof AvailableAssetDto
     */
    'breakdown'?: Array<BreakdownItemDto> | null;
}
/**
 * 
 * @export
 * @interface Balance
 */
export interface Balance {
    /**
     * 
     * @type {number}
     * @memberof Balance
     */
    'units': number;
    /**
     * 
     * @type {number}
     * @memberof Balance
     */
    'amountInDisplay': number;
}
/**
 * 
 * @export
 * @interface BankCountryDto
 */
export interface BankCountryDto {
    /**
     * 
     * @type {string}
     * @memberof BankCountryDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof BankCountryDto
     */
    'countryName': string;
}
/**
 * 
 * @export
 * @interface BaseUserResponseDto
 */
export interface BaseUserResponseDto {
    /**
     * 
     * @type {string}
     * @memberof BaseUserResponseDto
     */
    'userId'?: string | null;
}
/**
 * 
 * @export
 * @interface BreakdownItemDto
 */
export interface BreakdownItemDto {
    /**
     * 
     * @type {string}
     * @memberof BreakdownItemDto
     */
    'assetCode': string;
    /**
     * 
     * @type {string}
     * @memberof BreakdownItemDto
     */
    'assetName': string;
    /**
     * 
     * @type {number}
     * @memberof BreakdownItemDto
     */
    'currentWeighting': number;
    /**
     * 
     * @type {number}
     * @memberof BreakdownItemDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof BreakdownItemDto
     */
    'returnValue': number;
    /**
     * 
     * @type {number}
     * @memberof BreakdownItemDto
     */
    'returnPercentage': number;
}
/**
 * 
 * @export
 * @interface CashBalanceDto
 */
export interface CashBalanceDto {
    /**
     * 
     * @type {string}
     * @memberof CashBalanceDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CashBalanceDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof CashBalanceDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CashBalanceDto
     */
    'symbol': string;
    /**
     * 
     * @type {number}
     * @memberof CashBalanceDto
     */
    'units': number;
    /**
     * 
     * @type {string}
     * @memberof CashBalanceDto
     */
    'displaySymbol': string;
    /**
     * 
     * @type {number}
     * @memberof CashBalanceDto
     */
    'displayUnits'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CashBalanceDto
     */
    'reservedUnits': number;
}
/**
 * 
 * @export
 * @interface ChangeEmailRequest
 */
export interface ChangeEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailRequest
     */
    'existingPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangeEmailRequest
     */
    'newEmail': string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'existingPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ClientApplicationSso
 */
export interface ClientApplicationSso {
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'clientApplicationCode': string;
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'ssoProvider': string;
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'ssoProviderCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientApplicationSso
     */
    'clientId': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'metadataAddress': string;
    /**
     * 
     * @type {number}
     * @memberof ClientApplicationSso
     */
    'metadataAutomaticRefreshIntervalInHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ClientApplicationSso
     */
    'metadataRefreshIntervalInSeconds'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClientApplicationSso
     */
    'active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof ClientApplicationSso
     */
    'createdAt'?: string | null;
}
/**
 * 
 * @export
 * @interface CompletedDeFiTransactionDto
 */
export interface CompletedDeFiTransactionDto {
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'dateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'orderType': CompletedDeFiTransactionDtoOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'orderTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof CompletedDeFiTransactionDto
     */
    'amountBeforeFee': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDeFiTransactionDto
     */
    'amountBeforeFeeAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDeFiTransactionDto
     */
    'fee': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDeFiTransactionDto
     */
    'feeAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDeFiTransactionDto
     */
    'amountAfterFees': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDeFiTransactionDto
     */
    'amountAfterFeesAsFunctionalProduct': number;
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'functionalSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'customerFunctionalProduct': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDeFiTransactionDto
     */
    'productCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof CompletedDeFiTransactionDto
     */
    'isBonus': boolean;
}

export const CompletedDeFiTransactionDtoOrderTypeEnum = {
    All: 'All',
    Lock: 'Lock',
    Unlock: 'Unlock'
} as const;

export type CompletedDeFiTransactionDtoOrderTypeEnum = typeof CompletedDeFiTransactionDtoOrderTypeEnum[keyof typeof CompletedDeFiTransactionDtoOrderTypeEnum];

/**
 * 
 * @export
 * @interface CompletedDepositsWithdrawalsDto
 */
export interface CompletedDepositsWithdrawalsDto {
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'dateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'orderType': CompletedDepositsWithdrawalsDtoOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'orderTypeName': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'orderReference': string;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'amountAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'amountAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'feesAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'feesAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'amountAfterFees': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'amountAfterFeesAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'currentPrice': number;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'symbol': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'customerFunctionalProduct': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'fromProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'toProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedDepositsWithdrawalsDto
     */
    'customerCompanyCode': string;
}

export const CompletedDepositsWithdrawalsDtoOrderTypeEnum = {
    All: 'All',
    BankDeposit: 'BankDeposit',
    CryptoDeposit: 'CryptoDeposit',
    BankWithdrawal: 'BankWithdrawal',
    CryptoWithdrawal: 'CryptoWithdrawal',
    AddCryptoFunds: 'AddCryptoFunds',
    AddFiatFunds: 'AddFiatFunds',
    RemoveCryptoFunds: 'RemoveCryptoFunds',
    RemoveFiatFunds: 'RemoveFiatFunds',
    ReferralDeposit: 'ReferralDeposit',
    StitchDeposit: 'StitchDeposit'
} as const;

export type CompletedDepositsWithdrawalsDtoOrderTypeEnum = typeof CompletedDepositsWithdrawalsDtoOrderTypeEnum[keyof typeof CompletedDepositsWithdrawalsDtoOrderTypeEnum];

/**
 * 
 * @export
 * @interface CompletedTransactionHistoryDto
 */
export interface CompletedTransactionHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'dateTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'orderType': CompletedTransactionHistoryDtoOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'orderTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'amountAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'amountAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'feesAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'feesAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'amountReceived': number;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'amountReceivedAsFunctionalProduct': number;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'fromSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'fromProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'toSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'toProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof CompletedTransactionHistoryDto
     */
    'customerFunctionalProduct': string;
    /**
     * 
     * @type {number}
     * @memberof CompletedTransactionHistoryDto
     */
    'orderReference': number;
    /**
     * 
     * @type {TransactionAdjustmentDetailsDto}
     * @memberof CompletedTransactionHistoryDto
     */
    'transactionAdjustmentDetails': TransactionAdjustmentDetailsDto;
}

export const CompletedTransactionHistoryDtoOrderTypeEnum = {
    All: 'All',
    Buy: 'Buy',
    AutoBuy: 'AutoBuy',
    Sell: 'Sell',
    Rebalance: 'Rebalance',
    Redeem: 'Redeem',
    CreditAdjustment: 'CreditAdjustment',
    DebitAdjustment: 'DebitAdjustment'
} as const;

export type CompletedTransactionHistoryDtoOrderTypeEnum = typeof CompletedTransactionHistoryDtoOrderTypeEnum[keyof typeof CompletedTransactionHistoryDtoOrderTypeEnum];

/**
 * 
 * @export
 * @interface ConfigurationsDto
 */
export interface ConfigurationsDto {
    /**
     * 
     * @type {number}
     * @memberof ConfigurationsDto
     */
    'timeFrameInDays': number;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationsDto
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof ConfigurationsDto
     */
    'currencySymbol': string;
}
/**
 * 
 * @export
 * @interface ConversationHistoryDto
 */
export interface ConversationHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof ConversationHistoryDto
     */
    'role': string;
    /**
     * 
     * @type {string}
     * @memberof ConversationHistoryDto
     */
    'content': string;
}
/**
 * 
 * @export
 * @interface Country
 */
export interface Country {
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'dialCode': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'baseCurrencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'displayCurrencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'iconUrl': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'timeZone': string;
    /**
     * 
     * @type {string}
     * @memberof Country
     */
    'alpha3Code': string;
}
/**
 * 
 * @export
 * @interface CreateCryptoWithdrawDto
 */
export interface CreateCryptoWithdrawDto {
    /**
     * 
     * @type {number}
     * @memberof CreateCryptoWithdrawDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCryptoWithdrawDto
     */
    'quotedFeeAmount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateCryptoWithdrawDto
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCryptoWithdrawDto
     */
    'productCode': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCryptoWithdrawDto
     */
    'otpFlowTypeCode': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateCryptoWithdrawDto
     */
    'twoFactorPins': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateCryptoWithdrawDto
     */
    'acceptAbsolution'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CreateFiatDepositDto
 */
export interface CreateFiatDepositDto {
    /**
     * 
     * @type {number}
     * @memberof CreateFiatDepositDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFiatDepositDto
     */
    'quotedFee'?: number | null;
}
/**
 * 
 * @export
 * @interface CreateFiatWithdrawDto
 */
export interface CreateFiatWithdrawDto {
    /**
     * 
     * @type {number}
     * @memberof CreateFiatWithdrawDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof CreateFiatWithdrawDto
     */
    'quotedFeeAmount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateFiatWithdrawDto
     */
    'accountId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateFiatWithdrawDto
     */
    'productCode': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreateFiatWithdrawDto
     */
    'twoFactorPins': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof CreateFiatWithdrawDto
     */
    'acceptAbsolution'?: boolean | null;
}
/**
 * 
 * @export
 * @interface CreateRecurringBuyRequest
 */
export interface CreateRecurringBuyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringBuyRequest
     */
    'productCode': string;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringBuyRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringBuyRequest
     */
    'interval': CreateRecurringBuyRequestIntervalEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateRecurringBuyRequest
     */
    'dayOfMonth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecurringBuyRequest
     */
    'dayOfWeek'?: CreateRecurringBuyRequestDayOfWeekEnum | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateRecurringBuyRequest
     */
    'executeImmediately': boolean;
}

export const CreateRecurringBuyRequestIntervalEnum = {
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type CreateRecurringBuyRequestIntervalEnum = typeof CreateRecurringBuyRequestIntervalEnum[keyof typeof CreateRecurringBuyRequestIntervalEnum];
export const CreateRecurringBuyRequestDayOfWeekEnum = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;

export type CreateRecurringBuyRequestDayOfWeekEnum = typeof CreateRecurringBuyRequestDayOfWeekEnum[keyof typeof CreateRecurringBuyRequestDayOfWeekEnum];

/**
 * 
 * @export
 * @interface CreatedCryptoDepositDetailsDto
 */
export interface CreatedCryptoDepositDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof CreatedCryptoDepositDetailsDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCryptoDepositDetailsDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof CreatedCryptoDepositDetailsDto
     */
    'tag'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreatedCryptoDepositDetailsDto
     */
    'minimumDeposit': number;
}
/**
 * 
 * @export
 * @interface CredentialDto
 */
export interface CredentialDto {
    /**
     * 
     * @type {string}
     * @memberof CredentialDto
     */
    'credential': string;
}
/**
 * 
 * @export
 * @interface CryptoDepositProductDto
 */
export interface CryptoDepositProductDto {
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'ticker': string;
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof CryptoDepositProductDto
     */
    'price': number;
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'category'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'network'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'disclaimerCopy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CryptoDepositProductDto
     */
    'pendingOrderId'?: string | null;
}
/**
 * 
 * @export
 * @interface CryptoWithdrawProductDataDto
 */
export interface CryptoWithdrawProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof CryptoWithdrawProductDataDto
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof CryptoWithdrawProductDataDto
     */
    'customerFiatBalance'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CryptoWithdrawProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof CryptoWithdrawProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof CryptoWithdrawProductDataDto
     */
    'fees': Array<FeeStructureDto>;
    /**
     * 
     * @type {CyptoWalletAccountDto}
     * @memberof CryptoWithdrawProductDataDto
     */
    'walletAccount': CyptoWalletAccountDto;
}
/**
 * 
 * @export
 * @interface Currency
 */
export interface Currency {
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Currency
     */
    'symbol': string;
}
/**
 * 
 * @export
 * @interface CustomerPersonalDataDto
 */
export interface CustomerPersonalDataDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'birthCountryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'birthCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'residencyCountryCode': string;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'residencyCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'addressLine1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'addressLine2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'streetName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'streetNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'zipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'countryOfTaxResidence'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CustomerPersonalDataDto
     */
    'taxIdentificationNumber'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomerPersonalDataDto
     */
    'isComplete': boolean;
}
/**
 * 
 * @export
 * @interface CyptoWalletAccountDto
 */
export interface CyptoWalletAccountDto {
    /**
     * 
     * @type {string}
     * @memberof CyptoWalletAccountDto
     */
    'customerAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof CyptoWalletAccountDto
     */
    'referenceName': string;
    /**
     * 
     * @type {string}
     * @memberof CyptoWalletAccountDto
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface DetailedRewardDetailsDto
 */
export interface DetailedRewardDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardDetailsDto
     */
    'referralCode': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardDetailsDto
     */
    'rewardsBalance': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardDetailsDto
     */
    'rewardsBalanceInFiat': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardDetailsDto
     */
    'rewardsBalanceFiatSymbol': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardDetailsDto
     */
    'stars': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardDetailsDto
     */
    'currentTierName': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardDetailsDto
     */
    'nextTierName': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardDetailsDto
     */
    'rewardsPointsRequiredForNextTier': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardDetailsDto
     */
    'rewardsPointsRequiredToRedeem': number;
    /**
     * 
     * @type {Array<RewardsDetailsDto>}
     * @memberof DetailedRewardDetailsDto
     */
    'rewardsDetails': Array<RewardsDetailsDto>;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardDetailsDto
     */
    'totalLifeTimePointsBalance': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedRewardDetailsDto
     */
    'nextTierBenefits': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedRewardDetailsDto
     */
    'currentTierBenefits': Array<string>;
}
/**
 * 
 * @export
 * @interface DetailedRewardsHistoryItemDto
 */
export interface DetailedRewardsHistoryItemDto {
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'dateTime': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'rewardAction': DetailedRewardsHistoryItemDtoRewardActionEnum;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'rewardName': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'rewardAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'rewardAmountInFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'bitcoinRedeemedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'runningTotal': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'rewardsTierName': string;
    /**
     * 
     * @type {number}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'rewardTierStarCount': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedRewardsHistoryItemDto
     */
    'symbol': string;
}

export const DetailedRewardsHistoryItemDtoRewardActionEnum = {
    SignUp: 'SignUp',
    Verified: 'Verified',
    FirstInvestment: 'FirstInvestment',
    NextInvestment: 'NextInvestment',
    Referral: 'Referral',
    GoogleReview: 'GoogleReview',
    SurveyCompleted: 'SurveyCompleted',
    RedeemRewards: 'RedeemRewards',
    Other: 'Other',
    HiddenFirstInvestmentAction: 'HiddenFirstInvestmentAction',
    AutoBuy: 'AutoBuy',
    RecurringBuyQuiz: 'RecurringBuyQuiz'
} as const;

export type DetailedRewardsHistoryItemDtoRewardActionEnum = typeof DetailedRewardsHistoryItemDtoRewardActionEnum[keyof typeof DetailedRewardsHistoryItemDtoRewardActionEnum];

/**
 * 
 * @export
 * @interface EuroBankAccountDto
 */
export interface EuroBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof EuroBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EuroBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof EuroBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof EuroBankAccountDto
     */
    'swift': string;
    /**
     * 
     * @type {string}
     * @memberof EuroBankAccountDto
     */
    'iban': string;
    /**
     * 
     * @type {Array<BankCountryDto>}
     * @memberof EuroBankAccountDto
     */
    'countries': Array<BankCountryDto>;
}
/**
 * 
 * @export
 * @interface EuroFiatWithdrawProductDataDto
 */
export interface EuroFiatWithdrawProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof EuroFiatWithdrawProductDataDto
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof EuroFiatWithdrawProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof EuroFiatWithdrawProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof EuroFiatWithdrawProductDataDto
     */
    'fees': Array<FeeStructureDto>;
    /**
     * 
     * @type {EuroBankAccountDto}
     * @memberof EuroFiatWithdrawProductDataDto
     */
    'bankAccount': EuroBankAccountDto;
}
/**
 * 
 * @export
 * @interface FeatureFlag
 */
export interface FeatureFlag {
    /**
     * 
     * @type {string}
     * @memberof FeatureFlag
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlag
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FeatureFlag
     */
    'displayMessage': string;
    /**
     * 
     * @type {boolean}
     * @memberof FeatureFlag
     */
    'active'?: boolean | null;
}
/**
 * 
 * @export
 * @interface FeeStructureDto
 */
export interface FeeStructureDto {
    /**
     * 
     * @type {string}
     * @memberof FeeStructureDto
     */
    'feeType': string;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureDto
     */
    'feeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureDto
     */
    'minFeeAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureDto
     */
    'discount': number;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureDto
     */
    'rangeStart'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FeeStructureDto
     */
    'rangeEnd'?: number | null;
}
/**
 * 
 * @export
 * @interface FiatDepositProductDataDto
 */
export interface FiatDepositProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof FiatDepositProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {number}
     * @memberof FiatDepositProductDataDto
     */
    'maximumAmount': number;
    /**
     * 
     * @type {boolean}
     * @memberof FiatDepositProductDataDto
     */
    'hideDepositInstructions': boolean;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof FiatDepositProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof FiatDepositProductDataDto
     */
    'feeStructures': Array<FeeStructureDto>;
}
/**
 * 
 * @export
 * @interface ForgotPasswordRequest
 */
export interface ForgotPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequest
     */
    'recaptcha': string;
}
/**
 * 
 * @export
 * @interface Gains
 */
export interface Gains {
    /**
     * 
     * @type {number}
     * @memberof Gains
     */
    'gainPercentage'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Gains
     */
    'gainAmount'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Gains
     */
    'rate'?: number | null;
}
/**
 * 
 * @export
 * @interface GbpFiatWithdrawProductDataDto
 */
export interface GbpFiatWithdrawProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof GbpFiatWithdrawProductDataDto
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof GbpFiatWithdrawProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof GbpFiatWithdrawProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof GbpFiatWithdrawProductDataDto
     */
    'fees': Array<FeeStructureDto>;
    /**
     * 
     * @type {UkBankAccountDto}
     * @memberof GbpFiatWithdrawProductDataDto
     */
    'bankAccount': UkBankAccountDto;
}
/**
 * 
 * @export
 * @interface GetGainLossesQueryResponse
 */
export interface GetGainLossesQueryResponse {
    /**
     * 
     * @type {number}
     * @memberof GetGainLossesQueryResponse
     */
    'portfolioGainPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof GetGainLossesQueryResponse
     */
    'portfolioGainAmount': number;
    /**
     * 
     * @type {Array<ProductHoldingsGainsLosses>}
     * @memberof GetGainLossesQueryResponse
     */
    'productHoldingsGainsLosses': Array<ProductHoldingsGainsLosses>;
}
/**
 * 
 * @export
 * @interface GetPendingsOrdersSimpleQueryResponse
 */
export interface GetPendingsOrdersSimpleQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetPendingsOrdersSimpleQueryResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingsOrdersSimpleQueryResponse
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof GetPendingsOrdersSimpleQueryResponse
     */
    'orderActionTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof GetPendingsOrdersSimpleQueryResponse
     */
    'orderActionTypeValue': number;
}
/**
 * 
 * @export
 * @interface GetProductsAndHoldingsQueryResponse
 */
export interface GetProductsAndHoldingsQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'productTypeName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'productType': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'isBuyable'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'isSellable'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'minTrade'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'isDepositable'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'isWithdrawable'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'minWithdrawal'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'symbol': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'redeemsTo': string;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'minDefiRedeem'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'stakesTo': string;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'minDefiStake'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'wac'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'isFunctional'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'isDisplay'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'apy'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'canRedeem'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'currentTierName': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'nextTierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'minDeposit'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'canLock'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'canUnlock'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'lifetimeRewardsPoints'?: number | null;
    /**
     * 
     * @type {StablecoinAutoConversion}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'stablecoinConversionData': StablecoinAutoConversion;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'migratedFrom': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductsAndHoldingsQueryResponse
     */
    'lastUpdated'?: string | null;
}
/**
 * 
 * @export
 * @interface GetRewardsDetailsQueryResponse
 */
export interface GetRewardsDetailsQueryResponse {
    /**
     * 
     * @type {string}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'currentRewardTierName': string;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'lifetimeRewardsPoints': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'pointsForNextTier': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'referrerRewardsPointsAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'referrerRewardsPoints': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'referralDepositAmountAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'refereeMinBuyAmountAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'rewardPointFunctionalRate': number;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'referralCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'dedicatedAccountManager'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'rewardTierDiscountPercentage'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetRewardsDetailsQueryResponse
     */
    'rewardsTierBenefits': Array<string>;
}
/**
 * 
 * @export
 * @interface GraphPoint
 */
export interface GraphPoint {
    /**
     * 
     * @type {number}
     * @memberof GraphPoint
     */
    'timestamp': number;
    /**
     * 
     * @type {number}
     * @memberof GraphPoint
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface HoldingsDto
 */
export interface HoldingsDto {
    /**
     * 
     * @type {string}
     * @memberof HoldingsDto
     */
    'productCode': string;
    /**
     * 
     * @type {number}
     * @memberof HoldingsDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof HoldingsDto
     */
    'reservedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof HoldingsDto
     */
    'wac': number;
    /**
     * 
     * @type {string}
     * @memberof HoldingsDto
     */
    'lastChangedAt': string;
}
/**
 * 
 * @export
 * @interface IntBankAccountDto
 */
export interface IntBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof IntBankAccountDto
     */
    'ibanOrSwift': string;
    /**
     * 
     * @type {Array<BankCountryDto>}
     * @memberof IntBankAccountDto
     */
    'countries': Array<BankCountryDto>;
}
/**
 * 
 * @export
 * @interface LinkWithSsoRequestDto
 */
export interface LinkWithSsoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof LinkWithSsoRequestDto
     */
    'clientApplicationSsoCode': string;
    /**
     * 
     * @type {string}
     * @memberof LinkWithSsoRequestDto
     */
    'ssoJwt': string;
}
/**
 * 
 * @export
 * @interface LinkedDepositAvailableBankDto
 */
export interface LinkedDepositAvailableBankDto {
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositAvailableBankDto
     */
    'bankId': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositAvailableBankDto
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositAvailableBankDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositAvailableBankDto
     */
    'logoUrl': string;
}
/**
 * 
 * @export
 * @interface LinkedDepositCustomerAccountCompleteRequest
 */
export interface LinkedDepositCustomerAccountCompleteRequest {
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountCompleteRequest
     */
    'linkedDepositCustomerAccountId': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LinkedDepositCustomerAccountCompleteRequest
     */
    'customData': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface LinkedDepositCustomerAccountDto
 */
export interface LinkedDepositCustomerAccountDto {
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountDto
     */
    'linkedDepositCustomerAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountDto
     */
    'referenceName': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof LinkedDepositCustomerAccountDto
     */
    'data': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountDto
     */
    'providerCode': string;
}
/**
 * 
 * @export
 * @interface LinkedDepositCustomerAccountFriendlyNameRequest
 */
export interface LinkedDepositCustomerAccountFriendlyNameRequest {
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountFriendlyNameRequest
     */
    'linkedDepositCustomerAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountFriendlyNameRequest
     */
    'friendlyName': string;
}
/**
 * 
 * @export
 * @interface LinkedDepositCustomerAccountProviderDto
 */
export interface LinkedDepositCustomerAccountProviderDto {
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountProviderDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountProviderDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof LinkedDepositCustomerAccountProviderDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface LinkedDepositFiatDepositProductDataDto
 */
export interface LinkedDepositFiatDepositProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof LinkedDepositFiatDepositProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {number}
     * @memberof LinkedDepositFiatDepositProductDataDto
     */
    'maximumAmount': number;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof LinkedDepositFiatDepositProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof LinkedDepositFiatDepositProductDataDto
     */
    'feeStructures': Array<FeeStructureDto>;
    /**
     * 
     * @type {number}
     * @memberof LinkedDepositFiatDepositProductDataDto
     */
    'maximumDepositAmount': number;
    /**
     * 
     * @type {number}
     * @memberof LinkedDepositFiatDepositProductDataDto
     */
    'calculatedMaximumDepositAmount': number;
}
/**
 * 
 * @export
 * @interface LoginMethodDto
 */
export interface LoginMethodDto {
    /**
     * 
     * @type {string}
     * @memberof LoginMethodDto
     */
    'type': string;
    /**
     * 
     * @type {boolean}
     * @memberof LoginMethodDto
     */
    'enabled': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoginMethodDto
     */
    'canEnable': boolean;
}
/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'recaptcha'?: string | null;
}
/**
 * 
 * @export
 * @interface LoginWithSsoRequest
 */
export interface LoginWithSsoRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginWithSsoRequest
     */
    'clientApplicationSsoCode': string;
    /**
     * 
     * @type {string}
     * @memberof LoginWithSsoRequest
     */
    'ssoJwt': string;
}
/**
 * 
 * @export
 * @interface ModifyEuroBankAccountDto
 */
export interface ModifyEuroBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'swift': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyEuroBankAccountDto
     */
    'iban': string;
}
/**
 * 
 * @export
 * @interface ModifyIntBankAccountDto
 */
export interface ModifyIntBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyIntBankAccountDto
     */
    'ibanOrSwift': string;
}
/**
 * 
 * @export
 * @interface ModifySaBankAccountDto
 */
export interface ModifySaBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof ModifySaBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModifySaBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof ModifySaBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ModifySaBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ModifySaBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof ModifySaBankAccountDto
     */
    'branchCode': string;
}
/**
 * 
 * @export
 * @interface ModifyUkBankAccountDto
 */
export interface ModifyUkBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof ModifyUkBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ModifyUkBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyUkBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyUkBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyUkBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof ModifyUkBankAccountDto
     */
    'sortCode': string;
}
/**
 * 
 * @export
 * @interface OrderResponseDto
 */
export interface OrderResponseDto {
    /**
     * 
     * @type {string}
     * @memberof OrderResponseDto
     */
    'orderId': string;
}
/**
 * 
 * @export
 * @interface OtpActivateRequest
 */
export interface OtpActivateRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpActivateRequest
     */
    'otp': string;
    /**
     * 
     * @type {string}
     * @memberof OtpActivateRequest
     */
    'otpFlowTypeCode': string;
}
/**
 * 
 * @export
 * @interface OtpDeactivateRequest
 */
export interface OtpDeactivateRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpDeactivateRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof OtpDeactivateRequest
     */
    'otp': string;
}
/**
 * 
 * @export
 * @interface OtpInitiateEmailRequest
 */
export interface OtpInitiateEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpInitiateEmailRequest
     */
    'otpFlowTypeCode': string;
}
/**
 * 
 * @export
 * @interface OtpInitiateRequest
 */
export interface OtpInitiateRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpInitiateRequest
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtpInitiateRequest
     */
    'number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OtpInitiateRequest
     */
    'otpFlowTypeCode': string;
}
/**
 * 
 * @export
 * @interface OtpSendElevatedRequest
 */
export interface OtpSendElevatedRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpSendElevatedRequest
     */
    'otpFlowTypeCode': string;
}
/**
 * 
 * @export
 * @interface OtpSendEmailRequest
 */
export interface OtpSendEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpSendEmailRequest
     */
    'otpFlowTypeCode': string;
}
/**
 * 
 * @export
 * @interface OtpSendSmsRequest
 */
export interface OtpSendSmsRequest {
    /**
     * 
     * @type {string}
     * @memberof OtpSendSmsRequest
     */
    'otpFlowTypeCode': string;
}
/**
 * 
 * @export
 * @interface PagedListOfCompletedDeFiTransactionDto
 */
export interface PagedListOfCompletedDeFiTransactionDto {
    /**
     * 
     * @type {Array<CompletedDeFiTransactionDto>}
     * @memberof PagedListOfCompletedDeFiTransactionDto
     */
    'items': Array<CompletedDeFiTransactionDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDeFiTransactionDto
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDeFiTransactionDto
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDeFiTransactionDto
     */
    'pageCurrent': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDeFiTransactionDto
     */
    'pagesTotal': number;
}
/**
 * 
 * @export
 * @interface PagedListOfCompletedDepositsWithdrawalsDto
 */
export interface PagedListOfCompletedDepositsWithdrawalsDto {
    /**
     * 
     * @type {Array<CompletedDepositsWithdrawalsDto>}
     * @memberof PagedListOfCompletedDepositsWithdrawalsDto
     */
    'items': Array<CompletedDepositsWithdrawalsDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDepositsWithdrawalsDto
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDepositsWithdrawalsDto
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDepositsWithdrawalsDto
     */
    'pageCurrent': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedDepositsWithdrawalsDto
     */
    'pagesTotal': number;
}
/**
 * 
 * @export
 * @interface PagedListOfCompletedTransactionHistoryDto
 */
export interface PagedListOfCompletedTransactionHistoryDto {
    /**
     * 
     * @type {Array<CompletedTransactionHistoryDto>}
     * @memberof PagedListOfCompletedTransactionHistoryDto
     */
    'items': Array<CompletedTransactionHistoryDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedTransactionHistoryDto
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedTransactionHistoryDto
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedTransactionHistoryDto
     */
    'pageCurrent': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfCompletedTransactionHistoryDto
     */
    'pagesTotal': number;
}
/**
 * 
 * @export
 * @interface PagedListOfDetailedRewardsHistoryItemDto
 */
export interface PagedListOfDetailedRewardsHistoryItemDto {
    /**
     * 
     * @type {Array<DetailedRewardsHistoryItemDto>}
     * @memberof PagedListOfDetailedRewardsHistoryItemDto
     */
    'items': Array<DetailedRewardsHistoryItemDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfDetailedRewardsHistoryItemDto
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfDetailedRewardsHistoryItemDto
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfDetailedRewardsHistoryItemDto
     */
    'pageCurrent': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfDetailedRewardsHistoryItemDto
     */
    'pagesTotal': number;
}
/**
 * 
 * @export
 * @interface PagedListOfPendingOrdersDto
 */
export interface PagedListOfPendingOrdersDto {
    /**
     * 
     * @type {Array<PendingOrdersDto>}
     * @memberof PagedListOfPendingOrdersDto
     */
    'items': Array<PendingOrdersDto>;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfPendingOrdersDto
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfPendingOrdersDto
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfPendingOrdersDto
     */
    'pageCurrent': number;
    /**
     * 
     * @type {number}
     * @memberof PagedListOfPendingOrdersDto
     */
    'pagesTotal': number;
}
/**
 * 
 * @export
 * @interface PendingCryptoWithdrawOrderDto
 */
export interface PendingCryptoWithdrawOrderDto {
    /**
     * 
     * @type {string}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'productCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'orderReference': string;
    /**
     * 
     * @type {string}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'orderId': string;
    /**
     * 
     * @type {number}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'orderAmount': number;
    /**
     * 
     * @type {number}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'orderAmountInDisplayCurrency': number;
    /**
     * 
     * @type {number}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'amountAvailable': number;
    /**
     * 
     * @type {string}
     * @memberof PendingCryptoWithdrawOrderDto
     */
    'address': string;
}
/**
 * 
 * @export
 * @interface PendingFiatDepositDetailsDto
 */
export interface PendingFiatDepositDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'depositType': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'paymentMethod': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'productCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatDepositDetailsDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'paymentReference': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'branchCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'companyCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'currencyCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'iban': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'sortCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'swiftCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'bankAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'bankAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'bankAddress3': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'bankPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'bankCountry': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'companyAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'companyAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'companyAddress3': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'companyPostalCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'companyCountry': string;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatDepositDetailsDto
     */
    'linkedAccountDepositFee': number;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatDepositDetailsDto
     */
    'linkedAccountDepositAmountAfterFees': number;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'linkedAccountFriendlyName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'linkedAccountAccountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'linkedAccountBank': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatDepositDetailsDto
     */
    'linkedAccountProviderCode': string;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatDepositDetailsDto
     */
    'quotedFee'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PendingFiatDepositDetailsDto
     */
    'isCancellable': boolean;
}
/**
 * 
 * @export
 * @interface PendingFiatWithdrawOrderDto
 */
export interface PendingFiatWithdrawOrderDto {
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'productCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'productName': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'orderReference': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'orderId': string;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'orderAmount': number;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'amountAvailable': number;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'bank': string;
    /**
     * 
     * @type {string}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'branchCode': string;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'fee': number;
    /**
     * 
     * @type {number}
     * @memberof PendingFiatWithdrawOrderDto
     */
    'amountReceived': number;
}
/**
 * 
 * @export
 * @interface PendingOrdersDto
 */
export interface PendingOrdersDto {
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'orderId': string;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'dateTime': string;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'orderType': PendingOrdersDtoOrderTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'orderTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'amountAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'amountAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'feesAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'feesAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'amountAfterFeesAsFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'amountAfterFeesAsFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof PendingOrdersDto
     */
    'currentPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof PendingOrdersDto
     */
    'popExistsForDeposit': boolean;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'symbol': string;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'customerFunctionalProduct': string;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'fromProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof PendingOrdersDto
     */
    'customerCompanyCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof PendingOrdersDto
     */
    'isCancellable': boolean;
}

export const PendingOrdersDtoOrderTypeEnum = {
    All: 'All',
    BankDeposit: 'BankDeposit',
    CryptoDeposit: 'CryptoDeposit',
    BankWithdrawal: 'BankWithdrawal',
    CryptoWithdrawal: 'CryptoWithdrawal',
    DeFiVaultLock: 'DeFiVaultLock',
    DeFiVaultUnlock: 'DeFiVaultUnlock',
    StitchDeposit: 'StitchDeposit'
} as const;

export type PendingOrdersDtoOrderTypeEnum = typeof PendingOrdersDtoOrderTypeEnum[keyof typeof PendingOrdersDtoOrderTypeEnum];

/**
 * 
 * @export
 * @interface PerformanceValueDto
 */
export interface PerformanceValueDto {
    /**
     * 
     * @type {number}
     * @memberof PerformanceValueDto
     */
    'timeStamp': number;
    /**
     * 
     * @type {string}
     * @memberof PerformanceValueDto
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof PerformanceValueDto
     */
    'value': number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceValueDto
     */
    'normalisedValue': number;
    /**
     * 
     * @type {number}
     * @memberof PerformanceValueDto
     */
    'change': number;
}
/**
 * 
 * @export
 * @interface PortfolioDurationTimespanDto
 */
export interface PortfolioDurationTimespanDto {
    /**
     * 
     * @type {number}
     * @memberof PortfolioDurationTimespanDto
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioDurationTimespanDto
     */
    'days': number;
    /**
     * 
     * @type {string}
     * @memberof PortfolioDurationTimespanDto
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PortfolioGainLossDebugDto
 */
export interface PortfolioGainLossDebugDto {
    /**
     * 
     * @type {{ [key: string]: Balance; }}
     * @memberof PortfolioGainLossDebugDto
     */
    'openingBalances'?: { [key: string]: Balance; } | null;
    /**
     * 
     * @type {{ [key: string]: Balance; }}
     * @memberof PortfolioGainLossDebugDto
     */
    'closingBalances': { [key: string]: Balance; };
}
/**
 * 
 * @export
 * @interface PortfolioGainLossDto
 */
export interface PortfolioGainLossDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioGainLossDto
     */
    'openingTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PortfolioGainLossDto
     */
    'gainPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioGainLossDto
     */
    'gainAmount': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioGainLossDto
     */
    'openingBalance': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioGainLossDto
     */
    'closingBalance': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioGainLossDto
     */
    'positiveCashFlow': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioGainLossDto
     */
    'negativeCashFlow': number;
    /**
     * 
     * @type {PortfolioGainLossDebugDto}
     * @memberof PortfolioGainLossDto
     */
    'debug': PortfolioGainLossDebugDto;
}
/**
 * 
 * @export
 * @interface PortfolioProductHoldingsDto
 */
export interface PortfolioProductHoldingsDto {
    /**
     * 
     * @type {string}
     * @memberof PortfolioProductHoldingsDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioProductHoldingsDto
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioProductHoldingsDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'units': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'displayUnits': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'gainLoss': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'gainLossValue': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'latestPrice': number;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioProductHoldingsDto
     */
    'canInvest': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioProductHoldingsDto
     */
    'canSell': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioProductHoldingsDto
     */
    'canDeposit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioProductHoldingsDto
     */
    'canWithdraw': boolean;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'reservedUnits': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'reservedUnitsAsDisplayProduct': number;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioProductHoldingsDto
     */
    'isStakable': boolean;
    /**
     * 
     * @type {number}
     * @memberof PortfolioProductHoldingsDto
     */
    'savingsPercentage'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PortfolioProductHoldingsDto
     */
    'migratedFrom': string;
    /**
     * 
     * @type {Array<ReservedDetails>}
     * @memberof PortfolioProductHoldingsDto
     */
    'reservedDetails': Array<ReservedDetails>;
}
/**
 * 
 * @export
 * @interface PortfolioSummaryDto
 */
export interface PortfolioSummaryDto {
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryDto
     */
    'portfolioValue': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryDto
     */
    'portfolioReturnValue': number;
    /**
     * 
     * @type {number}
     * @memberof PortfolioSummaryDto
     */
    'portfolioReturnPercentage': number;
}
/**
 * 
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'title'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProblemDetails
     */
    'status'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'detail'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProblemDetails
     */
    'instance'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductGraphDto
 */
export interface ProductGraphDto {
    /**
     * 
     * @type {number}
     * @memberof ProductGraphDto
     */
    'intervalMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof ProductGraphDto
     */
    'timeframeDays'?: number | null;
    /**
     * 
     * @type {Array<GraphPoint>}
     * @memberof ProductGraphDto
     */
    'graph': Array<GraphPoint>;
}
/**
 * 
 * @export
 * @interface ProductHoldings
 */
export interface ProductHoldings {
    /**
     * 
     * @type {GetProductsAndHoldingsQueryResponse}
     * @memberof ProductHoldings
     */
    'holdings': GetProductsAndHoldingsQueryResponse;
    /**
     * 
     * @type {Gains}
     * @memberof ProductHoldings
     */
    'gains': Gains;
    /**
     * 
     * @type {number}
     * @memberof ProductHoldings
     */
    'fiatValue'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductHoldings
     */
    'vaultGains'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductHoldings
     */
    'breakdownPercentage'?: number | null;
    /**
     * 
     * @type {Array<ReservedAmount>}
     * @memberof ProductHoldings
     */
    'reservedAmounts': Array<ReservedAmount>;
}
/**
 * 
 * @export
 * @interface ProductHoldingsGainsLosses
 */
export interface ProductHoldingsGainsLosses {
    /**
     * 
     * @type {string}
     * @memberof ProductHoldingsGainsLosses
     */
    'productCode': string;
    /**
     * 
     * @type {number}
     * @memberof ProductHoldingsGainsLosses
     */
    'gainPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof ProductHoldingsGainsLosses
     */
    'gainAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ProductHoldingsGainsLosses
     */
    'rate': number;
    /**
     * 
     * @type {string}
     * @memberof ProductHoldingsGainsLosses
     */
    'lastUpdated'?: string | null;
}
/**
 * 
 * @export
 * @interface ProductMetricsDto
 */
export interface ProductMetricsDto {
    /**
     * 
     * @type {string}
     * @memberof ProductMetricsDto
     */
    'productCode': string;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProductMetricsDto
     */
    'changePercentage': { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof ProductMetricsDto
     */
    'changeAmount': { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface ProductTransactablePairDto
 */
export interface ProductTransactablePairDto {
    /**
     * 
     * @type {string}
     * @memberof ProductTransactablePairDto
     */
    'fromProductCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductTransactablePairDto
     */
    'toProductCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductTransactablePairDto
     */
    'transactType': ProductTransactablePairDtoTransactTypeEnum;
}

export const ProductTransactablePairDtoTransactTypeEnum = {
    SellsTo: 'SellsTo',
    Buys: 'Buys'
} as const;

export type ProductTransactablePairDtoTransactTypeEnum = typeof ProductTransactablePairDtoTransactTypeEnum[keyof typeof ProductTransactablePairDtoTransactTypeEnum];

/**
 * 
 * @export
 * @interface ProductVaultDto
 */
export interface ProductVaultDto {
    /**
     * 
     * @type {string}
     * @memberof ProductVaultDto
     */
    'productCode': string;
    /**
     * 
     * @type {string}
     * @memberof ProductVaultDto
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof ProductVaultDto
     */
    'vaultValue': number;
    /**
     * 
     * @type {number}
     * @memberof ProductVaultDto
     */
    'apy': number;
    /**
     * 
     * @type {number}
     * @memberof ProductVaultDto
     */
    'gains': number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVaultDto
     */
    'pendingLock': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductVaultDto
     */
    'pendingUnlock': boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductVaultDto
     */
    'reservedAmount': number;
}
/**
 * 
 * @export
 * @interface ProductsGraphsDto
 */
export interface ProductsGraphsDto {
    /**
     * 
     * @type {number}
     * @memberof ProductsGraphsDto
     */
    'intervalMinutes': number;
    /**
     * 
     * @type {number}
     * @memberof ProductsGraphsDto
     */
    'timeframeDays'?: number | null;
    /**
     * 
     * @type {{ [key: string]: Array<GraphPoint>; }}
     * @memberof ProductsGraphsDto
     */
    'graphs': { [key: string]: Array<GraphPoint>; };
}
/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'msisdn'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'msisdnConfirmed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'emailConfirmed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'nationalId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'passport'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'countryCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'languageCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'companyCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'verificationStatus'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'statusCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'domain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'source'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'promoCode'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Profile
     */
    'twoFactorServices': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'bankAccountType': string;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'loginNotification'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'revixRoundUp'?: boolean | null;
    /**
     * 
     * @type {Array<LoginMethodDto>}
     * @memberof Profile
     */
    'loginMethods': Array<LoginMethodDto>;
    /**
     * 
     * @type {TotpStatusDto}
     * @memberof Profile
     */
    'twoFactorStatus': TotpStatusDto;
    /**
     * 
     * @type {Currency}
     * @memberof Profile
     */
    'baseCurrency': Currency;
    /**
     * 
     * @type {Currency}
     * @memberof Profile
     */
    'displayCurrency': Currency;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'termsAcceptedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'createdAt': string;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'minimumTradingAmount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'jurisdictionCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'journeyCompleted': boolean;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'depositState'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Profile
     */
    'investmentCompleted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'referralCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'currentRewardTierId': string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'currentRewardTierName': string;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'currentRewardTierStars': number;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'referrerRewardsPoints': number;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'refereeRewardAmountAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'refereeMinBuyAmountAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'rewardPointFunctionalRate': number;
}
/**
 * 
 * @export
 * @interface ProfileHearAboutDto
 */
export interface ProfileHearAboutDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileHearAboutDto
     */
    'hearAbout': string;
}
/**
 * 
 * @export
 * @interface ProfileStatusDto
 */
export interface ProfileStatusDto {
    /**
     * 
     * @type {Profile}
     * @memberof ProfileStatusDto
     */
    'profile': Profile;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileStatusDto
     */
    'registered': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileStatusDto
     */
    'emailVerified': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileStatusDto
     */
    'detailsCompleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileStatusDto
     */
    'termsAccepted': boolean;
    /**
     * 
     * @type {AccessTokenDto}
     * @memberof ProfileStatusDto
     */
    'accessToken': AccessTokenDto;
}
/**
 * 
 * @export
 * @interface ProfileUpdateDto
 */
export interface ProfileUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateDto
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateDto
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateDto
     */
    'nationalID': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateDto
     */
    'passport': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateDto
     */
    'dateOfBirth'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProfileUpdateDto
     */
    'countryCode': string;
}
/**
 * 
 * @export
 * @interface PromoCodeRequest
 */
export interface PromoCodeRequest {
    /**
     * 
     * @type {string}
     * @memberof PromoCodeRequest
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface PromoCodeResponse
 */
export interface PromoCodeResponse {
    /**
     * 
     * @type {boolean}
     * @memberof PromoCodeResponse
     */
    'valid'?: boolean | null;
}
/**
 * 
 * @export
 * @interface QuestionTemplate
 */
export interface QuestionTemplate {
    /**
     * 
     * @type {string}
     * @memberof QuestionTemplate
     */
    'type': string;
    /**
     * 
     * @type {string}
     * @memberof QuestionTemplate
     */
    'assetType'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof QuestionTemplate
     */
    'question': string;
    /**
     * 
     * @type {number}
     * @memberof QuestionTemplate
     */
    'order': number;
    /**
     * 
     * @type {boolean}
     * @memberof QuestionTemplate
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface RFQTradeQuoteDataDto
 */
export interface RFQTradeQuoteDataDto {
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteDataDto
     */
    'orderId': string;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'approximateBaseFeeInFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'baseFeeInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'discountPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'approximateFinalFeeInFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'finalFeeInFunctionalProduct': number;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteDataDto
     */
    'rewardTierCode': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteDataDto
     */
    'rewardTierName': string;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'fromAmount': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'fromAmountInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'approximateToAmount': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'toAmountInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteDataDto
     */
    'approximateFromToPrice': number;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteDataDto
     */
    'expiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteDataDto
     */
    'currentTime': string;
}
/**
 * 
 * @export
 * @interface RFQTradeQuoteSelectionDataDto
 */
export interface RFQTradeQuoteSelectionDataDto {
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'balanceInDisplayCurrency': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'balanceInUnits': number;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'fromProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'fromProductName': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'functionalProductSymbol': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'toProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'toProductName': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'toProductSymbol': string;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'approximateFunctionalToFromProductRate': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'approximateFromProductToToProductRate': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'maximumAmount'?: number | null;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof RFQTradeQuoteSelectionDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
}
/**
 * 
 * @export
 * @interface RFQTradeResultDto
 */
export interface RFQTradeResultDto {
    /**
     * 
     * @type {string}
     * @memberof RFQTradeResultDto
     */
    'orderId': string;
    /**
     * 
     * @type {SmartTradeResultV3Dto}
     * @memberof RFQTradeResultDto
     */
    'smartTradeResult': SmartTradeResultV3Dto;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'baseFeeInFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'baseFeeInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'discountPercentage': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'finalFeeInFromProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'finalFeeInFunctionalProduct': number;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeResultDto
     */
    'rewardTierCode': string;
    /**
     * 
     * @type {string}
     * @memberof RFQTradeResultDto
     */
    'rewardTierName': string;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'fromAmount': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'fromAmountInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'toAmount': number;
    /**
     * 
     * @type {number}
     * @memberof RFQTradeResultDto
     */
    'toAmountInFunctionalProduct': number;
}
/**
 * 
 * @export
 * @interface RebalanceBreakdown
 */
export interface RebalanceBreakdown {
    /**
     * 
     * @type {number}
     * @memberof RebalanceBreakdown
     */
    'units': number;
    /**
     * 
     * @type {number}
     * @memberof RebalanceBreakdown
     */
    'percentage': number;
}
/**
 * 
 * @export
 * @interface RebalanceBreakdownDto
 */
export interface RebalanceBreakdownDto {
    /**
     * 
     * @type {string}
     * @memberof RebalanceBreakdownDto
     */
    'assetCode': string;
    /**
     * 
     * @type {RebalanceBreakdown}
     * @memberof RebalanceBreakdownDto
     */
    'beforeRebalance': RebalanceBreakdown;
    /**
     * 
     * @type {number}
     * @memberof RebalanceBreakdownDto
     */
    'change': number;
    /**
     * 
     * @type {RebalanceBreakdown}
     * @memberof RebalanceBreakdownDto
     */
    'afterRebalance': RebalanceBreakdown;
}
/**
 * 
 * @export
 * @interface RecurringBuyCreateResponse
 */
export interface RecurringBuyCreateResponse {
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyCreateResponse
     */
    'recurringBuyId': string;
    /**
     * 
     * @type {number}
     * @memberof RecurringBuyCreateResponse
     */
    'amountPurchased'?: number | null;
}
/**
 * 
 * @export
 * @interface RecurringBuyResponse
 */
export interface RecurringBuyResponse {
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'recurringBuyId': string;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'productCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof RecurringBuyResponse
     */
    'paused': boolean;
    /**
     * 
     * @type {number}
     * @memberof RecurringBuyResponse
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'lastExecutionStatus'?: RecurringBuyResponseLastExecutionStatusEnum | null;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'lastExecutionTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'nextExecutionDate': string;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'interval': RecurringBuyResponseIntervalEnum;
    /**
     * 
     * @type {number}
     * @memberof RecurringBuyResponse
     */
    'dayOfMonth'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof RecurringBuyResponse
     */
    'dayOfWeek'?: RecurringBuyResponseDayOfWeekEnum | null;
    /**
     * 
     * @type {number}
     * @memberof RecurringBuyResponse
     */
    'successfulExecutions': number;
    /**
     * 
     * @type {number}
     * @memberof RecurringBuyResponse
     */
    'totalInvestedAmount': number;
}

export const RecurringBuyResponseLastExecutionStatusEnum = {
    Success: 'Success',
    InsufficientFunds: 'InsufficientFunds',
    UnknownError: 'UnknownError'
} as const;

export type RecurringBuyResponseLastExecutionStatusEnum = typeof RecurringBuyResponseLastExecutionStatusEnum[keyof typeof RecurringBuyResponseLastExecutionStatusEnum];
export const RecurringBuyResponseIntervalEnum = {
    Weekly: 'Weekly',
    Monthly: 'Monthly'
} as const;

export type RecurringBuyResponseIntervalEnum = typeof RecurringBuyResponseIntervalEnum[keyof typeof RecurringBuyResponseIntervalEnum];
export const RecurringBuyResponseDayOfWeekEnum = {
    Sunday: 'Sunday',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday'
} as const;

export type RecurringBuyResponseDayOfWeekEnum = typeof RecurringBuyResponseDayOfWeekEnum[keyof typeof RecurringBuyResponseDayOfWeekEnum];

/**
 * 
 * @export
 * @interface RedeemRewardsResponseDto
 */
export interface RedeemRewardsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RedeemRewardsResponseDto
     */
    'orderId': string;
    /**
     * 
     * @type {number}
     * @memberof RedeemRewardsResponseDto
     */
    'bitcoinAmountReceived': number;
    /**
     * 
     * @type {number}
     * @memberof RedeemRewardsResponseDto
     */
    'amountInDisplayCurrency': number;
}
/**
 * 
 * @export
 * @interface ReferralHistoryDto
 */
export interface ReferralHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralHistoryDto
     */
    'refereeCustomerId': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralHistoryDto
     */
    'refereeFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralHistoryDto
     */
    'refereeLastName': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralHistoryDto
     */
    'refereeFunctionalProductCode': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralHistoryDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralHistoryDto
     */
    'lastChangedAt': string;
    /**
     * 
     * @type {number}
     * @memberof ReferralHistoryDto
     */
    'minimumBuyAmount': number;
}
/**
 * 
 * @export
 * @interface ReferralsHistoryDto
 */
export interface ReferralsHistoryDto {
    /**
     * 
     * @type {string}
     * @memberof ReferralsHistoryDto
     */
    'customerId': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralsHistoryDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralsHistoryDto
     */
    'referralName': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralsHistoryDto
     */
    'statusName': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralsHistoryDto
     */
    'statusCode': string;
    /**
     * 
     * @type {string}
     * @memberof ReferralsHistoryDto
     */
    'minAmountSymbol': string;
    /**
     * 
     * @type {number}
     * @memberof ReferralsHistoryDto
     */
    'minAmount': number;
}
/**
 * 
 * @export
 * @interface ReferralsHistoryDtoPagedList
 */
export interface ReferralsHistoryDtoPagedList {
    /**
     * 
     * @type {Array<ReferralsHistoryDto>}
     * @memberof ReferralsHistoryDtoPagedList
     */
    'items': Array<ReferralsHistoryDto>;
    /**
     * 
     * @type {number}
     * @memberof ReferralsHistoryDtoPagedList
     */
    'itemsTotal': number;
    /**
     * 
     * @type {number}
     * @memberof ReferralsHistoryDtoPagedList
     */
    'itemsPerPage': number;
    /**
     * 
     * @type {number}
     * @memberof ReferralsHistoryDtoPagedList
     */
    'pageCurrent': number;
    /**
     * 
     * @type {number}
     * @memberof ReferralsHistoryDtoPagedList
     */
    'pagesTotal': number;
}
/**
 * 
 * @export
 * @interface RegisterRequestDto
 */
export interface RegisterRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestDto
     */
    'recaptcha'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestDto
     */
    'promoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterRequestDto
     */
    'languageCode'?: string | null;
}
/**
 * 
 * @export
 * @interface RegisterWithSsoRequestDto
 */
export interface RegisterWithSsoRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterWithSsoRequestDto
     */
    'clientApplicationSsoCode': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterWithSsoRequestDto
     */
    'ssoJwt': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterWithSsoRequestDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterWithSsoRequestDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterWithSsoRequestDto
     */
    'promoCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterWithSsoRequestDto
     */
    'languageCode'?: string | null;
}
/**
 * 
 * @export
 * @interface ReservedAmount
 */
export interface ReservedAmount {
    /**
     * 
     * @type {string}
     * @memberof ReservedAmount
     */
    'orderActionTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof ReservedAmount
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface ReservedDetails
 */
export interface ReservedDetails {
    /**
     * 
     * @type {string}
     * @memberof ReservedDetails
     */
    'orderActionTypeName': string;
    /**
     * 
     * @type {number}
     * @memberof ReservedDetails
     */
    'reservedAmount': number;
    /**
     * 
     * @type {number}
     * @memberof ReservedDetails
     */
    'reservedAmountAsDisplayProduct': number;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'credential': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'newPassword': string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    'totp': string;
}
/**
 * 
 * @export
 * @interface ResultDto
 */
export interface ResultDto {
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultDto
     */
    'success': boolean;
    /**
     * 
     * @type {string}
     * @memberof ResultDto
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface RewardActionSummaryDto
 */
export interface RewardActionSummaryDto {
    /**
     * 
     * @type {string}
     * @memberof RewardActionSummaryDto
     */
    'rewardAction': RewardActionSummaryDtoRewardActionEnum;
    /**
     * 
     * @type {number}
     * @memberof RewardActionSummaryDto
     */
    'rewardId': number;
    /**
     * 
     * @type {string}
     * @memberof RewardActionSummaryDto
     */
    'rewardActionName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof RewardActionSummaryDto
     */
    'pointsValue': number;
    /**
     * 
     * @type {number}
     * @memberof RewardActionSummaryDto
     */
    'maxApplications': number;
    /**
     * 
     * @type {number}
     * @memberof RewardActionSummaryDto
     */
    'applicationCount': number;
    /**
     * 
     * @type {number}
     * @memberof RewardActionSummaryDto
     */
    'totalAppliedPoints': number;
    /**
     * 
     * @type {boolean}
     * @memberof RewardActionSummaryDto
     */
    'active': boolean;
}

export const RewardActionSummaryDtoRewardActionEnum = {
    SignUp: 'SignUp',
    Verified: 'Verified',
    FirstInvestment: 'FirstInvestment',
    NextInvestment: 'NextInvestment',
    Referral: 'Referral',
    GoogleReview: 'GoogleReview',
    SurveyCompleted: 'SurveyCompleted',
    RedeemRewards: 'RedeemRewards',
    Other: 'Other',
    HiddenFirstInvestmentAction: 'HiddenFirstInvestmentAction',
    AutoBuy: 'AutoBuy',
    RecurringBuyQuiz: 'RecurringBuyQuiz'
} as const;

export type RewardActionSummaryDtoRewardActionEnum = typeof RewardActionSummaryDtoRewardActionEnum[keyof typeof RewardActionSummaryDtoRewardActionEnum];

/**
 * 
 * @export
 * @interface RewardGiftDto
 */
export interface RewardGiftDto {
    /**
     * 
     * @type {string}
     * @memberof RewardGiftDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RewardGiftDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface RewardTierDto
 */
export interface RewardTierDto {
    /**
     * 
     * @type {string}
     * @memberof RewardTierDto
     */
    'tierId': string;
    /**
     * 
     * @type {string}
     * @memberof RewardTierDto
     */
    'tierName': string;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDto
     */
    'stars': number;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDto
     */
    'requiredPoints': number;
    /**
     * 
     * @type {boolean}
     * @memberof RewardTierDto
     */
    'dedicatedAccountManager': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RewardTierDto
     * @deprecated
     */
    'isCurrent': boolean;
    /**
     * 
     * @type {Array<RewardGiftDto>}
     * @memberof RewardTierDto
     * @deprecated
     */
    'gifts': Array<RewardGiftDto>;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDto
     */
    'monthsFree': number;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDto
     */
    'percentOff': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof RewardTierDto
     */
    'benefits': Array<string>;
}
/**
 * 
 * @export
 * @interface RewardTierDtoOld
 */
export interface RewardTierDtoOld {
    /**
     * 
     * @type {string}
     * @memberof RewardTierDtoOld
     */
    'tierId': string;
    /**
     * 
     * @type {string}
     * @memberof RewardTierDtoOld
     */
    'tierName': string;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDtoOld
     */
    'requiredRewardsAmount': number;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDtoOld
     */
    'starsCount': number;
    /**
     * 
     * @type {number}
     * @memberof RewardTierDtoOld
     */
    'percentOff'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof RewardTierDtoOld
     */
    'benefits': Array<string>;
}
/**
 * 
 * @export
 * @interface RewardsDetailsDto
 */
export interface RewardsDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsDto
     */
    'rewardId': number;
    /**
     * 
     * @type {string}
     * @memberof RewardsDetailsDto
     */
    'rewardName': string;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsDto
     */
    'points': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsDto
     */
    'customersTotalPoints': number;
    /**
     * 
     * @type {boolean}
     * @memberof RewardsDetailsDto
     */
    'displayCount': boolean;
}
/**
 * 
 * @export
 * @interface RewardsDetailsQueryResponse
 */
export interface RewardsDetailsQueryResponse {
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'rewardPointsHoldings': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'lifetimeRewardsPoints': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'rewardPointFunctionalRate': number;
    /**
     * 
     * @type {string}
     * @memberof RewardsDetailsQueryResponse
     */
    'referralCode': string;
    /**
     * 
     * @type {string}
     * @memberof RewardsDetailsQueryResponse
     */
    'currentRewardTierId': string;
    /**
     * 
     * @type {string}
     * @memberof RewardsDetailsQueryResponse
     */
    'nextRewardTierId': string;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'minRewardPointsForRedemption': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'referrerRewardsPoints': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'refereeRewardAmountAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'refereeMinBuyAmountAsFunctional': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'totalRedeemedBtc': number;
    /**
     * 
     * @type {number}
     * @memberof RewardsDetailsQueryResponse
     */
    'referralCount': number;
}
/**
 * 
 * @export
 * @interface SaBankAccountDto
 */
export interface SaBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof SaBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof SaBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SaBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof SaBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof SaBankAccountDto
     */
    'branchCode': string;
    /**
     * 
     * @type {Array<BankCountryDto>}
     * @memberof SaBankAccountDto
     */
    'countries': Array<BankCountryDto>;
}
/**
 * 
 * @export
 * @interface SaveTaxDataAddressRequest
 */
export interface SaveTaxDataAddressRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataAddressRequest
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataAddressRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataAddressRequest
     */
    'postCode': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataAddressRequest
     */
    'addressLine2'?: string | null;
}
/**
 * 
 * @export
 * @interface SaveTaxDataRequest
 */
export interface SaveTaxDataRequest {
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'countryOfResidence': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'addressLine1': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'postCode': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'countryOfTaxResidence': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'taxIdentificationNumber': string;
    /**
     * 
     * @type {string}
     * @memberof SaveTaxDataRequest
     */
    'addressLine2'?: string | null;
}
/**
 * 
 * @export
 * @interface SmartTradeResultV3Dto
 */
export interface SmartTradeResultV3Dto {
    /**
     * 
     * @type {number}
     * @memberof SmartTradeResultV3Dto
     */
    'estimatePrice': number;
    /**
     * 
     * @type {number}
     * @memberof SmartTradeResultV3Dto
     */
    'actualPrice': number;
    /**
     * 
     * @type {number}
     * @memberof SmartTradeResultV3Dto
     */
    'savingsAsPercentage': number;
}
/**
 * 
 * @export
 * @interface StablecoinAutoConversion
 */
export interface StablecoinAutoConversion {
    /**
     * 
     * @type {string}
     * @memberof StablecoinAutoConversion
     */
    'targetConversionCode': string;
    /**
     * 
     * @type {string}
     * @memberof StablecoinAutoConversion
     */
    'targetConversionName': string;
    /**
     * 
     * @type {boolean}
     * @memberof StablecoinAutoConversion
     */
    'showConversionNotice': boolean;
}
/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'code': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Tag
     */
    'displayNames': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Tag
     */
    'colors': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface TagColor
 */
export interface TagColor {
    /**
     * 
     * @type {string}
     * @memberof TagColor
     */
    'backgroundStart': string;
    /**
     * 
     * @type {string}
     * @memberof TagColor
     */
    'backgroundEnd': string;
    /**
     * 
     * @type {string}
     * @memberof TagColor
     */
    'text': string;
}
/**
 * 
 * @export
 * @interface TagDto
 */
export interface TagDto {
    /**
     * 
     * @type {string}
     * @memberof TagDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof TagDto
     */
    'displayName': string;
    /**
     * 
     * @type {TagColor}
     * @memberof TagDto
     */
    'colors': TagColor;
}
/**
 * 
 * @export
 * @interface TotpActivateRequest
 */
export interface TotpActivateRequest {
    /**
     * 
     * @type {string}
     * @memberof TotpActivateRequest
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TotpActivateRequest
     */
    'idNumber': string;
    /**
     * 
     * @type {string}
     * @memberof TotpActivateRequest
     */
    'totp': string;
}
/**
 * 
 * @export
 * @interface TotpDisableRequest
 */
export interface TotpDisableRequest {
    /**
     * 
     * @type {string}
     * @memberof TotpDisableRequest
     */
    'password'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TotpDisableRequest
     */
    'totp': string;
}
/**
 * 
 * @export
 * @interface TotpStatusDto
 */
export interface TotpStatusDto {
    /**
     * 
     * @type {string}
     * @memberof TotpStatusDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TotpStatusDto
     */
    'userId'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TotpStatusDto
     */
    'registered'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TotpStatusDto
     */
    'activated'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof TotpStatusDto
     */
    'locked'?: boolean | null;
}
/**
 * 
 * @export
 * @interface TradeIntentRequestDto
 */
export interface TradeIntentRequestDto {
    /**
     * 
     * @type {string}
     * @memberof TradeIntentRequestDto
     */
    'question': string;
}
/**
 * 
 * @export
 * @interface TradeIntentResultDto
 */
export interface TradeIntentResultDto {
    /**
     * 
     * @type {string}
     * @memberof TradeIntentResultDto
     */
    'action'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TradeIntentResultDto
     */
    'targetProductCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TradeIntentResultDto
     */
    'sourceProductCode'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TradeIntentResultDto
     */
    'amount'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TradeIntentResultDto
     */
    'amountSide'?: string | null;
}
/**
 * 
 * @export
 * @interface TradeProductDto
 */
export interface TradeProductDto {
    /**
     * 
     * @type {string}
     * @memberof TradeProductDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TradeProductDto
     */
    'ticker': string;
    /**
     * 
     * @type {string}
     * @memberof TradeProductDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof TradeProductDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof TradeProductDto
     */
    'balanceFiat': number;
    /**
     * 
     * @type {number}
     * @memberof TradeProductDto
     */
    'balance': number;
}
/**
 * 
 * @export
 * @interface TransactionAdjustmentDetailsDto
 */
export interface TransactionAdjustmentDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'balanceBefore': number;
    /**
     * 
     * @type {number}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'balanceBeforeInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'amount': number;
    /**
     * 
     * @type {number}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'amountInFunctionalProduct': number;
    /**
     * 
     * @type {number}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'balanceAfter': number;
    /**
     * 
     * @type {number}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'balanceAfterInFunctionalProduct': number;
    /**
     * 
     * @type {string}
     * @memberof TransactionAdjustmentDetailsDto
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface TwoFactorLoginRequest
 */
export interface TwoFactorLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof TwoFactorLoginRequest
     */
    'pin'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TwoFactorLoginRequest
     */
    'token'?: string | null;
}
/**
 * 
 * @export
 * @interface UkBankAccountDto
 */
export interface UkBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof UkBankAccountDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UkBankAccountDto
     */
    'countryCode': string;
    /**
     * 
     * @type {string}
     * @memberof UkBankAccountDto
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof UkBankAccountDto
     */
    'bankName': string;
    /**
     * 
     * @type {string}
     * @memberof UkBankAccountDto
     */
    'accountType': string;
    /**
     * 
     * @type {string}
     * @memberof UkBankAccountDto
     */
    'sortCode': string;
    /**
     * 
     * @type {Array<BankCountryDto>}
     * @memberof UkBankAccountDto
     */
    'countries': Array<BankCountryDto>;
}
/**
 * 
 * @export
 * @interface UsdFiatWithdrawProductDataDto
 */
export interface UsdFiatWithdrawProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof UsdFiatWithdrawProductDataDto
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof UsdFiatWithdrawProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof UsdFiatWithdrawProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof UsdFiatWithdrawProductDataDto
     */
    'fees': Array<FeeStructureDto>;
    /**
     * 
     * @type {IntBankAccountDto}
     * @memberof UsdFiatWithdrawProductDataDto
     */
    'bankAccount': IntBankAccountDto;
}
/**
 * 
 * @export
 * @interface UserTermDto
 */
export interface UserTermDto {
    /**
     * 
     * @type {string}
     * @memberof UserTermDto
     */
    'code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTermDto
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTermDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserTermDto
     */
    'oneLineDescription'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTermDto
     */
    'showOnRegistration'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTermDto
     */
    'mandatory'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof UserTermDto
     */
    'priority'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserTermDto
     */
    'accepted'?: boolean | null;
}
/**
 * 
 * @export
 * @interface VaspDto
 */
export interface VaspDto {
    /**
     * 
     * @type {string}
     * @memberof VaspDto
     */
    'id'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VaspDto
     */
    'name'?: string | null;
}
/**
 * 
 * @export
 * @interface VerificationActionOption
 */
export interface VerificationActionOption {
    /**
     * 
     * @type {string}
     * @memberof VerificationActionOption
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationActionOption
     */
    'value': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationActionOption
     */
    'display': string;
    /**
     * 
     * @type {number}
     * @memberof VerificationActionOption
     */
    'points'?: number | null;
}
/**
 * 
 * @export
 * @interface VerificationLevel
 */
export interface VerificationLevel {
    /**
     * 
     * @type {string}
     * @memberof VerificationLevel
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationLevel
     */
    'extendsLevelCode': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationLevel
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationLevel
     */
    'active'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationLevel
     */
    'createdAt'?: string | null;
}
/**
 * 
 * @export
 * @interface VerificationTier
 */
export interface VerificationTier {
    /**
     * 
     * @type {string}
     * @memberof VerificationTier
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationTier
     */
    'verificationLevelCode': string;
    /**
     * 
     * @type {string}
     * @memberof VerificationTier
     */
    'countryCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationTier
     */
    'active'?: boolean | null;
}
/**
 * 
 * @export
 * @interface VerificationTierStatus
 */
export interface VerificationTierStatus {
    /**
     * 
     * @type {string}
     * @memberof VerificationTierStatus
     */
    'userId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerificationTierStatus
     */
    'countryCode': string;
    /**
     * 
     * @type {VerificationTier}
     * @memberof VerificationTierStatus
     */
    'tier': VerificationTier;
    /**
     * 
     * @type {VerificationLevel}
     * @memberof VerificationTierStatus
     */
    'requiredLevel': VerificationLevel;
    /**
     * 
     * @type {Array<VerificationLevel>}
     * @memberof VerificationTierStatus
     */
    'dependentLevels': Array<VerificationLevel>;
    /**
     * 
     * @type {Array<VerifyActionStatusDto>}
     * @memberof VerificationTierStatus
     */
    'actions': Array<VerifyActionStatusDto>;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationTierStatus
     */
    'started': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationTierStatus
     */
    'completed': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VerificationTierStatus
     */
    'active': boolean;
}
/**
 * 
 * @export
 * @interface VerifyActionStatusDto
 */
export interface VerifyActionStatusDto {
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'actionCode': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'userMessage': string;
    /**
     * 
     * @type {Array<VerificationActionOption>}
     * @memberof VerifyActionStatusDto
     */
    'userOptions': Array<VerificationActionOption>;
    /**
     * 
     * @type {number}
     * @memberof VerifyActionStatusDto
     */
    'points'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'providerActionCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyActionStatusDto
     */
    'requiredSubmissionFields': Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof VerifyActionStatusDto
     */
    'completedSubmissionFields': { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof VerifyActionStatusDto
     */
    'requiredVerificationFields': Array<string>;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof VerifyActionStatusDto
     */
    'completedValidationFields': { [key: string]: string; };
    /**
     * 
     * @type {boolean}
     * @memberof VerifyActionStatusDto
     */
    'manualVerification'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyActionStatusDto
     */
    'attachmentRequired'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'attachmentName': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'statusCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyActionStatusDto
     */
    'completed'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'completedAt'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyActionStatusDto
     */
    'approved'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'approvedBy'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyActionStatusDto
     */
    'rejected'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'rejectedReason': string;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'rejectedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyActionStatusDto
     */
    'startedAt'?: string | null;
}
/**
 * 
 * @export
 * @interface WalletDto
 */
export interface WalletDto {
    /**
     * 
     * @type {string}
     * @memberof WalletDto
     */
    'accountId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WalletDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WalletDto
     */
    'address': string;
    /**
     * 
     * @type {string}
     * @memberof WalletDto
     */
    'productCode': string;
    /**
     * 
     * @type {boolean}
     * @memberof WalletDto
     */
    'isHosted'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof WalletDto
     */
    'institutionId'?: string | null;
}
/**
 * 
 * @export
 * @interface WithdrawDetailsDto
 */
export interface WithdrawDetailsDto {
    /**
     * 
     * @type {number}
     * @memberof WithdrawDetailsDto
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof WithdrawDetailsDto
     */
    'reference': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawDetailsDto
     */
    'date': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawDetailsDto
     */
    'time': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawDetailsDto
     */
    'recipient': string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawDetailsDto
     */
    'fee': number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawDetailsDto
     */
    'amountReceived': number;
}
/**
 * 
 * @export
 * @interface WithdrawProductDto
 */
export interface WithdrawProductDto {
    /**
     * 
     * @type {string}
     * @memberof WithdrawProductDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawProductDto
     */
    'ticker': string;
    /**
     * 
     * @type {string}
     * @memberof WithdrawProductDto
     */
    'code': string;
    /**
     * 
     * @type {number}
     * @memberof WithdrawProductDto
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof WithdrawProductDto
     */
    'balanceCustomerFiat'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof WithdrawProductDto
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ZarFiatWithdrawProductDataDto
 */
export interface ZarFiatWithdrawProductDataDto {
    /**
     * 
     * @type {number}
     * @memberof ZarFiatWithdrawProductDataDto
     */
    'balance': number;
    /**
     * 
     * @type {number}
     * @memberof ZarFiatWithdrawProductDataDto
     */
    'minimumAmount': number;
    /**
     * 
     * @type {Array<AmountBlockDto>}
     * @memberof ZarFiatWithdrawProductDataDto
     */
    'amountBlocks': Array<AmountBlockDto>;
    /**
     * 
     * @type {Array<FeeStructureDto>}
     * @memberof ZarFiatWithdrawProductDataDto
     */
    'fees': Array<FeeStructureDto>;
    /**
     * 
     * @type {SaBankAccountDto}
     * @memberof ZarFiatWithdrawProductDataDto
     */
    'bankAccount': SaBankAccountDto;
}

/**
 * AskApi - axios parameter creator
 * @export
 */
export const AskApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AskConversationRequestDto} [askConversationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askConversation: async (askConversationRequestDto?: AskConversationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ask/conversation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(askConversationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askExplore: async (askRequestDto?: AskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ask/explore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(askRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askPortfolio: async (askRequestDto?: AskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ask/portfolio`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(askRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askProduct: async (askRequestDto?: AskRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ask/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(askRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TradeIntentRequestDto} [tradeIntentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askTradeIntent: async (tradeIntentRequestDto?: TradeIntentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/ask/trade-intent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tradeIntentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AskApi - functional programming interface
 * @export
 */
export const AskApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AskApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AskConversationRequestDto} [askConversationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askConversation(askConversationRequestDto?: AskConversationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AskConversationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askConversation(askConversationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskApi.askConversation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askExplore(askRequestDto?: AskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AskResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askExplore(askRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskApi.askExplore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askPortfolio(askRequestDto?: AskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AskResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askPortfolio(askRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskApi.askPortfolio']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askProduct(askRequestDto?: AskRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AskResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askProduct(askRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskApi.askProduct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TradeIntentRequestDto} [tradeIntentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async askTradeIntent(tradeIntentRequestDto?: TradeIntentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TradeIntentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.askTradeIntent(tradeIntentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AskApi.askTradeIntent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AskApi - factory interface
 * @export
 */
export const AskApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AskApiFp(configuration)
    return {
        /**
         * 
         * @param {AskConversationRequestDto} [askConversationRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askConversation(askConversationRequestDto?: AskConversationRequestDto, options?: any): AxiosPromise<AskConversationResponseDto> {
            return localVarFp.askConversation(askConversationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askExplore(askRequestDto?: AskRequestDto, options?: any): AxiosPromise<AskResponseDto> {
            return localVarFp.askExplore(askRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askPortfolio(askRequestDto?: AskRequestDto, options?: any): AxiosPromise<AskResponseDto> {
            return localVarFp.askPortfolio(askRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AskRequestDto} [askRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askProduct(askRequestDto?: AskRequestDto, options?: any): AxiosPromise<AskResponseDto> {
            return localVarFp.askProduct(askRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TradeIntentRequestDto} [tradeIntentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        askTradeIntent(tradeIntentRequestDto?: TradeIntentRequestDto, options?: any): AxiosPromise<TradeIntentResultDto> {
            return localVarFp.askTradeIntent(tradeIntentRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AskApi - object-oriented interface
 * @export
 * @class AskApi
 * @extends {BaseAPI}
 */
export class AskApi extends BaseAPI {
    /**
     * 
     * @param {AskConversationRequestDto} [askConversationRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskApi
     */
    public askConversation(askConversationRequestDto?: AskConversationRequestDto, options?: RawAxiosRequestConfig) {
        return AskApiFp(this.configuration).askConversation(askConversationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AskRequestDto} [askRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskApi
     */
    public askExplore(askRequestDto?: AskRequestDto, options?: RawAxiosRequestConfig) {
        return AskApiFp(this.configuration).askExplore(askRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AskRequestDto} [askRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskApi
     */
    public askPortfolio(askRequestDto?: AskRequestDto, options?: RawAxiosRequestConfig) {
        return AskApiFp(this.configuration).askPortfolio(askRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AskRequestDto} [askRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskApi
     */
    public askProduct(askRequestDto?: AskRequestDto, options?: RawAxiosRequestConfig) {
        return AskApiFp(this.configuration).askProduct(askRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TradeIntentRequestDto} [tradeIntentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AskApi
     */
    public askTradeIntent(tradeIntentRequestDto?: TradeIntentRequestDto, options?: RawAxiosRequestConfig) {
        return AskApiFp(this.configuration).askTradeIntent(tradeIntentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientIP: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/user-ip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login: async (loginRequest?: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginWithSsoRequest} [loginWithSsoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithProvider: async (loginWithSsoRequest?: LoginWithSsoRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/loginWithProvider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithSsoRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/refreshToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TwoFactorLoginRequest} [twoFactorLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorLogin: async (twoFactorLoginRequest?: TwoFactorLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/twoFactorLogin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(twoFactorLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [dateOfBirth] 
         * @param {string} [phoneNumber] 
         * @param {string} [firstDepositDate] 
         * @param {number} [balance] 
         * @param {File} [idDocument] 
         * @param {File} [selfieDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorReset: async (firstName?: string, lastName?: string, dateOfBirth?: string, phoneNumber?: string, firstDepositDate?: string, balance?: number, idDocument?: File, selfieDocument?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/authentication/twoFactorReset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (firstName !== undefined) { 
                localVarFormParams.append('FirstName', firstName as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.append('LastName', lastName as any);
            }
    
            if (dateOfBirth !== undefined) { 
                localVarFormParams.append('DateOfBirth', dateOfBirth as any);
            }
    
            if (phoneNumber !== undefined) { 
                localVarFormParams.append('PhoneNumber', phoneNumber as any);
            }
    
            if (firstDepositDate !== undefined) { 
                localVarFormParams.append('FirstDepositDate', firstDepositDate as any);
            }
    
            if (balance !== undefined) { 
                localVarFormParams.append('Balance', balance as any);
            }
    
            if (idDocument !== undefined) { 
                localVarFormParams.append('IdDocument', idDocument as any);
            }
    
            if (selfieDocument !== undefined) { 
                localVarFormParams.append('SelfieDocument', selfieDocument as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientIP(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientIP(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.getClientIP']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async login(loginRequest?: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.login(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.login']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LoginWithSsoRequest} [loginWithSsoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithProvider(loginWithSsoRequest?: LoginWithSsoRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithProvider(loginWithSsoRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.loginWithProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refreshToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refreshToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.refreshToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TwoFactorLoginRequest} [twoFactorLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorLogin(twoFactorLoginRequest?: TwoFactorLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorLogin(twoFactorLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.twoFactorLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [dateOfBirth] 
         * @param {string} [phoneNumber] 
         * @param {string} [firstDepositDate] 
         * @param {number} [balance] 
         * @param {File} [idDocument] 
         * @param {File} [selfieDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async twoFactorReset(firstName?: string, lastName?: string, dateOfBirth?: string, phoneNumber?: string, firstDepositDate?: string, balance?: number, idDocument?: File, selfieDocument?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.twoFactorReset(firstName, lastName, dateOfBirth, phoneNumber, firstDepositDate, balance, idDocument, selfieDocument, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthenticationApi.twoFactorReset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientIP(options?: any): AxiosPromise<void> {
            return localVarFp.getClientIP(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginRequest} [loginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        login(loginRequest?: LoginRequest, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.login(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginWithSsoRequest} [loginWithSsoRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithProvider(loginWithSsoRequest?: LoginWithSsoRequest, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.loginWithProvider(loginWithSsoRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshToken(options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.refreshToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TwoFactorLoginRequest} [twoFactorLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorLogin(twoFactorLoginRequest?: TwoFactorLoginRequest, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.twoFactorLogin(twoFactorLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [dateOfBirth] 
         * @param {string} [phoneNumber] 
         * @param {string} [firstDepositDate] 
         * @param {number} [balance] 
         * @param {File} [idDocument] 
         * @param {File} [selfieDocument] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        twoFactorReset(firstName?: string, lastName?: string, dateOfBirth?: string, phoneNumber?: string, firstDepositDate?: string, balance?: number, idDocument?: File, selfieDocument?: File, options?: any): AxiosPromise<void> {
            return localVarFp.twoFactorReset(firstName, lastName, dateOfBirth, phoneNumber, firstDepositDate, balance, idDocument, selfieDocument, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public getClientIP(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).getClientIP(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginRequest} [loginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public login(loginRequest?: LoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).login(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginWithSsoRequest} [loginWithSsoRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithProvider(loginWithSsoRequest?: LoginWithSsoRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithProvider(loginWithSsoRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public refreshToken(options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).refreshToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TwoFactorLoginRequest} [twoFactorLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public twoFactorLogin(twoFactorLoginRequest?: TwoFactorLoginRequest, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).twoFactorLogin(twoFactorLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [dateOfBirth] 
     * @param {string} [phoneNumber] 
     * @param {string} [firstDepositDate] 
     * @param {number} [balance] 
     * @param {File} [idDocument] 
     * @param {File} [selfieDocument] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public twoFactorReset(firstName?: string, lastName?: string, dateOfBirth?: string, phoneNumber?: string, firstDepositDate?: string, balance?: number, idDocument?: File, selfieDocument?: File, options?: RawAxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).twoFactorReset(firstName, lastName, dateOfBirth, phoneNumber, firstDepositDate, balance, idDocument, selfieDocument, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BuyApi - axios parameter creator
 * @export
 */
export const BuyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all products that can buy the selected product
         * @param {string} targetProductCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts: async (targetProductCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'targetProductCode' is not null or undefined
            assertParamExists('availableProducts', 'targetProductCode', targetProductCode)
            const localVarPath = `/buy/{targetProductCode}/products`
                .replace(`{${"targetProductCode"}}`, encodeURIComponent(String(targetProductCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a pending buy trade order
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buy/quote/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm and complete the buy using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buy/quote/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get buy quote data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyQuote: async (fromProductCode?: string, toProductCode?: string, amount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buy/quote/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromProductCode !== undefined) {
                localVarQueryParameter['fromProductCode'] = fromProductCode;
            }

            if (toProductCode !== undefined) {
                localVarQueryParameter['toProductCode'] = toProductCode;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get buy quote selection data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyQuoteData: async (fromProductCode?: string, toProductCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buy/quote/selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromProductCode !== undefined) {
                localVarQueryParameter['fromProductCode'] = fromProductCode;
            }

            if (toProductCode !== undefined) {
                localVarQueryParameter['toProductCode'] = toProductCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh the buy quote using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/buy/quote/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyApi - functional programming interface
 * @export
 */
export const BuyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all products that can buy the selected product
         * @param {string} targetProductCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableProducts(targetProductCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TradeProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableProducts(targetProductCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyApi.availableProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a pending buy trade order
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm and complete the buy using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complete(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complete(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyApi.complete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get buy quote data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyQuote(fromProductCode?: string, toProductCode?: string, amount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeQuoteDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyQuote(fromProductCode, toProductCode, amount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyApi.getBuyQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get buy quote selection data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBuyQuoteData(fromProductCode?: string, toProductCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeQuoteSelectionDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBuyQuoteData(fromProductCode, toProductCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyApi.getBuyQuoteData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh the buy quote using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeQuoteDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BuyApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BuyApi - factory interface
 * @export
 */
export const BuyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all products that can buy the selected product
         * @param {string} targetProductCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts(targetProductCode: string, options?: any): AxiosPromise<Array<TradeProductDto>> {
            return localVarFp.availableProducts(targetProductCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a pending buy trade order
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(orderId?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm and complete the buy using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(orderId?: string, options?: any): AxiosPromise<RFQTradeResultDto> {
            return localVarFp.complete(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get buy quote data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyQuote(fromProductCode?: string, toProductCode?: string, amount?: number, options?: any): AxiosPromise<RFQTradeQuoteDataDto> {
            return localVarFp.getBuyQuote(fromProductCode, toProductCode, amount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get buy quote selection data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBuyQuoteData(fromProductCode?: string, toProductCode?: string, options?: any): AxiosPromise<RFQTradeQuoteSelectionDataDto> {
            return localVarFp.getBuyQuoteData(fromProductCode, toProductCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh the buy quote using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(orderId?: string, options?: any): AxiosPromise<RFQTradeQuoteDataDto> {
            return localVarFp.refresh(orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyApi - object-oriented interface
 * @export
 * @class BuyApi
 * @extends {BaseAPI}
 */
export class BuyApi extends BaseAPI {
    /**
     * 
     * @summary Get all products that can buy the selected product
     * @param {string} targetProductCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyApi
     */
    public availableProducts(targetProductCode: string, options?: RawAxiosRequestConfig) {
        return BuyApiFp(this.configuration).availableProducts(targetProductCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a pending buy trade order
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyApi
     */
    public cancel(orderId?: string, options?: RawAxiosRequestConfig) {
        return BuyApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm and complete the buy using the order id
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyApi
     */
    public complete(orderId?: string, options?: RawAxiosRequestConfig) {
        return BuyApiFp(this.configuration).complete(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get buy quote data
     * @param {string} [fromProductCode] 
     * @param {string} [toProductCode] 
     * @param {number} [amount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyApi
     */
    public getBuyQuote(fromProductCode?: string, toProductCode?: string, amount?: number, options?: RawAxiosRequestConfig) {
        return BuyApiFp(this.configuration).getBuyQuote(fromProductCode, toProductCode, amount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get buy quote selection data
     * @param {string} [fromProductCode] 
     * @param {string} [toProductCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyApi
     */
    public getBuyQuoteData(fromProductCode?: string, toProductCode?: string, options?: RawAxiosRequestConfig) {
        return BuyApiFp(this.configuration).getBuyQuoteData(fromProductCode, toProductCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh the buy quote using the order id
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyApi
     */
    public refresh(orderId?: string, options?: RawAxiosRequestConfig) {
        return BuyApiFp(this.configuration).refresh(orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContactApi - axios parameter creator
 * @export
 */
export const ContactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [productName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStockToLead: async (productName?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksFromLead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/stocks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [radioService] 
         * @param {Array<string>} [assets] 
         * @param {string} [otherAsset] 
         * @param {string} [transactionValue] 
         * @param {string} [radioContact] 
         * @param {string} [recaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateClient: async (firstName?: string, lastName?: string, email?: string, phone?: string, radioService?: string, assets?: Array<string>, otherAsset?: string, transactionValue?: string, radioContact?: string, recaptchaResponse?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/privateClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (firstName !== undefined) { 
                localVarFormParams.append('firstName', firstName as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.append('lastName', lastName as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.append('email', email as any);
            }
    
            if (phone !== undefined) { 
                localVarFormParams.append('phone', phone as any);
            }
    
            if (radioService !== undefined) { 
                localVarFormParams.append('radioService', radioService as any);
            }
                if (assets) {
                assets.forEach((element) => {
                    localVarFormParams.append('assets', element as any);
                })
            }

    
            if (otherAsset !== undefined) { 
                localVarFormParams.append('otherAsset', otherAsset as any);
            }
    
            if (transactionValue !== undefined) { 
                localVarFormParams.append('transactionValue', transactionValue as any);
            }
    
            if (radioContact !== undefined) { 
                localVarFormParams.append('radioContact', radioContact as any);
            }
    
            if (recaptchaResponse !== undefined) { 
                localVarFormParams.append('recaptchaResponse', recaptchaResponse as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [radioTax] 
         * @param {string} [specifyCryptoPlatform] 
         * @param {string} [transactionsCount] 
         * @param {string} [recaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tax: async (firstName?: string, lastName?: string, email?: string, phone?: string, radioTax?: string, specifyCryptoPlatform?: string, transactionsCount?: string, recaptchaResponse?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/contact/tax`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (firstName !== undefined) { 
                localVarFormParams.append('firstName', firstName as any);
            }
    
            if (lastName !== undefined) { 
                localVarFormParams.append('lastName', lastName as any);
            }
    
            if (email !== undefined) { 
                localVarFormParams.append('email', email as any);
            }
    
            if (phone !== undefined) { 
                localVarFormParams.append('phone', phone as any);
            }
    
            if (radioTax !== undefined) { 
                localVarFormParams.append('radioTax', radioTax as any);
            }
    
            if (specifyCryptoPlatform !== undefined) { 
                localVarFormParams.append('specifyCryptoPlatform', specifyCryptoPlatform as any);
            }
    
            if (transactionsCount !== undefined) { 
                localVarFormParams.append('transactionsCount', transactionsCount as any);
            }
    
            if (recaptchaResponse !== undefined) { 
                localVarFormParams.append('recaptchaResponse', recaptchaResponse as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContactApi - functional programming interface
 * @export
 */
export const ContactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContactApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [productName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addStockToLead(productName?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addStockToLead(productName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.addStockToLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStocksFromLead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStocksFromLead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.getStocksFromLead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [radioService] 
         * @param {Array<string>} [assets] 
         * @param {string} [otherAsset] 
         * @param {string} [transactionValue] 
         * @param {string} [radioContact] 
         * @param {string} [recaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async privateClient(firstName?: string, lastName?: string, email?: string, phone?: string, radioService?: string, assets?: Array<string>, otherAsset?: string, transactionValue?: string, radioContact?: string, recaptchaResponse?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.privateClient(firstName, lastName, email, phone, radioService, assets, otherAsset, transactionValue, radioContact, recaptchaResponse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.privateClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [radioTax] 
         * @param {string} [specifyCryptoPlatform] 
         * @param {string} [transactionsCount] 
         * @param {string} [recaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tax(firstName?: string, lastName?: string, email?: string, phone?: string, radioTax?: string, specifyCryptoPlatform?: string, transactionsCount?: string, recaptchaResponse?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tax(firstName, lastName, email, phone, radioTax, specifyCryptoPlatform, transactionsCount, recaptchaResponse, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContactApi.tax']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContactApi - factory interface
 * @export
 */
export const ContactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContactApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [productName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addStockToLead(productName?: string, options?: any): AxiosPromise<void> {
            return localVarFp.addStockToLead(productName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStocksFromLead(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getStocksFromLead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [radioService] 
         * @param {Array<string>} [assets] 
         * @param {string} [otherAsset] 
         * @param {string} [transactionValue] 
         * @param {string} [radioContact] 
         * @param {string} [recaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        privateClient(firstName?: string, lastName?: string, email?: string, phone?: string, radioService?: string, assets?: Array<string>, otherAsset?: string, transactionValue?: string, radioContact?: string, recaptchaResponse?: string, options?: any): AxiosPromise<void> {
            return localVarFp.privateClient(firstName, lastName, email, phone, radioService, assets, otherAsset, transactionValue, radioContact, recaptchaResponse, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [firstName] 
         * @param {string} [lastName] 
         * @param {string} [email] 
         * @param {string} [phone] 
         * @param {string} [radioTax] 
         * @param {string} [specifyCryptoPlatform] 
         * @param {string} [transactionsCount] 
         * @param {string} [recaptchaResponse] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tax(firstName?: string, lastName?: string, email?: string, phone?: string, radioTax?: string, specifyCryptoPlatform?: string, transactionsCount?: string, recaptchaResponse?: string, options?: any): AxiosPromise<void> {
            return localVarFp.tax(firstName, lastName, email, phone, radioTax, specifyCryptoPlatform, transactionsCount, recaptchaResponse, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContactApi - object-oriented interface
 * @export
 * @class ContactApi
 * @extends {BaseAPI}
 */
export class ContactApi extends BaseAPI {
    /**
     * 
     * @param {string} [productName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public addStockToLead(productName?: string, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).addStockToLead(productName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public getStocksFromLead(options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).getStocksFromLead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [email] 
     * @param {string} [phone] 
     * @param {string} [radioService] 
     * @param {Array<string>} [assets] 
     * @param {string} [otherAsset] 
     * @param {string} [transactionValue] 
     * @param {string} [radioContact] 
     * @param {string} [recaptchaResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public privateClient(firstName?: string, lastName?: string, email?: string, phone?: string, radioService?: string, assets?: Array<string>, otherAsset?: string, transactionValue?: string, radioContact?: string, recaptchaResponse?: string, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).privateClient(firstName, lastName, email, phone, radioService, assets, otherAsset, transactionValue, radioContact, recaptchaResponse, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [firstName] 
     * @param {string} [lastName] 
     * @param {string} [email] 
     * @param {string} [phone] 
     * @param {string} [radioTax] 
     * @param {string} [specifyCryptoPlatform] 
     * @param {string} [transactionsCount] 
     * @param {string} [recaptchaResponse] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContactApi
     */
    public tax(firstName?: string, lastName?: string, email?: string, phone?: string, radioTax?: string, specifyCryptoPlatform?: string, transactionsCount?: string, recaptchaResponse?: string, options?: RawAxiosRequestConfig) {
        return ContactApiFp(this.configuration).tax(firstName, lastName, email, phone, radioTax, specifyCryptoPlatform, transactionsCount, recaptchaResponse, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerApi - axios parameter creator
 * @export
 */
export const CustomerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a EUR bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsEur: async (_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/euro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyEuroBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an INT bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsInternational: async (_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/int`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyIntBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a SA bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsSa: async (_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/sa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifySaBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a UK bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsUk: async (_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/uk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyUkBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {WalletDto} [walletDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWallet: async (_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/wallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(walletDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a users EURO bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountEur: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/euro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a users INT bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountInt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/int`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a users SA bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountSa: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/sa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a users UK bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountUk: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/uk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a users wallet for a specific ProductCode.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
         * @param {string} [productCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWallet: async (productCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/wallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCode !== undefined) {
                localVarQueryParameter['productCode'] = productCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a EUR bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsEur: async (_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/euro`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyEuroBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a UK bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsGbp: async (_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/uk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyUkBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an INT bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsInternational: async (_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/int`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifyIntBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a SA bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsSa: async (_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/bankAccount/sa`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(modifySaBankAccountDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {WalletDto} [walletDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWallet: async (_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/customer/wallet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(walletDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a EUR bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankDetailsEur(_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuroBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankDetailsEur(_2fa, otpFlowTypeCode, modifyEuroBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createBankDetailsEur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an INT bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankDetailsInternational(_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankDetailsInternational(_2fa, otpFlowTypeCode, modifyIntBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createBankDetailsInternational']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a SA bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankDetailsSa(_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankDetailsSa(_2fa, otpFlowTypeCode, modifySaBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createBankDetailsSa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a UK bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createBankDetailsUk(_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UkBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createBankDetailsUk(_2fa, otpFlowTypeCode, modifyUkBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createBankDetailsUk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {WalletDto} [walletDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWallet(_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WalletDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWallet(_2fa, otpFlowTypeCode, walletDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.createWallet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a users EURO bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountEur(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuroBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountEur(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getBankAccountEur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a users INT bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountInt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountInt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getBankAccountInt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a users SA bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountSa(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountSa(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getBankAccountSa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a users UK bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankAccountUk(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UkBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankAccountUk(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getBankAccountUk']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a users wallet for a specific ProductCode.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
         * @param {string} [productCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWallet(productCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WalletDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWallet(productCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.getWallet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a EUR bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBankDetailsEur(_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuroBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankDetailsEur(_2fa, otpFlowTypeCode, modifyEuroBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateBankDetailsEur']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a UK bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBankDetailsGbp(_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UkBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankDetailsGbp(_2fa, otpFlowTypeCode, modifyUkBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateBankDetailsGbp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an INT bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBankDetailsInternational(_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IntBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankDetailsInternational(_2fa, otpFlowTypeCode, modifyIntBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateBankDetailsInternational']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a SA bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateBankDetailsSa(_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SaBankAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateBankDetailsSa(_2fa, otpFlowTypeCode, modifySaBankAccountDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateBankDetailsSa']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {WalletDto} [walletDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWallet(_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WalletDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWallet(_2fa, otpFlowTypeCode, walletDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerApi.updateWallet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a EUR bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsEur(_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options?: any): AxiosPromise<EuroBankAccountDto> {
            return localVarFp.createBankDetailsEur(_2fa, otpFlowTypeCode, modifyEuroBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an INT bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsInternational(_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options?: any): AxiosPromise<IntBankAccountDto> {
            return localVarFp.createBankDetailsInternational(_2fa, otpFlowTypeCode, modifyIntBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a SA bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsSa(_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options?: any): AxiosPromise<SaBankAccountDto> {
            return localVarFp.createBankDetailsSa(_2fa, otpFlowTypeCode, modifySaBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a UK bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBankDetailsUk(_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options?: any): AxiosPromise<UkBankAccountDto> {
            return localVarFp.createBankDetailsUk(_2fa, otpFlowTypeCode, modifyUkBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {WalletDto} [walletDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWallet(_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options?: any): AxiosPromise<WalletDto> {
            return localVarFp.createWallet(_2fa, otpFlowTypeCode, walletDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a users EURO bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountEur(options?: any): AxiosPromise<EuroBankAccountDto> {
            return localVarFp.getBankAccountEur(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a users INT bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountInt(options?: any): AxiosPromise<IntBankAccountDto> {
            return localVarFp.getBankAccountInt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a users SA bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountSa(options?: any): AxiosPromise<SaBankAccountDto> {
            return localVarFp.getBankAccountSa(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a users UK bank account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankAccountUk(options?: any): AxiosPromise<UkBankAccountDto> {
            return localVarFp.getBankAccountUk(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a users wallet for a specific ProductCode.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
         * @param {string} [productCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWallet(productCode?: string, options?: any): AxiosPromise<WalletDto> {
            return localVarFp.getWallet(productCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a EUR bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsEur(_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options?: any): AxiosPromise<EuroBankAccountDto> {
            return localVarFp.updateBankDetailsEur(_2fa, otpFlowTypeCode, modifyEuroBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a UK bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsGbp(_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options?: any): AxiosPromise<UkBankAccountDto> {
            return localVarFp.updateBankDetailsGbp(_2fa, otpFlowTypeCode, modifyUkBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an INT bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsInternational(_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options?: any): AxiosPromise<IntBankAccountDto> {
            return localVarFp.updateBankDetailsInternational(_2fa, otpFlowTypeCode, modifyIntBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a SA bank account
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBankDetailsSa(_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options?: any): AxiosPromise<SaBankAccountDto> {
            return localVarFp.updateBankDetailsSa(_2fa, otpFlowTypeCode, modifySaBankAccountDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {WalletDto} [walletDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWallet(_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options?: any): AxiosPromise<WalletDto> {
            return localVarFp.updateWallet(_2fa, otpFlowTypeCode, walletDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @summary Create a EUR bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createBankDetailsEur(_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createBankDetailsEur(_2fa, otpFlowTypeCode, modifyEuroBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an INT bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createBankDetailsInternational(_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createBankDetailsInternational(_2fa, otpFlowTypeCode, modifyIntBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a SA bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createBankDetailsSa(_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createBankDetailsSa(_2fa, otpFlowTypeCode, modifySaBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a UK bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createBankDetailsUk(_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createBankDetailsUk(_2fa, otpFlowTypeCode, modifyUkBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {WalletDto} [walletDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public createWallet(_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).createWallet(_2fa, otpFlowTypeCode, walletDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a users EURO bank account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getBankAccountEur(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getBankAccountEur(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a users INT bank account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getBankAccountInt(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getBankAccountInt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a users SA bank account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getBankAccountSa(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getBankAccountSa(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a users UK bank account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getBankAccountUk(options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getBankAccountUk(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a users wallet for a specific ProductCode.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
     * @param {string} [productCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public getWallet(productCode?: string, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).getWallet(productCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a EUR bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifyEuroBankAccountDto} [modifyEuroBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateBankDetailsEur(_2fa?: string, otpFlowTypeCode?: string, modifyEuroBankAccountDto?: ModifyEuroBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateBankDetailsEur(_2fa, otpFlowTypeCode, modifyEuroBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a UK bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifyUkBankAccountDto} [modifyUkBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateBankDetailsGbp(_2fa?: string, otpFlowTypeCode?: string, modifyUkBankAccountDto?: ModifyUkBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateBankDetailsGbp(_2fa, otpFlowTypeCode, modifyUkBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an INT bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifyIntBankAccountDto} [modifyIntBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateBankDetailsInternational(_2fa?: string, otpFlowTypeCode?: string, modifyIntBankAccountDto?: ModifyIntBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateBankDetailsInternational(_2fa, otpFlowTypeCode, modifyIntBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a SA bank account
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ModifySaBankAccountDto} [modifySaBankAccountDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateBankDetailsSa(_2fa?: string, otpFlowTypeCode?: string, modifySaBankAccountDto?: ModifySaBankAccountDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateBankDetailsSa(_2fa, otpFlowTypeCode, modifySaBankAccountDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing user\'s Crypto wallet.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {WalletDto} [walletDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public updateWallet(_2fa?: string, otpFlowTypeCode?: string, walletDto?: WalletDto, options?: RawAxiosRequestConfig) {
        return CustomerApiFp(this.configuration).updateWallet(_2fa, otpFlowTypeCode, walletDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomerPersonalDataApi - axios parameter creator
 * @export
 */
export const CustomerPersonalDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CustomerPersonalDataDto} [customerPersonalDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdatePersonalData: async (customerPersonalDataDto?: CustomerPersonalDataDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(customerPersonalDataDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveTaxDataAddressRequest} [saveTaxDataAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAddress: async (saveTaxDataAddressRequest?: SaveTaxDataAddressRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData/address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveTaxDataAddressRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [countryOfResidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCountryOfResidence: async (countryOfResidence?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData/countryOfResidence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (countryOfResidence !== undefined) {
                localVarQueryParameter['countryOfResidence'] = countryOfResidence;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [countryOfTaxResidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCountryOfTaxResidence: async (countryOfTaxResidence?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData/countryOfTaxResidence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (countryOfTaxResidence !== undefined) {
                localVarQueryParameter['countryOfTaxResidence'] = countryOfTaxResidence;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SaveTaxDataRequest} [saveTaxDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxData: async (saveTaxDataRequest?: SaveTaxDataRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData/savePersonalData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveTaxDataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [taxIdentificationNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxIdentificationNumber: async (taxIdentificationNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/personalData/taxIdentificationNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (taxIdentificationNumber !== undefined) {
                localVarQueryParameter['taxIdentificationNumber'] = taxIdentificationNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerPersonalDataApi - functional programming interface
 * @export
 */
export const CustomerPersonalDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomerPersonalDataApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CustomerPersonalDataDto} [customerPersonalDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrUpdatePersonalData(customerPersonalDataDto?: CustomerPersonalDataDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrUpdatePersonalData(customerPersonalDataDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.createOrUpdatePersonalData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPersonalData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerPersonalDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPersonalData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.getPersonalData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveTaxDataAddressRequest} [saveTaxDataAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveAddress(saveTaxDataAddressRequest?: SaveTaxDataAddressRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveAddress(saveTaxDataAddressRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.saveAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [countryOfResidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCountryOfResidence(countryOfResidence?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCountryOfResidence(countryOfResidence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.saveCountryOfResidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [countryOfTaxResidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCountryOfTaxResidence(countryOfTaxResidence?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCountryOfTaxResidence(countryOfTaxResidence, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.saveCountryOfTaxResidence']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SaveTaxDataRequest} [saveTaxDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTaxData(saveTaxDataRequest?: SaveTaxDataRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTaxData(saveTaxDataRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.saveTaxData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [taxIdentificationNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveTaxIdentificationNumber(taxIdentificationNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveTaxIdentificationNumber(taxIdentificationNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomerPersonalDataApi.saveTaxIdentificationNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomerPersonalDataApi - factory interface
 * @export
 */
export const CustomerPersonalDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomerPersonalDataApiFp(configuration)
    return {
        /**
         * 
         * @param {CustomerPersonalDataDto} [customerPersonalDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrUpdatePersonalData(customerPersonalDataDto?: CustomerPersonalDataDto, options?: any): AxiosPromise<void> {
            return localVarFp.createOrUpdatePersonalData(customerPersonalDataDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonalData(options?: any): AxiosPromise<CustomerPersonalDataDto> {
            return localVarFp.getPersonalData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveTaxDataAddressRequest} [saveTaxDataAddressRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveAddress(saveTaxDataAddressRequest?: SaveTaxDataAddressRequest, options?: any): AxiosPromise<void> {
            return localVarFp.saveAddress(saveTaxDataAddressRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [countryOfResidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCountryOfResidence(countryOfResidence?: string, options?: any): AxiosPromise<void> {
            return localVarFp.saveCountryOfResidence(countryOfResidence, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [countryOfTaxResidence] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCountryOfTaxResidence(countryOfTaxResidence?: string, options?: any): AxiosPromise<void> {
            return localVarFp.saveCountryOfTaxResidence(countryOfTaxResidence, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SaveTaxDataRequest} [saveTaxDataRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxData(saveTaxDataRequest?: SaveTaxDataRequest, options?: any): AxiosPromise<void> {
            return localVarFp.saveTaxData(saveTaxDataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [taxIdentificationNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveTaxIdentificationNumber(taxIdentificationNumber?: string, options?: any): AxiosPromise<void> {
            return localVarFp.saveTaxIdentificationNumber(taxIdentificationNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomerPersonalDataApi - object-oriented interface
 * @export
 * @class CustomerPersonalDataApi
 * @extends {BaseAPI}
 */
export class CustomerPersonalDataApi extends BaseAPI {
    /**
     * 
     * @param {CustomerPersonalDataDto} [customerPersonalDataDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public createOrUpdatePersonalData(customerPersonalDataDto?: CustomerPersonalDataDto, options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).createOrUpdatePersonalData(customerPersonalDataDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public getPersonalData(options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).getPersonalData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveTaxDataAddressRequest} [saveTaxDataAddressRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public saveAddress(saveTaxDataAddressRequest?: SaveTaxDataAddressRequest, options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).saveAddress(saveTaxDataAddressRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [countryOfResidence] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public saveCountryOfResidence(countryOfResidence?: string, options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).saveCountryOfResidence(countryOfResidence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [countryOfTaxResidence] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public saveCountryOfTaxResidence(countryOfTaxResidence?: string, options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).saveCountryOfTaxResidence(countryOfTaxResidence, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SaveTaxDataRequest} [saveTaxDataRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public saveTaxData(saveTaxDataRequest?: SaveTaxDataRequest, options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).saveTaxData(saveTaxDataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [taxIdentificationNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerPersonalDataApi
     */
    public saveTaxIdentificationNumber(taxIdentificationNumber?: string, options?: RawAxiosRequestConfig) {
        return CustomerPersonalDataApiFp(this.configuration).saveTaxIdentificationNumber(taxIdentificationNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepositCryptoApi - axios parameter creator
 * @export
 */
export const DepositCryptoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all available crypto products that can be deposited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit/crypto/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancel', 'orderId', orderId)
            const localVarPath = `/deposit/crypto/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a crypto deposit
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeposit: async (productCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('createDeposit', 'productCode', productCode)
            const localVarPath = `/deposit/crypto/{productCode}`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        depositMade: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('depositMade', 'orderId', orderId)
            const localVarPath = `/deposit/crypto/{orderId}/depositMade`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a crypto deposit details
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeposit: async (productCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('getDeposit', 'productCode', productCode)
            const localVarPath = `/deposit/crypto/{productCode}`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide the stablecoin coversion notice for a specified product
         * @param {string} productcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideStablecoinConversionNotice: async (productcode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productcode' is not null or undefined
            assertParamExists('hideStablecoinConversionNotice', 'productcode', productcode)
            const localVarPath = `/deposit/crypto/hideStablecoinNotice/{productcode}`
                .replace(`{${"productcode"}}`, encodeURIComponent(String(productcode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepositCryptoApi - functional programming interface
 * @export
 */
export const DepositCryptoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepositCryptoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all available crypto products that can be deposited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CryptoDepositProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositCryptoApi.availableProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancel(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositCryptoApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a crypto deposit
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDeposit(productCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedCryptoDepositDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDeposit(productCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositCryptoApi.createDeposit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async depositMade(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.depositMade(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositCryptoApi.depositMade']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a crypto deposit details
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeposit(productCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreatedCryptoDepositDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeposit(productCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositCryptoApi.getDeposit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Hide the stablecoin coversion notice for a specified product
         * @param {string} productcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideStablecoinConversionNotice(productcode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideStablecoinConversionNotice(productcode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositCryptoApi.hideStablecoinConversionNotice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepositCryptoApi - factory interface
 * @export
 */
export const DepositCryptoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepositCryptoApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all available crypto products that can be deposited
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts(options?: any): AxiosPromise<Array<CryptoDepositProductDto>> {
            return localVarFp.availableProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a crypto deposit
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeposit(productCode: string, options?: any): AxiosPromise<CreatedCryptoDepositDetailsDto> {
            return localVarFp.createDeposit(productCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        depositMade(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.depositMade(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a crypto deposit details
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeposit(productCode: string, options?: any): AxiosPromise<CreatedCryptoDepositDetailsDto> {
            return localVarFp.getDeposit(productCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide the stablecoin coversion notice for a specified product
         * @param {string} productcode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideStablecoinConversionNotice(productcode: string, options?: any): AxiosPromise<void> {
            return localVarFp.hideStablecoinConversionNotice(productcode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepositCryptoApi - object-oriented interface
 * @export
 * @class DepositCryptoApi
 * @extends {BaseAPI}
 */
export class DepositCryptoApi extends BaseAPI {
    /**
     * 
     * @summary Get all available crypto products that can be deposited
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositCryptoApi
     */
    public availableProducts(options?: RawAxiosRequestConfig) {
        return DepositCryptoApiFp(this.configuration).availableProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User can cancel an order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DepositCryptoApi
     */
    public cancel(orderId: string, options?: RawAxiosRequestConfig) {
        return DepositCryptoApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a crypto deposit
     * @param {string} productCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositCryptoApi
     */
    public createDeposit(productCode: string, options?: RawAxiosRequestConfig) {
        return DepositCryptoApiFp(this.configuration).createDeposit(productCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositCryptoApi
     */
    public depositMade(orderId: string, options?: RawAxiosRequestConfig) {
        return DepositCryptoApiFp(this.configuration).depositMade(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a crypto deposit details
     * @param {string} productCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositCryptoApi
     */
    public getDeposit(productCode: string, options?: RawAxiosRequestConfig) {
        return DepositCryptoApiFp(this.configuration).getDeposit(productCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide the stablecoin coversion notice for a specified product
     * @param {string} productcode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositCryptoApi
     */
    public hideStablecoinConversionNotice(productcode: string, options?: RawAxiosRequestConfig) {
        return DepositCryptoApiFp(this.configuration).hideStablecoinConversionNotice(productcode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DepositFiatApi - axios parameter creator
 * @export
 */
export const DepositFiatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancel', 'orderId', orderId)
            const localVarPath = `/deposit/fiat/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a fiat deposit
         * @param {CreateFiatDepositDto} [createFiatDepositDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiatDeposit: async (createFiatDepositDto?: CreateFiatDepositDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit/fiat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFiatDepositDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to the customer\'s functional fiat product for the deposit flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatDepositProductData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit/fiat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to the customer\'s functional fiat product for the LinkedDeposit deposit flow
         * @param {string} linkedDepositCustomerAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedDepositFiatDepositProductData: async (linkedDepositCustomerAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkedDepositCustomerAccountId' is not null or undefined
            assertParamExists('getLinkedDepositFiatDepositProductData', 'linkedDepositCustomerAccountId', linkedDepositCustomerAccountId)
            const localVarPath = `/deposit/fiat/linkedDeposit/{linkedDepositCustomerAccountId}`
                .replace(`{${"linkedDepositCustomerAccountId"}}`, encodeURIComponent(String(linkedDepositCustomerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get pending fiat deposit orders for the customer including the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingFiatDepositOrderDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit/fiat/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideDepositInstructions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit/fiat/hideInstructions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Specify whether a payment has been made, or will be made later
         * @param {string} [orderId] 
         * @param {boolean} [paymentMade] 
         * @param {File} [popFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMade: async (orderId?: string, paymentMade?: boolean, popFile?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/deposit/fiat/paymentMade`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            if (orderId !== undefined) { 
                localVarFormParams.append('OrderId', orderId as any);
            }
    
            if (paymentMade !== undefined) { 
                localVarFormParams.append('PaymentMade', String(paymentMade) as any);
            }
    
            if (popFile !== undefined) { 
                localVarFormParams.append('PopFile', popFile as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepositFiatApi - functional programming interface
 * @export
 */
export const DepositFiatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepositFiatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancel(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a fiat deposit
         * @param {CreateFiatDepositDto} [createFiatDepositDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFiatDeposit(createFiatDepositDto?: CreateFiatDepositDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFiatDeposit(createFiatDepositDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.createFiatDeposit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to the customer\'s functional fiat product for the deposit flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiatDepositProductData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FiatDepositProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiatDepositProductData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.getFiatDepositProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to the customer\'s functional fiat product for the LinkedDeposit deposit flow
         * @param {string} linkedDepositCustomerAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkedDepositFiatDepositProductData(linkedDepositCustomerAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedDepositFiatDepositProductDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkedDepositFiatDepositProductData(linkedDepositCustomerAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.getLinkedDepositFiatDepositProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get pending fiat deposit orders for the customer including the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingFiatDepositOrderDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingFiatDepositDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingFiatDepositOrderDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.getPendingFiatDepositOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async hideDepositInstructions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.hideDepositInstructions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.hideDepositInstructions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Specify whether a payment has been made, or will be made later
         * @param {string} [orderId] 
         * @param {boolean} [paymentMade] 
         * @param {File} [popFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paymentMade(orderId?: string, paymentMade?: boolean, popFile?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paymentMade(orderId, paymentMade, popFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DepositFiatApi.paymentMade']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DepositFiatApi - factory interface
 * @export
 */
export const DepositFiatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepositFiatApiFp(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a fiat deposit
         * @param {CreateFiatDepositDto} [createFiatDepositDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFiatDeposit(createFiatDepositDto?: CreateFiatDepositDto, options?: any): AxiosPromise<OrderResponseDto> {
            return localVarFp.createFiatDeposit(createFiatDepositDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to the customer\'s functional fiat product for the deposit flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiatDepositProductData(options?: any): AxiosPromise<FiatDepositProductDataDto> {
            return localVarFp.getFiatDepositProductData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to the customer\'s functional fiat product for the LinkedDeposit deposit flow
         * @param {string} linkedDepositCustomerAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedDepositFiatDepositProductData(linkedDepositCustomerAccountId: string, options?: any): AxiosPromise<Array<LinkedDepositFiatDepositProductDataDto>> {
            return localVarFp.getLinkedDepositFiatDepositProductData(linkedDepositCustomerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get pending fiat deposit orders for the customer including the payment method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingFiatDepositOrderDetails(options?: any): AxiosPromise<Array<PendingFiatDepositDetailsDto>> {
            return localVarFp.getPendingFiatDepositOrderDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        hideDepositInstructions(options?: any): AxiosPromise<void> {
            return localVarFp.hideDepositInstructions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Specify whether a payment has been made, or will be made later
         * @param {string} [orderId] 
         * @param {boolean} [paymentMade] 
         * @param {File} [popFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentMade(orderId?: string, paymentMade?: boolean, popFile?: File, options?: any): AxiosPromise<void> {
            return localVarFp.paymentMade(orderId, paymentMade, popFile, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepositFiatApi - object-oriented interface
 * @export
 * @class DepositFiatApi
 * @extends {BaseAPI}
 */
export class DepositFiatApi extends BaseAPI {
    /**
     * 
     * @summary User can cancel an order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public cancel(orderId: string, options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a fiat deposit
     * @param {CreateFiatDepositDto} [createFiatDepositDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public createFiatDeposit(createFiatDepositDto?: CreateFiatDepositDto, options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).createFiatDeposit(createFiatDepositDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to the customer\'s functional fiat product for the deposit flow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public getFiatDepositProductData(options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).getFiatDepositProductData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to the customer\'s functional fiat product for the LinkedDeposit deposit flow
     * @param {string} linkedDepositCustomerAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public getLinkedDepositFiatDepositProductData(linkedDepositCustomerAccountId: string, options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).getLinkedDepositFiatDepositProductData(linkedDepositCustomerAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get pending fiat deposit orders for the customer including the payment method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public getPendingFiatDepositOrderDetails(options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).getPendingFiatDepositOrderDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public hideDepositInstructions(options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).hideDepositInstructions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Specify whether a payment has been made, or will be made later
     * @param {string} [orderId] 
     * @param {boolean} [paymentMade] 
     * @param {File} [popFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositFiatApi
     */
    public paymentMade(orderId?: string, paymentMade?: boolean, popFile?: File, options?: RawAxiosRequestConfig) {
        return DepositFiatApiFp(this.configuration).paymentMade(orderId, paymentMade, popFile, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FeatureFlagApi - axios parameter creator
 * @export
 */
export const FeatureFlagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check if deposits allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowDeposits: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featureFlags/deposits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if registrations allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowRegistrations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featureFlags/registrations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if savings vaults are allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowSavingsVault: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featureFlags/savingsvaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if trading allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowTrading: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featureFlags/trades`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if withdrawals allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowWithdrawal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featureFlags/withdrawals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of all features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/featureFlags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureFlagApi - functional programming interface
 * @export
 */
export const FeatureFlagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureFlagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check if deposits allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowDeposits(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowDeposits(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagApi.allowDeposits']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if registrations allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowRegistrations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowRegistrations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagApi.allowRegistrations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if savings vaults are allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowSavingsVault(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowSavingsVault(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagApi.allowSavingsVault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if trading allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowTrading(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowTrading(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagApi.allowTrading']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if withdrawals allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allowWithdrawal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allowWithdrawal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagApi.allowWithdrawal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of all features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async list(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureFlag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.list(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FeatureFlagApi.list']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FeatureFlagApi - factory interface
 * @export
 */
export const FeatureFlagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureFlagApiFp(configuration)
    return {
        /**
         * 
         * @summary Check if deposits allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowDeposits(options?: any): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.allowDeposits(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if registrations allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowRegistrations(options?: any): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.allowRegistrations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if savings vaults are allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowSavingsVault(options?: any): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.allowSavingsVault(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if trading allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowTrading(options?: any): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.allowTrading(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if withdrawals allowed, 200 ok, 400 fail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allowWithdrawal(options?: any): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.allowWithdrawal(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of all features
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options?: any): AxiosPromise<Array<FeatureFlag>> {
            return localVarFp.list(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureFlagApi - object-oriented interface
 * @export
 * @class FeatureFlagApi
 * @extends {BaseAPI}
 */
export class FeatureFlagApi extends BaseAPI {
    /**
     * 
     * @summary Check if deposits allowed, 200 ok, 400 fail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public allowDeposits(options?: RawAxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).allowDeposits(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if registrations allowed, 200 ok, 400 fail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public allowRegistrations(options?: RawAxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).allowRegistrations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if savings vaults are allowed, 200 ok, 400 fail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public allowSavingsVault(options?: RawAxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).allowSavingsVault(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if trading allowed, 200 ok, 400 fail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public allowTrading(options?: RawAxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).allowTrading(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if withdrawals allowed, 200 ok, 400 fail
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public allowWithdrawal(options?: RawAxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).allowWithdrawal(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of all features
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureFlagApi
     */
    public list(options?: RawAxiosRequestConfig) {
        return FeatureFlagApiFp(this.configuration).list(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LinkedDepositCustomerAccountApi - axios parameter creator
 * @export
 */
export const LinkedDepositCustomerAccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Complete a LinkedDepositCustomerAccount from a Pending state to a Complete state for a User.  Stitch requires dictionary values: \"Code\"
         * @param {LinkedDepositCustomerAccountCompleteRequest} [linkedDepositCustomerAccountCompleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete: async (linkedDepositCustomerAccountCompleteRequest?: LinkedDepositCustomerAccountCompleteRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/linkedDepositCustomerAccount/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkedDepositCustomerAccountCompleteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all LinkedDepositCustomerAccountProviders for a country
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlLinkedDepositCustomerAccountProviders: async (countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getAlLinkedDepositCustomerAccountProviders', 'countryCode', countryCode)
            const localVarPath = `/linkedDepositCustomerAccount/providers/{countryCode}`
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all LinkedDepositCustomerAccounts for a User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLinkedDepositCustomerAccounts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/linkedDepositCustomerAccount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a specific LinkedDepositCustomerAccount
         * @param {string} linkedDepositCustomerAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedDepositCustomerAccount: async (linkedDepositCustomerAccountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'linkedDepositCustomerAccountId' is not null or undefined
            assertParamExists('getLinkedDepositCustomerAccount', 'linkedDepositCustomerAccountId', linkedDepositCustomerAccountId)
            const localVarPath = `/linkedDepositCustomerAccount/{linkedDepositCustomerAccountId}`
                .replace(`{${"linkedDepositCustomerAccountId"}}`, encodeURIComponent(String(linkedDepositCustomerAccountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all the supported bank acounts for a provider by country
         * @param {string} providerCode 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedBanks: async (providerCode: string, countryCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerCode' is not null or undefined
            assertParamExists('getSupportedBanks', 'providerCode', providerCode)
            // verify required parameter 'countryCode' is not null or undefined
            assertParamExists('getSupportedBanks', 'countryCode', countryCode)
            const localVarPath = `/linkedDepositCustomerAccount/provider/{providerCode}/banks/{countryCode}`
                .replace(`{${"providerCode"}}`, encodeURIComponent(String(providerCode)))
                .replace(`{${"countryCode"}}`, encodeURIComponent(String(countryCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Initialize a LinkedDepositCustomerAccount in a Pending state for a User
         * @param {string} providerCode 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialize: async (providerCode: string, source?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'providerCode' is not null or undefined
            assertParamExists('initialize', 'providerCode', providerCode)
            const localVarPath = `/linkedDepositCustomerAccount/initialize/{providerCode}`
                .replace(`{${"providerCode"}}`, encodeURIComponent(String(providerCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unlink a Linked Deposit Customer Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkLinkedDepositCustomerAccount: async (accountId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accountId' is not null or undefined
            assertParamExists('unlinkLinkedDepositCustomerAccount', 'accountId', accountId)
            const localVarPath = `/linkedDepositCustomerAccount/unlink/{accountId}`
                .replace(`{${"accountId"}}`, encodeURIComponent(String(accountId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the friendly name of a LinkedDepositCustomerAccount
         * @param {LinkedDepositCustomerAccountFriendlyNameRequest} [linkedDepositCustomerAccountFriendlyNameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFriendlyName: async (linkedDepositCustomerAccountFriendlyNameRequest?: LinkedDepositCustomerAccountFriendlyNameRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/linkedDepositCustomerAccount/updateFriendlyName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkedDepositCustomerAccountFriendlyNameRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LinkedDepositCustomerAccountApi - functional programming interface
 * @export
 */
export const LinkedDepositCustomerAccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LinkedDepositCustomerAccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Complete a LinkedDepositCustomerAccount from a Pending state to a Complete state for a User.  Stitch requires dictionary values: \"Code\"
         * @param {LinkedDepositCustomerAccountCompleteRequest} [linkedDepositCustomerAccountCompleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complete(linkedDepositCustomerAccountCompleteRequest?: LinkedDepositCustomerAccountCompleteRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedDepositCustomerAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complete(linkedDepositCustomerAccountCompleteRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.complete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all LinkedDepositCustomerAccountProviders for a country
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAlLinkedDepositCustomerAccountProviders(countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedDepositCustomerAccountProviderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAlLinkedDepositCustomerAccountProviders(countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.getAlLinkedDepositCustomerAccountProviders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all LinkedDepositCustomerAccounts for a User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllLinkedDepositCustomerAccounts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedDepositCustomerAccountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllLinkedDepositCustomerAccounts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.getAllLinkedDepositCustomerAccounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a specific LinkedDepositCustomerAccount
         * @param {string} linkedDepositCustomerAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLinkedDepositCustomerAccount(linkedDepositCustomerAccountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedDepositCustomerAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLinkedDepositCustomerAccount(linkedDepositCustomerAccountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.getLinkedDepositCustomerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all the supported bank acounts for a provider by country
         * @param {string} providerCode 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSupportedBanks(providerCode: string, countryCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LinkedDepositAvailableBankDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSupportedBanks(providerCode, countryCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.getSupportedBanks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Initialize a LinkedDepositCustomerAccount in a Pending state for a User
         * @param {string} providerCode 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initialize(providerCode: string, source?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LinkedDepositCustomerAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initialize(providerCode, source, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.initialize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Unlink a Linked Deposit Customer Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unlinkLinkedDepositCustomerAccount(accountId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unlinkLinkedDepositCustomerAccount(accountId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.unlinkLinkedDepositCustomerAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update the friendly name of a LinkedDepositCustomerAccount
         * @param {LinkedDepositCustomerAccountFriendlyNameRequest} [linkedDepositCustomerAccountFriendlyNameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFriendlyName(linkedDepositCustomerAccountFriendlyNameRequest?: LinkedDepositCustomerAccountFriendlyNameRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFriendlyName(linkedDepositCustomerAccountFriendlyNameRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LinkedDepositCustomerAccountApi.updateFriendlyName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LinkedDepositCustomerAccountApi - factory interface
 * @export
 */
export const LinkedDepositCustomerAccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LinkedDepositCustomerAccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Complete a LinkedDepositCustomerAccount from a Pending state to a Complete state for a User.  Stitch requires dictionary values: \"Code\"
         * @param {LinkedDepositCustomerAccountCompleteRequest} [linkedDepositCustomerAccountCompleteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(linkedDepositCustomerAccountCompleteRequest?: LinkedDepositCustomerAccountCompleteRequest, options?: any): AxiosPromise<LinkedDepositCustomerAccountDto> {
            return localVarFp.complete(linkedDepositCustomerAccountCompleteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all LinkedDepositCustomerAccountProviders for a country
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlLinkedDepositCustomerAccountProviders(countryCode: string, options?: any): AxiosPromise<Array<LinkedDepositCustomerAccountProviderDto>> {
            return localVarFp.getAlLinkedDepositCustomerAccountProviders(countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all LinkedDepositCustomerAccounts for a User
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllLinkedDepositCustomerAccounts(options?: any): AxiosPromise<Array<LinkedDepositCustomerAccountDto>> {
            return localVarFp.getAllLinkedDepositCustomerAccounts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a specific LinkedDepositCustomerAccount
         * @param {string} linkedDepositCustomerAccountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLinkedDepositCustomerAccount(linkedDepositCustomerAccountId: string, options?: any): AxiosPromise<LinkedDepositCustomerAccountDto> {
            return localVarFp.getLinkedDepositCustomerAccount(linkedDepositCustomerAccountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all the supported bank acounts for a provider by country
         * @param {string} providerCode 
         * @param {string} countryCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupportedBanks(providerCode: string, countryCode: string, options?: any): AxiosPromise<Array<LinkedDepositAvailableBankDto>> {
            return localVarFp.getSupportedBanks(providerCode, countryCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Initialize a LinkedDepositCustomerAccount in a Pending state for a User
         * @param {string} providerCode 
         * @param {string} [source] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initialize(providerCode: string, source?: string, options?: any): AxiosPromise<LinkedDepositCustomerAccountDto> {
            return localVarFp.initialize(providerCode, source, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unlink a Linked Deposit Customer Account
         * @param {string} accountId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unlinkLinkedDepositCustomerAccount(accountId: string, options?: any): AxiosPromise<void> {
            return localVarFp.unlinkLinkedDepositCustomerAccount(accountId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the friendly name of a LinkedDepositCustomerAccount
         * @param {LinkedDepositCustomerAccountFriendlyNameRequest} [linkedDepositCustomerAccountFriendlyNameRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFriendlyName(linkedDepositCustomerAccountFriendlyNameRequest?: LinkedDepositCustomerAccountFriendlyNameRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateFriendlyName(linkedDepositCustomerAccountFriendlyNameRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LinkedDepositCustomerAccountApi - object-oriented interface
 * @export
 * @class LinkedDepositCustomerAccountApi
 * @extends {BaseAPI}
 */
export class LinkedDepositCustomerAccountApi extends BaseAPI {
    /**
     * 
     * @summary Complete a LinkedDepositCustomerAccount from a Pending state to a Complete state for a User.  Stitch requires dictionary values: \"Code\"
     * @param {LinkedDepositCustomerAccountCompleteRequest} [linkedDepositCustomerAccountCompleteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public complete(linkedDepositCustomerAccountCompleteRequest?: LinkedDepositCustomerAccountCompleteRequest, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).complete(linkedDepositCustomerAccountCompleteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all LinkedDepositCustomerAccountProviders for a country
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public getAlLinkedDepositCustomerAccountProviders(countryCode: string, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).getAlLinkedDepositCustomerAccountProviders(countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all LinkedDepositCustomerAccounts for a User
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public getAllLinkedDepositCustomerAccounts(options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).getAllLinkedDepositCustomerAccounts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a specific LinkedDepositCustomerAccount
     * @param {string} linkedDepositCustomerAccountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public getLinkedDepositCustomerAccount(linkedDepositCustomerAccountId: string, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).getLinkedDepositCustomerAccount(linkedDepositCustomerAccountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all the supported bank acounts for a provider by country
     * @param {string} providerCode 
     * @param {string} countryCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public getSupportedBanks(providerCode: string, countryCode: string, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).getSupportedBanks(providerCode, countryCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Initialize a LinkedDepositCustomerAccount in a Pending state for a User
     * @param {string} providerCode 
     * @param {string} [source] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public initialize(providerCode: string, source?: string, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).initialize(providerCode, source, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unlink a Linked Deposit Customer Account
     * @param {string} accountId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public unlinkLinkedDepositCustomerAccount(accountId: string, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).unlinkLinkedDepositCustomerAccount(accountId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the friendly name of a LinkedDepositCustomerAccount
     * @param {LinkedDepositCustomerAccountFriendlyNameRequest} [linkedDepositCustomerAccountFriendlyNameRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LinkedDepositCustomerAccountApi
     */
    public updateFriendlyName(linkedDepositCustomerAccountFriendlyNameRequest?: LinkedDepositCustomerAccountFriendlyNameRequest, options?: RawAxiosRequestConfig) {
        return LinkedDepositCustomerAccountApiFp(this.configuration).updateFriendlyName(linkedDepositCustomerAccountFriendlyNameRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrdersApi - axios parameter creator
 * @export
 */
export const OrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancel', 'orderId', orderId)
            const localVarPath = `/orders/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrdersApi - functional programming interface
 * @export
 */
export const OrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OrdersApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OrdersApi - factory interface
 * @export
 */
export const OrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrdersApiFp(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrdersApi - object-oriented interface
 * @export
 * @class OrdersApi
 * @extends {BaseAPI}
 */
export class OrdersApi extends BaseAPI {
    /**
     * 
     * @summary User can cancel an order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrdersApi
     */
    public cancel(orderId: string, options?: RawAxiosRequestConfig) {
        return OrdersApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PendingOrdersApi - axios parameter creator
 * @export
 */
export const PendingOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrdersSimple: async (productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pending-orders/simple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PendingOrdersApi - functional programming interface
 * @export
 */
export const PendingOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PendingOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingOrdersSimple(productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetPendingsOrdersSimpleQueryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingOrdersSimple(productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PendingOrdersApi.getPendingOrdersSimple']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PendingOrdersApi - factory interface
 * @export
 */
export const PendingOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PendingOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrdersSimple(productCodes?: string, options?: any): AxiosPromise<Array<GetPendingsOrdersSimpleQueryResponse>> {
            return localVarFp.getPendingOrdersSimple(productCodes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PendingOrdersApi - object-oriented interface
 * @export
 * @class PendingOrdersApi
 * @extends {BaseAPI}
 */
export class PendingOrdersApi extends BaseAPI {
    /**
     * 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PendingOrdersApi
     */
    public getPendingOrdersSimple(productCodes?: string, options?: RawAxiosRequestConfig) {
        return PendingOrdersApiFp(this.configuration).getPendingOrdersSimple(productCodes, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PortfolioApi - axios parameter creator
 * @export
 */
export const PortfolioApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balances: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/balances`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerTimespans: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/timespans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [time] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        performance: async (time?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/performance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (time !== undefined) {
                localVarQueryParameter['time'] = time;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDeFiVault: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/vaults`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioApi - functional programming interface
 * @export
 */
export const PortfolioApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async balances(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CashBalanceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.balances(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioApi.balances']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customerTimespans(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioDurationTimespanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customerTimespans(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioApi.customerTimespans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [time] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async performance(time?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PerformanceValueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.performance(time, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioApi.performance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDeFiVault(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductVaultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDeFiVault(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioApi.productDeFiVault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortfolioApi - factory interface
 * @export
 */
export const PortfolioApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        balances(options?: any): AxiosPromise<Array<CashBalanceDto>> {
            return localVarFp.balances(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customerTimespans(options?: any): AxiosPromise<PortfolioDurationTimespanDto> {
            return localVarFp.customerTimespans(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [time] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        performance(time?: number, options?: any): AxiosPromise<PerformanceValueDto> {
            return localVarFp.performance(time, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDeFiVault(options?: any): AxiosPromise<Array<ProductVaultDto>> {
            return localVarFp.productDeFiVault(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioApi - object-oriented interface
 * @export
 * @class PortfolioApi
 * @extends {BaseAPI}
 */
export class PortfolioApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public balances(options?: RawAxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).balances(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public customerTimespans(options?: RawAxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).customerTimespans(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [time] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public performance(time?: number, options?: RawAxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).performance(time, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioApi
     */
    public productDeFiVault(options?: RawAxiosRequestConfig) {
        return PortfolioApiFp(this.configuration).productDeFiVault(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PortfolioV2Api - axios parameter creator
 * @export
 */
export const PortfolioV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} timeInterval 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAggregated: async (timeInterval: number, productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeInterval' is not null or undefined
            assertParamExists('getAggregated', 'timeInterval', timeInterval)
            const localVarPath = `/portfolio/v2/aggregated/{timeInterval}`
                .replace(`{${"timeInterval"}}`, encodeURIComponent(String(timeInterval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getOldPortfolioGainsAndLosses: async (timeInterval?: number, productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/gains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timeInterval !== undefined) {
                localVarQueryParameter['timeInterval'] = timeInterval;
            }

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} timeInterval 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getPortfolioAndHoldingsGainsLossesOld: async (timeInterval: number, productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'timeInterval' is not null or undefined
            assertParamExists('getPortfolioAndHoldingsGainsLossesOld', 'timeInterval', timeInterval)
            const localVarPath = `/portfolio/v2/all-gains/{timeInterval}`
                .replace(`{${"timeInterval"}}`, encodeURIComponent(String(timeInterval)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioGainsAndLosses: async (timeInterval?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/gains-v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timeInterval !== undefined) {
                localVarQueryParameter['timeInterval'] = timeInterval;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioHoldings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/holdings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioPerformanceGraph: async (timeInterval?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/performance-graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timeInterval !== undefined) {
                localVarQueryParameter['timeInterval'] = timeInterval;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getProductsAndHoldings: async (productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/products-and-holdings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReservedAmounts: async (productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/reserved-amounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getVaultGains: async (productCodes?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portfolio/v2/vault-gains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCodes !== undefined) {
                localVarQueryParameter['productCodes'] = productCodes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortfolioV2Api - functional programming interface
 * @export
 */
export const PortfolioV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortfolioV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} timeInterval 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getAggregated(timeInterval: number, productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AggregatedPortfolioQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAggregated(timeInterval, productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getAggregated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getOldPortfolioGainsAndLosses(timeInterval?: number, productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGainLossesQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOldPortfolioGainsAndLosses(timeInterval, productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getOldPortfolioGainsAndLosses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} timeInterval 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getPortfolioAndHoldingsGainsLossesOld(timeInterval: number, productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGainLossesQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioAndHoldingsGainsLossesOld(timeInterval, productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getPortfolioAndHoldingsGainsLossesOld']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioGainsAndLosses(timeInterval?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PortfolioGainLossDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioGainsAndLosses(timeInterval, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getPortfolioGainsAndLosses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioHoldings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HoldingsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioHoldings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getPortfolioHoldings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioPerformanceGraph(timeInterval?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GraphPoint>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioPerformanceGraph(timeInterval, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getPortfolioPerformanceGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getProductsAndHoldings(productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetProductsAndHoldingsQueryResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductsAndHoldings(productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getProductsAndHoldings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getReservedAmounts(productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReservedAmounts(productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getReservedAmounts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardsDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetRewardsDetailsQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardsDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getRewardsDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getVaultGains(productCodes?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVaultGains(productCodes, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortfolioV2Api.getVaultGains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortfolioV2Api - factory interface
 * @export
 */
export const PortfolioV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortfolioV2ApiFp(configuration)
    return {
        /**
         * 
         * @param {number} timeInterval 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getAggregated(timeInterval: number, productCodes?: string, options?: any): AxiosPromise<AggregatedPortfolioQueryResponse> {
            return localVarFp.getAggregated(timeInterval, productCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getOldPortfolioGainsAndLosses(timeInterval?: number, productCodes?: string, options?: any): AxiosPromise<GetGainLossesQueryResponse> {
            return localVarFp.getOldPortfolioGainsAndLosses(timeInterval, productCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} timeInterval 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getPortfolioAndHoldingsGainsLossesOld(timeInterval: number, productCodes?: string, options?: any): AxiosPromise<GetGainLossesQueryResponse> {
            return localVarFp.getPortfolioAndHoldingsGainsLossesOld(timeInterval, productCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioGainsAndLosses(timeInterval?: number, options?: any): AxiosPromise<PortfolioGainLossDto> {
            return localVarFp.getPortfolioGainsAndLosses(timeInterval, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioHoldings(options?: any): AxiosPromise<Array<HoldingsDto>> {
            return localVarFp.getPortfolioHoldings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [timeInterval] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioPerformanceGraph(timeInterval?: number, options?: any): AxiosPromise<Array<GraphPoint>> {
            return localVarFp.getPortfolioPerformanceGraph(timeInterval, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getProductsAndHoldings(productCodes?: string, options?: any): AxiosPromise<Array<GetProductsAndHoldingsQueryResponse>> {
            return localVarFp.getProductsAndHoldings(productCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getReservedAmounts(productCodes?: string, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getReservedAmounts(productCodes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardsDetails(options?: any): AxiosPromise<GetRewardsDetailsQueryResponse> {
            return localVarFp.getRewardsDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [productCodes] 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getVaultGains(productCodes?: string, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getVaultGains(productCodes, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortfolioV2Api - object-oriented interface
 * @export
 * @class PortfolioV2Api
 * @extends {BaseAPI}
 */
export class PortfolioV2Api extends BaseAPI {
    /**
     * 
     * @param {number} timeInterval 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getAggregated(timeInterval: number, productCodes?: string, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getAggregated(timeInterval, productCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [timeInterval] 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getOldPortfolioGainsAndLosses(timeInterval?: number, productCodes?: string, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getOldPortfolioGainsAndLosses(timeInterval, productCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} timeInterval 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getPortfolioAndHoldingsGainsLossesOld(timeInterval: number, productCodes?: string, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getPortfolioAndHoldingsGainsLossesOld(timeInterval, productCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [timeInterval] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getPortfolioGainsAndLosses(timeInterval?: number, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getPortfolioGainsAndLosses(timeInterval, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getPortfolioHoldings(options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getPortfolioHoldings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [timeInterval] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getPortfolioPerformanceGraph(timeInterval?: number, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getPortfolioPerformanceGraph(timeInterval, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getProductsAndHoldings(productCodes?: string, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getProductsAndHoldings(productCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getReservedAmounts(productCodes?: string, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getReservedAmounts(productCodes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getRewardsDetails(options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getRewardsDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [productCodes] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof PortfolioV2Api
     */
    public getVaultGains(productCodes?: string, options?: RawAxiosRequestConfig) {
        return PortfolioV2ApiFp(this.configuration).getVaultGains(productCodes, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {GetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (fromProductCode?: string, toProductCode?: string, type?: GetTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/transactable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromProductCode !== undefined) {
                localVarQueryParameter['fromProductCode'] = fromProductCode;
            }

            if (toProductCode !== undefined) {
                localVarQueryParameter['toProductCode'] = toProductCode;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [timeframeDays] 
         * @param {string} [displayCurrency] 
         * @param {number} [decimateBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsGraphs: async (timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/graph`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timeframeDays !== undefined) {
                localVarQueryParameter['timeframeDays'] = timeframeDays;
            }

            if (displayCurrency !== undefined) {
                localVarQueryParameter['displayCurrency'] = displayCurrency;
            }

            if (decimateBy !== undefined) {
                localVarQueryParameter['decimateBy'] = decimateBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [displayCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsMetrics: async (displayCurrency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (displayCurrency !== undefined) {
                localVarQueryParameter['displayCurrency'] = displayCurrency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productCode 
         * @param {number} [timeframeDays] 
         * @param {string} [displayCurrency] 
         * @param {number} [decimateBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGraph: async (productCode: string, timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('getProductGraph', 'productCode', productCode)
            const localVarPath = `/products/{productCode}/graph`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (timeframeDays !== undefined) {
                localVarQueryParameter['timeframeDays'] = timeframeDays;
            }

            if (displayCurrency !== undefined) {
                localVarQueryParameter['displayCurrency'] = displayCurrency;
            }

            if (decimateBy !== undefined) {
                localVarQueryParameter['decimateBy'] = decimateBy;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDeFiVault: async (productCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'productCode' is not null or undefined
            assertParamExists('productDeFiVault', 'productCode', productCode)
            const localVarPath = `/products/vault/{productCode}`
                .replace(`{${"productCode"}}`, encodeURIComponent(String(productCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {GetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(fromProductCode?: string, toProductCode?: string, type?: GetTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductTransactablePairDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(fromProductCode, toProductCode, type, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getActiveProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ActiveProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAvailableProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [timeframeDays] 
         * @param {string} [displayCurrency] 
         * @param {number} [decimateBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableProductsGraphs(timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductsGraphsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableProductsGraphs(timeframeDays, displayCurrency, decimateBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAvailableProductsGraphs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [displayCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableProductsMetrics(displayCurrency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductMetricsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableProductsMetrics(displayCurrency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getAvailableProductsMetrics']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productCode 
         * @param {number} [timeframeDays] 
         * @param {string} [displayCurrency] 
         * @param {number} [decimateBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProductGraph(productCode: string, timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductGraphDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProductGraph(productCode, timeframeDays, displayCurrency, decimateBy, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.getProductGraph']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productDeFiVault(productCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductVaultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productDeFiVault(productCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.productDeFiVault']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async suggestions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PortfolioProductHoldingsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.suggestions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProductsApi.suggestions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {GetTypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(fromProductCode?: string, toProductCode?: string, type?: GetTypeEnum, options?: any): AxiosPromise<Array<ProductTransactablePairDto>> {
            return localVarFp.get(fromProductCode, toProductCode, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveProducts(options?: any): AxiosPromise<Array<ActiveProductDto>> {
            return localVarFp.getActiveProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProducts(options?: any): AxiosPromise<Array<ActiveProductDto>> {
            return localVarFp.getAvailableProducts(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [timeframeDays] 
         * @param {string} [displayCurrency] 
         * @param {number} [decimateBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsGraphs(timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options?: any): AxiosPromise<ProductsGraphsDto> {
            return localVarFp.getAvailableProductsGraphs(timeframeDays, displayCurrency, decimateBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [displayCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsMetrics(displayCurrency?: string, options?: any): AxiosPromise<Array<ProductMetricsDto>> {
            return localVarFp.getAvailableProductsMetrics(displayCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productCode 
         * @param {number} [timeframeDays] 
         * @param {string} [displayCurrency] 
         * @param {number} [decimateBy] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductGraph(productCode: string, timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options?: any): AxiosPromise<ProductGraphDto> {
            return localVarFp.getProductGraph(productCode, timeframeDays, displayCurrency, decimateBy, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} productCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productDeFiVault(productCode: string, options?: any): AxiosPromise<ProductVaultDto> {
            return localVarFp.productDeFiVault(productCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestions(options?: any): AxiosPromise<Array<PortfolioProductHoldingsDto>> {
            return localVarFp.suggestions(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @param {string} [fromProductCode] 
     * @param {string} [toProductCode] 
     * @param {GetTypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public get(fromProductCode?: string, toProductCode?: string, type?: GetTypeEnum, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).get(fromProductCode, toProductCode, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getActiveProducts(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getActiveProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getAvailableProducts(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getAvailableProducts(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [timeframeDays] 
     * @param {string} [displayCurrency] 
     * @param {number} [decimateBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getAvailableProductsGraphs(timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getAvailableProductsGraphs(timeframeDays, displayCurrency, decimateBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [displayCurrency] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getAvailableProductsMetrics(displayCurrency?: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getAvailableProductsMetrics(displayCurrency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productCode 
     * @param {number} [timeframeDays] 
     * @param {string} [displayCurrency] 
     * @param {number} [decimateBy] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public getProductGraph(productCode: string, timeframeDays?: number, displayCurrency?: string, decimateBy?: number, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).getProductGraph(productCode, timeframeDays, displayCurrency, decimateBy, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} productCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public productDeFiVault(productCode: string, options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).productDeFiVault(productCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public suggestions(options?: RawAxiosRequestConfig) {
        return ProductsApiFp(this.configuration).suggestions(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetTypeEnum = {
    SellsTo: 'SellsTo',
    Buys: 'Buys'
} as const;
export type GetTypeEnum = typeof GetTypeEnum[keyof typeof GetTypeEnum];


/**
 * ProfileApi - axios parameter creator
 * @export
 */
export const ProfileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {boolean} [revixRoundUp] 
         * @param {Array<string>} [acceptedTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate: async (revixRoundUp?: boolean, acceptedTerms?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/activate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (revixRoundUp !== undefined) {
                localVarQueryParameter['revixRoundUp'] = revixRoundUp;
            }

            if (acceptedTerms) {
                acceptedTerms.forEach((element) => {
                    localVarFormParams.append('acceptedTerms', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpActivateRequest} [otpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateEmailOtp: async (otpActivateRequest?: OtpActivateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/activateEmailOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpActivateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpActivateRequest} [otpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSmsOtp: async (otpActivateRequest?: OtpActivateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/activateSmsOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpActivateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TotpActivateRequest} [totpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTotp: async (totpActivateRequest?: TotpActivateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/activateTotp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(totpActivateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeEmailRequest} [changeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail: async (changeEmailRequest?: ChangeEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/changeEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [totp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailVerify: async (token?: string, totp?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/changeEmail/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }

            if (totp !== undefined) {
                localVarQueryParameter['totp'] = totp;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword: async (_2fa?: string, otpFlowTypeCode?: string, changePasswordRequest?: ChangePasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/changePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (_2fa != null) {
                localVarHeaderParameter['2fa'] = String(_2fa);
            }

            if (otpFlowTypeCode != null) {
                localVarHeaderParameter['otpFlowTypeCode'] = String(otpFlowTypeCode);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEmailOtp: async (otpDeactivateRequest?: OtpDeactivateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/deactivateEmailOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpDeactivateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateSmsOtp: async (otpDeactivateRequest?: OtpDeactivateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/deactivateSmsOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpDeactivateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableLoginNotification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/loginNotification/disable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TotpDisableRequest} [totpDisableRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTotp: async (totpDisableRequest?: TotpDisableRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/disableTotp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(totpDisableRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableLoginNotification: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/loginNotification/enable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword: async (forgotPasswordRequest?: ForgotPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/forgotPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(forgotPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpInitiateEmailRequest} [otpInitiateEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailOtp: async (otpInitiateEmailRequest?: OtpInitiateEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/initiateEmailOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpInitiateEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpInitiateRequest} [otpInitiateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSmsOtp: async (otpInitiateRequest?: OtpInitiateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/initiateSmsOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpInitiateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LinkWithSsoRequestDto} [linkWithSsoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkWithProvider: async (linkWithSsoRequestDto?: LinkWithSsoRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/linkWithProvider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(linkWithSsoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMethods: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/loginMethods`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterRequestDto} [registerRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register: async (registerRequestDto?: RegisterRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTotp: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/registerTotp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterWithSsoRequestDto} [registerWithSsoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWithProvider: async (registerWithSsoRequestDto?: RegisterWithSsoRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/registerWithProvider`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerWithSsoRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendRegistrationEmail: async (email?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/resendRegistrationEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (resetPasswordRequest?: ResetPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/resetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpSendEmailRequest} [otpSendEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailOtp: async (otpSendEmailRequest?: OtpSendEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/sendEmailOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpSendEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {OtpSendSmsRequest} [otpSendSmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSmsOtp: async (otpSendSmsRequest?: OtpSendSmsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/sendSmsOtp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpSendSmsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProfileUpdateDto} [profileUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetails: async (profileUpdateDto?: ProfileUpdateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/updateDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileUpdateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProfileHearAboutDto} [profileHearAboutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHearAbout: async (profileHearAboutDto?: ProfileHearAboutDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/updateHearAbout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(profileHearAboutDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CredentialDto} [credentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailToken: async (credentialDto?: CredentialDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/validateEmailToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(credentialDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PromoCodeRequest} [promoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePromoCode: async (promoCodeRequest?: PromoCodeRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile/validatePromoCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(promoCodeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileApi - functional programming interface
 * @export
 */
export const ProfileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {boolean} [revixRoundUp] 
         * @param {Array<string>} [acceptedTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activate(revixRoundUp?: boolean, acceptedTerms?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activate(revixRoundUp, acceptedTerms, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.activate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpActivateRequest} [otpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateEmailOtp(otpActivateRequest?: OtpActivateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateEmailOtp(otpActivateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.activateEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpActivateRequest} [otpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateSmsOtp(otpActivateRequest?: OtpActivateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateSmsOtp(otpActivateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.activateSmsOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TotpActivateRequest} [totpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async activateTotp(totpActivateRequest?: TotpActivateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.activateTotp(totpActivateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.activateTotp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ChangeEmailRequest} [changeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmail(changeEmailRequest?: ChangeEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmail(changeEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.changeEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [totp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeEmailVerify(token?: string, totp?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeEmailVerify(token, totp, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.changeEmailVerify']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePassword(_2fa?: string, otpFlowTypeCode?: string, changePasswordRequest?: ChangePasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePassword(_2fa, otpFlowTypeCode, changePasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.changePassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateEmailOtp(otpDeactivateRequest?: OtpDeactivateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateEmailOtp(otpDeactivateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.deactivateEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateSmsOtp(otpDeactivateRequest?: OtpDeactivateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateSmsOtp(otpDeactivateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.deactivateSmsOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableLoginNotification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableLoginNotification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.disableLoginNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {TotpDisableRequest} [totpDisableRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async disableTotp(totpDisableRequest?: TotpDisableRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.disableTotp(totpDisableRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.disableTotp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async enableLoginNotification(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.enableLoginNotification(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.enableLoginNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async forgotPassword(forgotPasswordRequest?: ForgotPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.forgotPassword(forgotPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.forgotPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async get(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.get(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.get']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpInitiateEmailRequest} [otpInitiateEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateEmailOtp(otpInitiateEmailRequest?: OtpInitiateEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateEmailOtp(otpInitiateEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.initiateEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpInitiateRequest} [otpInitiateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateSmsOtp(otpInitiateRequest?: OtpInitiateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateSmsOtp(otpInitiateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.initiateSmsOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {LinkWithSsoRequestDto} [linkWithSsoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async linkWithProvider(linkWithSsoRequestDto?: LinkWithSsoRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.linkWithProvider(linkWithSsoRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.linkWithProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginMethods(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<LoginMethodDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginMethods(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.loginMethods']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterRequestDto} [registerRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async register(registerRequestDto?: RegisterRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.register(registerRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.register']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerTotp(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerTotp(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.registerTotp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RegisterWithSsoRequestDto} [registerWithSsoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async registerWithProvider(registerWithSsoRequestDto?: RegisterWithSsoRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.registerWithProvider(registerWithSsoRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.registerWithProvider']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendRegistrationEmail(email?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendRegistrationEmail(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.resendRegistrationEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(resetPasswordRequest?: ResetPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AccessTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(resetPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpSendEmailRequest} [otpSendEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendEmailOtp(otpSendEmailRequest?: OtpSendEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendEmailOtp(otpSendEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.sendEmailOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {OtpSendSmsRequest} [otpSendSmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendSmsOtp(otpSendSmsRequest?: OtpSendSmsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendSmsOtp(otpSendSmsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.sendSmsOtp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async status(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileStatusDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.status(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.status']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProfileUpdateDto} [profileUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDetails(profileUpdateDto?: ProfileUpdateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDetails(profileUpdateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ProfileHearAboutDto} [profileHearAboutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHearAbout(profileHearAboutDto?: ProfileHearAboutDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHearAbout(profileHearAboutDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.updateHearAbout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CredentialDto} [credentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateEmailToken(credentialDto?: CredentialDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuthResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateEmailToken(credentialDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.validateEmailToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {PromoCodeRequest} [promoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validatePromoCode(promoCodeRequest?: PromoCodeRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PromoCodeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validatePromoCode(promoCodeRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfileApi.validatePromoCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfileApi - factory interface
 * @export
 */
export const ProfileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileApiFp(configuration)
    return {
        /**
         * 
         * @param {boolean} [revixRoundUp] 
         * @param {Array<string>} [acceptedTerms] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate(revixRoundUp?: boolean, acceptedTerms?: Array<string>, options?: any): AxiosPromise<ProfileStatusDto> {
            return localVarFp.activate(revixRoundUp, acceptedTerms, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpActivateRequest} [otpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateEmailOtp(otpActivateRequest?: OtpActivateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.activateEmailOtp(otpActivateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpActivateRequest} [otpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateSmsOtp(otpActivateRequest?: OtpActivateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.activateSmsOtp(otpActivateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TotpActivateRequest} [totpActivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateTotp(totpActivateRequest?: TotpActivateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.activateTotp(totpActivateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ChangeEmailRequest} [changeEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmail(changeEmailRequest?: ChangeEmailRequest, options?: any): AxiosPromise<ResultDto> {
            return localVarFp.changeEmail(changeEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [token] 
         * @param {string} [totp] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeEmailVerify(token?: string, totp?: string, options?: any): AxiosPromise<AccessTokenDto> {
            return localVarFp.changeEmailVerify(token, totp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
         * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePassword(_2fa?: string, otpFlowTypeCode?: string, changePasswordRequest?: ChangePasswordRequest, options?: any): AxiosPromise<ResultDto> {
            return localVarFp.changePassword(_2fa, otpFlowTypeCode, changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEmailOtp(otpDeactivateRequest?: OtpDeactivateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deactivateEmailOtp(otpDeactivateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateSmsOtp(otpDeactivateRequest?: OtpDeactivateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.deactivateSmsOtp(otpDeactivateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableLoginNotification(options?: any): AxiosPromise<Profile> {
            return localVarFp.disableLoginNotification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TotpDisableRequest} [totpDisableRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        disableTotp(totpDisableRequest?: TotpDisableRequest, options?: any): AxiosPromise<void> {
            return localVarFp.disableTotp(totpDisableRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableLoginNotification(options?: any): AxiosPromise<Profile> {
            return localVarFp.enableLoginNotification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        forgotPassword(forgotPasswordRequest?: ForgotPasswordRequest, options?: any): AxiosPromise<void> {
            return localVarFp.forgotPassword(forgotPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options?: any): AxiosPromise<Profile> {
            return localVarFp.get(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpInitiateEmailRequest} [otpInitiateEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateEmailOtp(otpInitiateEmailRequest?: OtpInitiateEmailRequest, options?: any): AxiosPromise<void> {
            return localVarFp.initiateEmailOtp(otpInitiateEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpInitiateRequest} [otpInitiateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateSmsOtp(otpInitiateRequest?: OtpInitiateRequest, options?: any): AxiosPromise<void> {
            return localVarFp.initiateSmsOtp(otpInitiateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LinkWithSsoRequestDto} [linkWithSsoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        linkWithProvider(linkWithSsoRequestDto?: LinkWithSsoRequestDto, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.linkWithProvider(linkWithSsoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginMethods(options?: any): AxiosPromise<Array<LoginMethodDto>> {
            return localVarFp.loginMethods(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterRequestDto} [registerRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        register(registerRequestDto?: RegisterRequestDto, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.register(registerRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTotp(options?: any): AxiosPromise<void> {
            return localVarFp.registerTotp(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterWithSsoRequestDto} [registerWithSsoRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerWithProvider(registerWithSsoRequestDto?: RegisterWithSsoRequestDto, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.registerWithProvider(registerWithSsoRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendRegistrationEmail(email?: string, options?: any): AxiosPromise<BaseUserResponseDto> {
            return localVarFp.resendRegistrationEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(resetPasswordRequest?: ResetPasswordRequest, options?: any): AxiosPromise<AccessTokenDto> {
            return localVarFp.resetPassword(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpSendEmailRequest} [otpSendEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendEmailOtp(otpSendEmailRequest?: OtpSendEmailRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendEmailOtp(otpSendEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OtpSendSmsRequest} [otpSendSmsRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendSmsOtp(otpSendSmsRequest?: OtpSendSmsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.sendSmsOtp(otpSendSmsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        status(options?: any): AxiosPromise<ProfileStatusDto> {
            return localVarFp.status(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileUpdateDto} [profileUpdateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDetails(profileUpdateDto?: ProfileUpdateDto, options?: any): AxiosPromise<Profile> {
            return localVarFp.updateDetails(profileUpdateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProfileHearAboutDto} [profileHearAboutDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHearAbout(profileHearAboutDto?: ProfileHearAboutDto, options?: any): AxiosPromise<Profile> {
            return localVarFp.updateHearAbout(profileHearAboutDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CredentialDto} [credentialDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateEmailToken(credentialDto?: CredentialDto, options?: any): AxiosPromise<AuthResponse> {
            return localVarFp.validateEmailToken(credentialDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PromoCodeRequest} [promoCodeRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validatePromoCode(promoCodeRequest?: PromoCodeRequest, options?: any): AxiosPromise<PromoCodeResponse> {
            return localVarFp.validatePromoCode(promoCodeRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileApi - object-oriented interface
 * @export
 * @class ProfileApi
 * @extends {BaseAPI}
 */
export class ProfileApi extends BaseAPI {
    /**
     * 
     * @param {boolean} [revixRoundUp] 
     * @param {Array<string>} [acceptedTerms] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public activate(revixRoundUp?: boolean, acceptedTerms?: Array<string>, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).activate(revixRoundUp, acceptedTerms, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpActivateRequest} [otpActivateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public activateEmailOtp(otpActivateRequest?: OtpActivateRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).activateEmailOtp(otpActivateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpActivateRequest} [otpActivateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public activateSmsOtp(otpActivateRequest?: OtpActivateRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).activateSmsOtp(otpActivateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TotpActivateRequest} [totpActivateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public activateTotp(totpActivateRequest?: TotpActivateRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).activateTotp(totpActivateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ChangeEmailRequest} [changeEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public changeEmail(changeEmailRequest?: ChangeEmailRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).changeEmail(changeEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [token] 
     * @param {string} [totp] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public changeEmailVerify(token?: string, totp?: string, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).changeEmailVerify(token, totp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [_2fa] 2FA PIN - required if 2FA enabled
     * @param {string} [otpFlowTypeCode] OTP Flow Type Code - required if SMS OTP enabled
     * @param {ChangePasswordRequest} [changePasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public changePassword(_2fa?: string, otpFlowTypeCode?: string, changePasswordRequest?: ChangePasswordRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).changePassword(_2fa, otpFlowTypeCode, changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public deactivateEmailOtp(otpDeactivateRequest?: OtpDeactivateRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).deactivateEmailOtp(otpDeactivateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpDeactivateRequest} [otpDeactivateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public deactivateSmsOtp(otpDeactivateRequest?: OtpDeactivateRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).deactivateSmsOtp(otpDeactivateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public disableLoginNotification(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).disableLoginNotification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TotpDisableRequest} [totpDisableRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public disableTotp(totpDisableRequest?: TotpDisableRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).disableTotp(totpDisableRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public enableLoginNotification(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).enableLoginNotification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ForgotPasswordRequest} [forgotPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public forgotPassword(forgotPasswordRequest?: ForgotPasswordRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).forgotPassword(forgotPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public get(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).get(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpInitiateEmailRequest} [otpInitiateEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public initiateEmailOtp(otpInitiateEmailRequest?: OtpInitiateEmailRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).initiateEmailOtp(otpInitiateEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpInitiateRequest} [otpInitiateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public initiateSmsOtp(otpInitiateRequest?: OtpInitiateRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).initiateSmsOtp(otpInitiateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LinkWithSsoRequestDto} [linkWithSsoRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public linkWithProvider(linkWithSsoRequestDto?: LinkWithSsoRequestDto, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).linkWithProvider(linkWithSsoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public loginMethods(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).loginMethods(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterRequestDto} [registerRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public register(registerRequestDto?: RegisterRequestDto, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).register(registerRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public registerTotp(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).registerTotp(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterWithSsoRequestDto} [registerWithSsoRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public registerWithProvider(registerWithSsoRequestDto?: RegisterWithSsoRequestDto, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).registerWithProvider(registerWithSsoRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public resendRegistrationEmail(email?: string, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).resendRegistrationEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ResetPasswordRequest} [resetPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public resetPassword(resetPasswordRequest?: ResetPasswordRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).resetPassword(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpSendEmailRequest} [otpSendEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public sendEmailOtp(otpSendEmailRequest?: OtpSendEmailRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).sendEmailOtp(otpSendEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OtpSendSmsRequest} [otpSendSmsRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public sendSmsOtp(otpSendSmsRequest?: OtpSendSmsRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).sendSmsOtp(otpSendSmsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public status(options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).status(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileUpdateDto} [profileUpdateDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateDetails(profileUpdateDto?: ProfileUpdateDto, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateDetails(profileUpdateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProfileHearAboutDto} [profileHearAboutDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public updateHearAbout(profileHearAboutDto?: ProfileHearAboutDto, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).updateHearAbout(profileHearAboutDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CredentialDto} [credentialDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public validateEmailToken(credentialDto?: CredentialDto, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).validateEmailToken(credentialDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PromoCodeRequest} [promoCodeRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileApi
     */
    public validatePromoCode(promoCodeRequest?: PromoCodeRequest, options?: RawAxiosRequestConfig) {
        return ProfileApiFp(this.configuration).validatePromoCode(promoCodeRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RatesV2Api - axios parameter creator
 * @export
 */
export const RatesV2ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [displayCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsRates: async (displayCurrency?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rates/v2/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (displayCurrency !== undefined) {
                localVarQueryParameter['displayCurrency'] = displayCurrency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [companyCode] 
         * @param {string} [targetProductCode] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisplayRates: async (companyCode?: string, targetProductCode?: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rates/v2/displayable-rates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (companyCode !== undefined) {
                localVarQueryParameter['companyCode'] = companyCode;
            }

            if (targetProductCode !== undefined) {
                localVarQueryParameter['targetProductCode'] = targetProductCode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RatesV2Api - functional programming interface
 * @export
 */
export const RatesV2ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RatesV2ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [displayCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableProductsRates(displayCurrency?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableProductsRates(displayCurrency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RatesV2Api.getAvailableProductsRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [companyCode] 
         * @param {string} [targetProductCode] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDisplayRates(companyCode?: string, targetProductCode?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDisplayRates(companyCode, targetProductCode, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RatesV2Api.getDisplayRates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RatesV2Api - factory interface
 * @export
 */
export const RatesV2ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RatesV2ApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [displayCurrency] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableProductsRates(displayCurrency?: string, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getAvailableProductsRates(displayCurrency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [companyCode] 
         * @param {string} [targetProductCode] 
         * @param {Array<string>} [requestBody] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDisplayRates(companyCode?: string, targetProductCode?: string, requestBody?: Array<string>, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getDisplayRates(companyCode, targetProductCode, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RatesV2Api - object-oriented interface
 * @export
 * @class RatesV2Api
 * @extends {BaseAPI}
 */
export class RatesV2Api extends BaseAPI {
    /**
     * 
     * @param {string} [displayCurrency] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatesV2Api
     */
    public getAvailableProductsRates(displayCurrency?: string, options?: RawAxiosRequestConfig) {
        return RatesV2ApiFp(this.configuration).getAvailableProductsRates(displayCurrency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [companyCode] 
     * @param {string} [targetProductCode] 
     * @param {Array<string>} [requestBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RatesV2Api
     */
    public getDisplayRates(companyCode?: string, targetProductCode?: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return RatesV2ApiFp(this.configuration).getDisplayRates(companyCode, targetProductCode, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RecurringBuyApi - axios parameter creator
 * @export
 */
export const RecurringBuyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancels (deletes) a recurring buy. It cannot be reactivated
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRecurringBuy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelRecurringBuy', 'id', id)
            const localVarPath = `/recurring-buys/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Creates a new recurring buy for the user given the specified parameters
         * @param {CreateRecurringBuyRequest} [createRecurringBuyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurringBuy: async (createRecurringBuyRequest?: CreateRecurringBuyRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recurring-buys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createRecurringBuyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets details about a specified recurring buy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurringBuyById: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getRecurringBuyById', 'id', id)
            const localVarPath = `/recurring-buys/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets details of all recurring buys of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurringBuys: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/recurring-buys`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pauses a specified recurring buy. It will not be executed until resumed
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseRecurringBuy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pauseRecurringBuy', 'id', id)
            const localVarPath = `/recurring-buys/{id}/pause`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resumes a specified recurring buy. It will be executed on the next scheduled date
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRecurringBuy: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('resumeRecurringBuy', 'id', id)
            const localVarPath = `/recurring-buys/{id}/resume`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RecurringBuyApi - functional programming interface
 * @export
 */
export const RecurringBuyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RecurringBuyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancels (deletes) a recurring buy. It cannot be reactivated
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRecurringBuy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRecurringBuy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringBuyApi.cancelRecurringBuy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Creates a new recurring buy for the user given the specified parameters
         * @param {CreateRecurringBuyRequest} [createRecurringBuyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRecurringBuy(createRecurringBuyRequest?: CreateRecurringBuyRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecurringBuyCreateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRecurringBuy(createRecurringBuyRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringBuyApi.createRecurringBuy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets details about a specified recurring buy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecurringBuyById(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RecurringBuyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecurringBuyById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringBuyApi.getRecurringBuyById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets details of all recurring buys of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecurringBuys(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RecurringBuyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecurringBuys(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringBuyApi.getRecurringBuys']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pauses a specified recurring buy. It will not be executed until resumed
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseRecurringBuy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseRecurringBuy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringBuyApi.pauseRecurringBuy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Resumes a specified recurring buy. It will be executed on the next scheduled date
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resumeRecurringBuy(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resumeRecurringBuy(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RecurringBuyApi.resumeRecurringBuy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RecurringBuyApi - factory interface
 * @export
 */
export const RecurringBuyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RecurringBuyApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancels (deletes) a recurring buy. It cannot be reactivated
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRecurringBuy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelRecurringBuy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Creates a new recurring buy for the user given the specified parameters
         * @param {CreateRecurringBuyRequest} [createRecurringBuyRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurringBuy(createRecurringBuyRequest?: CreateRecurringBuyRequest, options?: any): AxiosPromise<RecurringBuyCreateResponse> {
            return localVarFp.createRecurringBuy(createRecurringBuyRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets details about a specified recurring buy
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurringBuyById(id: string, options?: any): AxiosPromise<RecurringBuyResponse> {
            return localVarFp.getRecurringBuyById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets details of all recurring buys of the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecurringBuys(options?: any): AxiosPromise<Array<RecurringBuyResponse>> {
            return localVarFp.getRecurringBuys(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pauses a specified recurring buy. It will not be executed until resumed
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseRecurringBuy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.pauseRecurringBuy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resumes a specified recurring buy. It will be executed on the next scheduled date
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resumeRecurringBuy(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.resumeRecurringBuy(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RecurringBuyApi - object-oriented interface
 * @export
 * @class RecurringBuyApi
 * @extends {BaseAPI}
 */
export class RecurringBuyApi extends BaseAPI {
    /**
     * 
     * @summary Cancels (deletes) a recurring buy. It cannot be reactivated
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringBuyApi
     */
    public cancelRecurringBuy(id: string, options?: RawAxiosRequestConfig) {
        return RecurringBuyApiFp(this.configuration).cancelRecurringBuy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Creates a new recurring buy for the user given the specified parameters
     * @param {CreateRecurringBuyRequest} [createRecurringBuyRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringBuyApi
     */
    public createRecurringBuy(createRecurringBuyRequest?: CreateRecurringBuyRequest, options?: RawAxiosRequestConfig) {
        return RecurringBuyApiFp(this.configuration).createRecurringBuy(createRecurringBuyRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets details about a specified recurring buy
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringBuyApi
     */
    public getRecurringBuyById(id: string, options?: RawAxiosRequestConfig) {
        return RecurringBuyApiFp(this.configuration).getRecurringBuyById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets details of all recurring buys of the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringBuyApi
     */
    public getRecurringBuys(options?: RawAxiosRequestConfig) {
        return RecurringBuyApiFp(this.configuration).getRecurringBuys(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pauses a specified recurring buy. It will not be executed until resumed
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringBuyApi
     */
    public pauseRecurringBuy(id: string, options?: RawAxiosRequestConfig) {
        return RecurringBuyApiFp(this.configuration).pauseRecurringBuy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resumes a specified recurring buy. It will be executed on the next scheduled date
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurringBuyApi
     */
    public resumeRecurringBuy(id: string, options?: RawAxiosRequestConfig) {
        return RecurringBuyApiFp(this.configuration).resumeRecurringBuy(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReferenceApi - axios parameter creator
 * @export
 */
export const ReferenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getAsset', 'code', code)
            const localVarPath = `/references/assets/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountry: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getCountry', 'code', code)
            const localVarPath = `/references/countries/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrency: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('getCurrency', 'code', code)
            const localVarPath = `/references/currencies/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/references/assets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClientApplicationSsos: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/references/clientApplicationSsos`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/references/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCurrencies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/references/currencies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [assetType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestionTemplates: async (type?: string, assetType?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/references/questionTemplates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (assetType !== undefined) {
                localVarQueryParameter['assetType'] = assetType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVasps: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/references/vasps`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReferenceApi - functional programming interface
 * @export
 */
export const ReferenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReferenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAsset(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetAggregateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAsset(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.getAsset']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountry(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Country>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountry(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.getCountry']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrency(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Currency>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrency(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.getCurrency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssets(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AssetAggregateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssets(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.listAssets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listClientApplicationSsos(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ClientApplicationSso>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listClientApplicationSsos(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.listClientApplicationSsos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Country>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.listCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listCurrencies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Currency>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listCurrencies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.listCurrencies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [assetType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listQuestionTemplates(type?: string, assetType?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listQuestionTemplates(type, assetType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.listQuestionTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listVasps(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<VaspDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listVasps(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReferenceApi.listVasps']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReferenceApi - factory interface
 * @export
 */
export const ReferenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReferenceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAsset(code: string, options?: any): AxiosPromise<AssetAggregateDto> {
            return localVarFp.getAsset(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountry(code: string, options?: any): AxiosPromise<Country> {
            return localVarFp.getCountry(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrency(code: string, options?: any): AxiosPromise<Currency> {
            return localVarFp.getCurrency(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssets(options?: any): AxiosPromise<Array<AssetAggregateDto>> {
            return localVarFp.listAssets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClientApplicationSsos(options?: any): AxiosPromise<Array<ClientApplicationSso>> {
            return localVarFp.listClientApplicationSsos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCountries(options?: any): AxiosPromise<Array<Country>> {
            return localVarFp.listCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listCurrencies(options?: any): AxiosPromise<Array<Currency>> {
            return localVarFp.listCurrencies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [type] 
         * @param {string} [assetType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listQuestionTemplates(type?: string, assetType?: string, options?: any): AxiosPromise<Array<QuestionTemplate>> {
            return localVarFp.listQuestionTemplates(type, assetType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listVasps(options?: any): AxiosPromise<Array<VaspDto>> {
            return localVarFp.listVasps(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReferenceApi - object-oriented interface
 * @export
 * @class ReferenceApi
 * @extends {BaseAPI}
 */
export class ReferenceApi extends BaseAPI {
    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public getAsset(code: string, options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).getAsset(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public getCountry(code: string, options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).getCountry(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public getCurrency(code: string, options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).getCurrency(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public listAssets(options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).listAssets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public listClientApplicationSsos(options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).listClientApplicationSsos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public listCountries(options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).listCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public listCurrencies(options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).listCurrencies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [type] 
     * @param {string} [assetType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public listQuestionTemplates(type?: string, assetType?: string, options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).listQuestionTemplates(type, assetType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReferenceApi
     */
    public listVasps(options?: RawAxiosRequestConfig) {
        return ReferenceApiFp(this.configuration).listVasps(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RewardsApi - axios parameter creator
 * @export
 */
export const RewardsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a referral history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralHistory: async (skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralHistoryV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/v2/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardActions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/actions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get detailed data about a customers current rewards
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRewardDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/detailed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardDetailsV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/v2/detailed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the different rewards tiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardTiers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardTiersV2: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/v2/tiers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redeem all of a users rewards for BTC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeem: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/rewards/redeem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RewardsApi - functional programming interface
 * @export
 */
export const RewardsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RewardsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a referral history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralHistory(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralsHistoryDtoPagedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralHistory(skip, take, orderBy, orderByDescending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getReferralHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralHistoryV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReferralHistoryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralHistoryV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getReferralHistoryV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardActions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RewardActionSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardActions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardActions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get detailed data about a customers current rewards
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getRewardDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedRewardDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardDetailsV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RewardsDetailsQueryResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardDetailsV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardDetailsV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the different rewards tiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardTiers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RewardTierDtoOld>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardTiers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardTiers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardTiersV2(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RewardTierDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardTiersV2(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.getRewardTiersV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Redeem all of a users rewards for BTC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async redeem(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeemRewardsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.redeem(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RewardsApi.redeem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RewardsApi - factory interface
 * @export
 */
export const RewardsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RewardsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a referral history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralHistory(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: any): AxiosPromise<ReferralsHistoryDtoPagedList> {
            return localVarFp.getReferralHistory(skip, take, orderBy, orderByDescending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralHistoryV2(options?: any): AxiosPromise<Array<ReferralHistoryDto>> {
            return localVarFp.getReferralHistoryV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardActions(options?: any): AxiosPromise<Array<RewardActionSummaryDto>> {
            return localVarFp.getRewardActions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get detailed data about a customers current rewards
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRewardDetails(options?: any): AxiosPromise<DetailedRewardDetailsDto> {
            return localVarFp.getRewardDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardDetailsV2(options?: any): AxiosPromise<RewardsDetailsQueryResponse> {
            return localVarFp.getRewardDetailsV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the different rewards tiers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardTiers(options?: any): AxiosPromise<Array<RewardTierDtoOld>> {
            return localVarFp.getRewardTiers(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardTiersV2(options?: any): AxiosPromise<Array<RewardTierDto>> {
            return localVarFp.getRewardTiersV2(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redeem all of a users rewards for BTC
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeem(options?: any): AxiosPromise<RedeemRewardsResponseDto> {
            return localVarFp.redeem(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RewardsApi - object-oriented interface
 * @export
 * @class RewardsApi
 * @extends {BaseAPI}
 */
export class RewardsApi extends BaseAPI {
    /**
     * 
     * @summary Get a referral history for a customer, ordering will default to property \"DateTime\" descending
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getReferralHistory(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getReferralHistory(skip, take, orderBy, orderByDescending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getReferralHistoryV2(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getReferralHistoryV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardActions(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardActions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get detailed data about a customers current rewards
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardDetails(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardDetailsV2(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardDetailsV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the different rewards tiers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardTiers(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardTiers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public getRewardTiersV2(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).getRewardTiersV2(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redeem all of a users rewards for BTC
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RewardsApi
     */
    public redeem(options?: RawAxiosRequestConfig) {
        return RewardsApiFp(this.configuration).redeem(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SegmentsApi - axios parameter creator
 * @export
 */
export const SegmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of all features
         * @param {string} segmentCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCustomerInSegment: async (segmentCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'segmentCode' is not null or undefined
            assertParamExists('isCustomerInSegment', 'segmentCode', segmentCode)
            const localVarPath = `/segments/{segmentCode}`
                .replace(`{${"segmentCode"}}`, encodeURIComponent(String(segmentCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SegmentsApi - functional programming interface
 * @export
 */
export const SegmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SegmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of all features
         * @param {string} segmentCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isCustomerInSegment(segmentCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isCustomerInSegment(segmentCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SegmentsApi.isCustomerInSegment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SegmentsApi - factory interface
 * @export
 */
export const SegmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SegmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of all features
         * @param {string} segmentCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCustomerInSegment(segmentCode: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.isCustomerInSegment(segmentCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SegmentsApi - object-oriented interface
 * @export
 * @class SegmentsApi
 * @extends {BaseAPI}
 */
export class SegmentsApi extends BaseAPI {
    /**
     * 
     * @summary Return list of all features
     * @param {string} segmentCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SegmentsApi
     */
    public isCustomerInSegment(segmentCode: string, options?: RawAxiosRequestConfig) {
        return SegmentsApiFp(this.configuration).isCustomerInSegment(segmentCode, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SellApi - axios parameter creator
 * @export
 */
export const SellApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all products that the selected product can be sold to by customer
         * @param {string} sourceProductCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts: async (sourceProductCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sourceProductCode' is not null or undefined
            assertParamExists('availableProducts', 'sourceProductCode', sourceProductCode)
            const localVarPath = `/sell/{sourceProductCode}/products`
                .replace(`{${"sourceProductCode"}}`, encodeURIComponent(String(sourceProductCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cancel a pending sell trade order
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sell/quote/cancel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm and complete the sell using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sell/quote/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sell quote data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellQuote: async (fromProductCode?: string, toProductCode?: string, amount?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sell/quote/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromProductCode !== undefined) {
                localVarQueryParameter['fromProductCode'] = fromProductCode;
            }

            if (toProductCode !== undefined) {
                localVarQueryParameter['toProductCode'] = toProductCode;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get sell quote selection data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellQuoteData: async (fromProductCode?: string, toProductCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sell/quote/selection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (fromProductCode !== undefined) {
                localVarQueryParameter['fromProductCode'] = fromProductCode;
            }

            if (toProductCode !== undefined) {
                localVarQueryParameter['toProductCode'] = toProductCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Refresh the sell quote using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh: async (orderId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sell/quote/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SellApi - functional programming interface
 * @export
 */
export const SellApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SellApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all products that the selected product can be sold to by customer
         * @param {string} sourceProductCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableProducts(sourceProductCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TradeProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableProducts(sourceProductCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SellApi.availableProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Cancel a pending sell trade order
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancel(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SellApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm and complete the sell using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async complete(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.complete(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SellApi.complete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sell quote data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSellQuote(fromProductCode?: string, toProductCode?: string, amount?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeQuoteDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSellQuote(fromProductCode, toProductCode, amount, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SellApi.getSellQuote']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get sell quote selection data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSellQuoteData(fromProductCode?: string, toProductCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeQuoteSelectionDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSellQuoteData(fromProductCode, toProductCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SellApi.getSellQuoteData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Refresh the sell quote using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async refresh(orderId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RFQTradeQuoteDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.refresh(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SellApi.refresh']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SellApi - factory interface
 * @export
 */
export const SellApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SellApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all products that the selected product can be sold to by customer
         * @param {string} sourceProductCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts(sourceProductCode: string, options?: any): AxiosPromise<Array<TradeProductDto>> {
            return localVarFp.availableProducts(sourceProductCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cancel a pending sell trade order
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancel(orderId?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm and complete the sell using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        complete(orderId?: string, options?: any): AxiosPromise<RFQTradeResultDto> {
            return localVarFp.complete(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sell quote data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {number} [amount] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellQuote(fromProductCode?: string, toProductCode?: string, amount?: number, options?: any): AxiosPromise<RFQTradeQuoteDataDto> {
            return localVarFp.getSellQuote(fromProductCode, toProductCode, amount, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get sell quote selection data
         * @param {string} [fromProductCode] 
         * @param {string} [toProductCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSellQuoteData(fromProductCode?: string, toProductCode?: string, options?: any): AxiosPromise<RFQTradeQuoteSelectionDataDto> {
            return localVarFp.getSellQuoteData(fromProductCode, toProductCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Refresh the sell quote using the order id
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refresh(orderId?: string, options?: any): AxiosPromise<RFQTradeQuoteDataDto> {
            return localVarFp.refresh(orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SellApi - object-oriented interface
 * @export
 * @class SellApi
 * @extends {BaseAPI}
 */
export class SellApi extends BaseAPI {
    /**
     * 
     * @summary Get all products that the selected product can be sold to by customer
     * @param {string} sourceProductCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellApi
     */
    public availableProducts(sourceProductCode: string, options?: RawAxiosRequestConfig) {
        return SellApiFp(this.configuration).availableProducts(sourceProductCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cancel a pending sell trade order
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellApi
     */
    public cancel(orderId?: string, options?: RawAxiosRequestConfig) {
        return SellApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm and complete the sell using the order id
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellApi
     */
    public complete(orderId?: string, options?: RawAxiosRequestConfig) {
        return SellApiFp(this.configuration).complete(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sell quote data
     * @param {string} [fromProductCode] 
     * @param {string} [toProductCode] 
     * @param {number} [amount] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellApi
     */
    public getSellQuote(fromProductCode?: string, toProductCode?: string, amount?: number, options?: RawAxiosRequestConfig) {
        return SellApiFp(this.configuration).getSellQuote(fromProductCode, toProductCode, amount, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get sell quote selection data
     * @param {string} [fromProductCode] 
     * @param {string} [toProductCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellApi
     */
    public getSellQuoteData(fromProductCode?: string, toProductCode?: string, options?: RawAxiosRequestConfig) {
        return SellApiFp(this.configuration).getSellQuoteData(fromProductCode, toProductCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Refresh the sell quote using the order id
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SellApi
     */
    public refresh(orderId?: string, options?: RawAxiosRequestConfig) {
        return SellApiFp(this.configuration).refresh(orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SmsSignUpApi - axios parameter creator
 * @export
 */
export const SmsSignUpApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Send an sms with a sign up link
         * @param {string} [mobileNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpSms: async (mobileNumber?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/smsSignup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (mobileNumber !== undefined) {
                localVarQueryParameter['mobileNumber'] = mobileNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SmsSignUpApi - functional programming interface
 * @export
 */
export const SmsSignUpApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SmsSignUpApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Send an sms with a sign up link
         * @param {string} [mobileNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signUpSms(mobileNumber?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signUpSms(mobileNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SmsSignUpApi.signUpSms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SmsSignUpApi - factory interface
 * @export
 */
export const SmsSignUpApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SmsSignUpApiFp(configuration)
    return {
        /**
         * 
         * @summary Send an sms with a sign up link
         * @param {string} [mobileNumber] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpSms(mobileNumber?: string, options?: any): AxiosPromise<void> {
            return localVarFp.signUpSms(mobileNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SmsSignUpApi - object-oriented interface
 * @export
 * @class SmsSignUpApi
 * @extends {BaseAPI}
 */
export class SmsSignUpApi extends BaseAPI {
    /**
     * 
     * @summary Send an sms with a sign up link
     * @param {string} [mobileNumber] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SmsSignUpApi
     */
    public signUpSms(mobileNumber?: string, options?: RawAxiosRequestConfig) {
        return SmsSignUpApiFp(this.configuration).signUpSms(mobileNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TermApi - axios parameter creator
 * @export
 */
export const TermApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} termCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerm: async (termCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'termCode' is not null or undefined
            assertParamExists('acceptTerm', 'termCode', termCode)
            const localVarPath = `/terms/{termCode}`
                .replace(`{${"termCode"}}`, encodeURIComponent(String(termCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTerms: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/terms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TermApi - functional programming interface
 * @export
 */
export const TermApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TermApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} termCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTerm(termCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTerm(termCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TermApi.acceptTerm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTerms(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserTermDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTerms(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TermApi.getUserTerms']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TermApi - factory interface
 * @export
 */
export const TermApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TermApiFp(configuration)
    return {
        /**
         * 
         * @param {string} termCode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTerm(termCode: string, options?: any): AxiosPromise<void> {
            return localVarFp.acceptTerm(termCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTerms(options?: any): AxiosPromise<Array<UserTermDto>> {
            return localVarFp.getUserTerms(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TermApi - object-oriented interface
 * @export
 * @class TermApi
 * @extends {BaseAPI}
 */
export class TermApi extends BaseAPI {
    /**
     * 
     * @param {string} termCode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public acceptTerm(termCode: string, options?: RawAxiosRequestConfig) {
        return TermApiFp(this.configuration).acceptTerm(termCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TermApi
     */
    public getUserTerms(options?: RawAxiosRequestConfig) {
        return TermApiFp(this.configuration).getUserTerms(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionHistoryApi - axios parameter creator
 * @export
 */
export const TransactionHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a completed deposits and withdrawals for a customer, ordering will default to property \"DateTime\" descending
         * @param {GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedDepositsWithdrawalsAsync: async (orderType?: GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactionHistory/depositWithdrawals/completed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
         * @param {GetPendingOrdersOrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrders: async (orderType?: GetPendingOrdersOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactionHistory/orders/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
         * @param {GetPendingOrders0OrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrders_1: async (orderType?: GetPendingOrders0OrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactionHistory/depositWithdrawals/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRebalanceTransactionBreakdownAsync: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('getRebalanceTransactionBreakdownAsync', 'orderId', orderId)
            const localVarPath = `/transactionHistory/transaction/{orderId}/rebalanceBreakdown`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a rewards history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardHistoryAsync: async (skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactionHistory/rewards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transaction history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {GetTransactionHistoryAsyncOrderTypeEnum} [orderType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistoryAsync: async (skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetTransactionHistoryAsyncOrderTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactionHistory/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get vault transaction history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {GetVaultTransactionHistoryAsyncOrderTypeEnum} [orderType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultTransactionHistoryAsync: async (skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetVaultTransactionHistoryAsyncOrderTypeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/transactionHistory/vault`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }

            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (orderByDescending !== undefined) {
                localVarQueryParameter['orderByDescending'] = orderByDescending;
            }

            if (orderType !== undefined) {
                localVarQueryParameter['orderType'] = orderType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionHistoryApi - functional programming interface
 * @export
 */
export const TransactionHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a completed deposits and withdrawals for a customer, ordering will default to property \"DateTime\" descending
         * @param {GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompletedDepositsWithdrawalsAsync(orderType?: GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedListOfCompletedDepositsWithdrawalsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompletedDepositsWithdrawalsAsync(orderType, skip, take, orderBy, orderByDescending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getCompletedDepositsWithdrawalsAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
         * @param {GetPendingOrdersOrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingOrders(orderType?: GetPendingOrdersOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedListOfPendingOrdersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingOrders(orderType, skip, take, orderBy, orderByDescending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getPendingOrders']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
         * @param {GetPendingOrders0OrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingOrders_1(orderType?: GetPendingOrders0OrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedListOfPendingOrdersDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingOrders_1(orderType, skip, take, orderBy, orderByDescending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getPendingOrders_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRebalanceTransactionBreakdownAsync(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RebalanceBreakdownDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRebalanceTransactionBreakdownAsync(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getRebalanceTransactionBreakdownAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a rewards history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRewardHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedListOfDetailedRewardsHistoryItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRewardHistoryAsync(skip, take, orderBy, orderByDescending, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getRewardHistoryAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transaction history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {GetTransactionHistoryAsyncOrderTypeEnum} [orderType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetTransactionHistoryAsyncOrderTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedListOfCompletedTransactionHistoryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistoryAsync(skip, take, orderBy, orderByDescending, orderType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getTransactionHistoryAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get vault transaction history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {GetVaultTransactionHistoryAsyncOrderTypeEnum} [orderType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVaultTransactionHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetVaultTransactionHistoryAsyncOrderTypeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagedListOfCompletedDeFiTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVaultTransactionHistoryAsync(skip, take, orderBy, orderByDescending, orderType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionHistoryApi.getVaultTransactionHistoryAsync']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionHistoryApi - factory interface
 * @export
 */
export const TransactionHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionHistoryApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a completed deposits and withdrawals for a customer, ordering will default to property \"DateTime\" descending
         * @param {GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompletedDepositsWithdrawalsAsync(orderType?: GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: any): AxiosPromise<PagedListOfCompletedDepositsWithdrawalsDto> {
            return localVarFp.getCompletedDepositsWithdrawalsAsync(orderType, skip, take, orderBy, orderByDescending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
         * @param {GetPendingOrdersOrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrders(orderType?: GetPendingOrdersOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: any): AxiosPromise<PagedListOfPendingOrdersDto> {
            return localVarFp.getPendingOrders(orderType, skip, take, orderBy, orderByDescending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
         * @param {GetPendingOrders0OrderTypeEnum} [orderType] 
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingOrders_1(orderType?: GetPendingOrders0OrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: any): AxiosPromise<PagedListOfPendingOrdersDto> {
            return localVarFp.getPendingOrders_1(orderType, skip, take, orderBy, orderByDescending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRebalanceTransactionBreakdownAsync(orderId: string, options?: any): AxiosPromise<Array<RebalanceBreakdownDto>> {
            return localVarFp.getRebalanceTransactionBreakdownAsync(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a rewards history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRewardHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: any): AxiosPromise<PagedListOfDetailedRewardsHistoryItemDto> {
            return localVarFp.getRewardHistoryAsync(skip, take, orderBy, orderByDescending, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transaction history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {GetTransactionHistoryAsyncOrderTypeEnum} [orderType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetTransactionHistoryAsyncOrderTypeEnum, options?: any): AxiosPromise<PagedListOfCompletedTransactionHistoryDto> {
            return localVarFp.getTransactionHistoryAsync(skip, take, orderBy, orderByDescending, orderType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get vault transaction history for a customer, ordering will default to property \"DateTime\" descending
         * @param {number} [skip] 
         * @param {number} [take] 
         * @param {string} [orderBy] 
         * @param {string} [orderByDescending] 
         * @param {GetVaultTransactionHistoryAsyncOrderTypeEnum} [orderType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVaultTransactionHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetVaultTransactionHistoryAsyncOrderTypeEnum, options?: any): AxiosPromise<PagedListOfCompletedDeFiTransactionDto> {
            return localVarFp.getVaultTransactionHistoryAsync(skip, take, orderBy, orderByDescending, orderType, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TransactionHistoryApi - object-oriented interface
 * @export
 * @class TransactionHistoryApi
 * @extends {BaseAPI}
 */
export class TransactionHistoryApi extends BaseAPI {
    /**
     * 
     * @summary Get a completed deposits and withdrawals for a customer, ordering will default to property \"DateTime\" descending
     * @param {GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum} [orderType] 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getCompletedDepositsWithdrawalsAsync(orderType?: GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getCompletedDepositsWithdrawalsAsync(orderType, skip, take, orderBy, orderByDescending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
     * @param {GetPendingOrdersOrderTypeEnum} [orderType] 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getPendingOrders(orderType?: GetPendingOrdersOrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getPendingOrders(orderType, skip, take, orderBy, orderByDescending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get pending deposits, withdrawals and vault orders for a customer, ordering will default to property \"DateTime\"  descending
     * @param {GetPendingOrders0OrderTypeEnum} [orderType] 
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getPendingOrders_1(orderType?: GetPendingOrders0OrderTypeEnum, skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getPendingOrders_1(orderType, skip, take, orderBy, orderByDescending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getRebalanceTransactionBreakdownAsync(orderId: string, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getRebalanceTransactionBreakdownAsync(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a rewards history for a customer, ordering will default to property \"DateTime\" descending
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getRewardHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getRewardHistoryAsync(skip, take, orderBy, orderByDescending, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transaction history for a customer, ordering will default to property \"DateTime\" descending
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {GetTransactionHistoryAsyncOrderTypeEnum} [orderType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getTransactionHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetTransactionHistoryAsyncOrderTypeEnum, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getTransactionHistoryAsync(skip, take, orderBy, orderByDescending, orderType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get vault transaction history for a customer, ordering will default to property \"DateTime\" descending
     * @param {number} [skip] 
     * @param {number} [take] 
     * @param {string} [orderBy] 
     * @param {string} [orderByDescending] 
     * @param {GetVaultTransactionHistoryAsyncOrderTypeEnum} [orderType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionHistoryApi
     */
    public getVaultTransactionHistoryAsync(skip?: number, take?: number, orderBy?: string, orderByDescending?: string, orderType?: GetVaultTransactionHistoryAsyncOrderTypeEnum, options?: RawAxiosRequestConfig) {
        return TransactionHistoryApiFp(this.configuration).getVaultTransactionHistoryAsync(skip, take, orderBy, orderByDescending, orderType, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum = {
    All: 'All',
    BankDeposit: 'BankDeposit',
    CryptoDeposit: 'CryptoDeposit',
    BankWithdrawal: 'BankWithdrawal',
    CryptoWithdrawal: 'CryptoWithdrawal',
    AddCryptoFunds: 'AddCryptoFunds',
    AddFiatFunds: 'AddFiatFunds',
    RemoveCryptoFunds: 'RemoveCryptoFunds',
    RemoveFiatFunds: 'RemoveFiatFunds',
    ReferralDeposit: 'ReferralDeposit',
    StitchDeposit: 'StitchDeposit'
} as const;
export type GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum = typeof GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum[keyof typeof GetCompletedDepositsWithdrawalsAsyncOrderTypeEnum];
/**
 * @export
 */
export const GetPendingOrdersOrderTypeEnum = {
    All: 'All',
    BankDeposit: 'BankDeposit',
    CryptoDeposit: 'CryptoDeposit',
    BankWithdrawal: 'BankWithdrawal',
    CryptoWithdrawal: 'CryptoWithdrawal',
    DeFiVaultLock: 'DeFiVaultLock',
    DeFiVaultUnlock: 'DeFiVaultUnlock',
    StitchDeposit: 'StitchDeposit'
} as const;
export type GetPendingOrdersOrderTypeEnum = typeof GetPendingOrdersOrderTypeEnum[keyof typeof GetPendingOrdersOrderTypeEnum];
/**
 * @export
 */
export const GetPendingOrders0OrderTypeEnum = {
    All: 'All',
    BankDeposit: 'BankDeposit',
    CryptoDeposit: 'CryptoDeposit',
    BankWithdrawal: 'BankWithdrawal',
    CryptoWithdrawal: 'CryptoWithdrawal',
    DeFiVaultLock: 'DeFiVaultLock',
    DeFiVaultUnlock: 'DeFiVaultUnlock',
    StitchDeposit: 'StitchDeposit'
} as const;
export type GetPendingOrders0OrderTypeEnum = typeof GetPendingOrders0OrderTypeEnum[keyof typeof GetPendingOrders0OrderTypeEnum];
/**
 * @export
 */
export const GetTransactionHistoryAsyncOrderTypeEnum = {
    All: 'All',
    Buy: 'Buy',
    AutoBuy: 'AutoBuy',
    Sell: 'Sell',
    Rebalance: 'Rebalance',
    Redeem: 'Redeem',
    CreditAdjustment: 'CreditAdjustment',
    DebitAdjustment: 'DebitAdjustment'
} as const;
export type GetTransactionHistoryAsyncOrderTypeEnum = typeof GetTransactionHistoryAsyncOrderTypeEnum[keyof typeof GetTransactionHistoryAsyncOrderTypeEnum];
/**
 * @export
 */
export const GetVaultTransactionHistoryAsyncOrderTypeEnum = {
    All: 'All',
    Lock: 'Lock',
    Unlock: 'Unlock'
} as const;
export type GetVaultTransactionHistoryAsyncOrderTypeEnum = typeof GetVaultTransactionHistoryAsyncOrderTypeEnum[keyof typeof GetVaultTransactionHistoryAsyncOrderTypeEnum];


/**
 * TwoFactorApi - axios parameter creator
 * @export
 */
export const TwoFactorApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {OtpSendElevatedRequest} [otpSendElevatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elevatedSend: async (otpSendElevatedRequest?: OtpSendElevatedRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/twoFactor/elevated/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(otpSendElevatedRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActive: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/twoFactor/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listElevated: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/twoFactor/elevated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TwoFactorApi - functional programming interface
 * @export
 */
export const TwoFactorApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TwoFactorApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {OtpSendElevatedRequest} [otpSendElevatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async elevatedSend(otpSendElevatedRequest?: OtpSendElevatedRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.elevatedSend(otpSendElevatedRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorApi.elevatedSend']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listActive(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listActive(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorApi.listActive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listElevated(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listElevated(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TwoFactorApi.listElevated']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TwoFactorApi - factory interface
 * @export
 */
export const TwoFactorApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TwoFactorApiFp(configuration)
    return {
        /**
         * 
         * @param {OtpSendElevatedRequest} [otpSendElevatedRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elevatedSend(otpSendElevatedRequest?: OtpSendElevatedRequest, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.elevatedSend(otpSendElevatedRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listActive(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.listActive(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listElevated(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.listElevated(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TwoFactorApi - object-oriented interface
 * @export
 * @class TwoFactorApi
 * @extends {BaseAPI}
 */
export class TwoFactorApi extends BaseAPI {
    /**
     * 
     * @param {OtpSendElevatedRequest} [otpSendElevatedRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorApi
     */
    public elevatedSend(otpSendElevatedRequest?: OtpSendElevatedRequest, options?: RawAxiosRequestConfig) {
        return TwoFactorApiFp(this.configuration).elevatedSend(otpSendElevatedRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorApi
     */
    public listActive(options?: RawAxiosRequestConfig) {
        return TwoFactorApiFp(this.configuration).listActive(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TwoFactorApi
     */
    public listElevated(options?: RawAxiosRequestConfig) {
        return TwoFactorApiFp(this.configuration).listElevated(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * VerificationApi - axios parameter creator
 * @export
 */
export const VerificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verification/generateAccessToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markVerificationAsCompleteByUser: async (body?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verification/markVerificationAsCompleteByUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tierStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verification/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VerificationApi - functional programming interface
 * @export
 */
export const VerificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VerificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateAccessToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateAccessToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.generateAccessToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markVerificationAsCompleteByUser(body?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markVerificationAsCompleteByUser(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.markVerificationAsCompleteByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tierStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerificationTierStatus>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tierStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['VerificationApi.tierStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * VerificationApi - factory interface
 * @export
 */
export const VerificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VerificationApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateAccessToken(options?: any): AxiosPromise<string> {
            return localVarFp.generateAccessToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markVerificationAsCompleteByUser(body?: string, options?: any): AxiosPromise<void> {
            return localVarFp.markVerificationAsCompleteByUser(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tierStatus(options?: any): AxiosPromise<VerificationTierStatus> {
            return localVarFp.tierStatus(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VerificationApi - object-oriented interface
 * @export
 * @class VerificationApi
 * @extends {BaseAPI}
 */
export class VerificationApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public generateAccessToken(options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).generateAccessToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public markVerificationAsCompleteByUser(body?: string, options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).markVerificationAsCompleteByUser(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VerificationApi
     */
    public tierStatus(options?: RawAxiosRequestConfig) {
        return VerificationApiFp(this.configuration).tierStatus(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WithdrawApi - axios parameter creator
 * @export
 */
export const WithdrawApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all available products that can a user can withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WithdrawApi - functional programming interface
 * @export
 */
export const WithdrawApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WithdrawApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all available products that can a user can withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async availableProducts(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WithdrawProductDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.availableProducts(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawApi.availableProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WithdrawApi - factory interface
 * @export
 */
export const WithdrawApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WithdrawApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all available products that can a user can withdraw
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        availableProducts(options?: any): AxiosPromise<Array<WithdrawProductDto>> {
            return localVarFp.availableProducts(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WithdrawApi - object-oriented interface
 * @export
 * @class WithdrawApi
 * @extends {BaseAPI}
 */
export class WithdrawApi extends BaseAPI {
    /**
     * 
     * @summary Get all available products that can a user can withdraw
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawApi
     */
    public availableProducts(options?: RawAxiosRequestConfig) {
        return WithdrawApiFp(this.configuration).availableProducts(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WithdrawCryptoApi - axios parameter creator
 * @export
 */
export const WithdrawCryptoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancel', 'orderId', orderId)
            const localVarPath = `/withdraw/crypto/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a crypto withdrawal.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {CreateCryptoWithdrawDto} [createCryptoWithdrawDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdraw: async (createCryptoWithdrawDto?: CreateCryptoWithdrawDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/crypto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCryptoWithdrawDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to the selected crypto product for the withdraw flow.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
         * @param {string} [productCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cryptoWithdrawProductData: async (productCode?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/crypto`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productCode !== undefined) {
                localVarQueryParameter['productCode'] = productCode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get pending crypto withrawal orders for the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingCryptoWithdrawOrderDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/crypto/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WithdrawCryptoApi - functional programming interface
 * @export
 */
export const WithdrawCryptoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WithdrawCryptoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancel(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawCryptoApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a crypto withdrawal.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {CreateCryptoWithdrawDto} [createCryptoWithdrawDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithdraw(createCryptoWithdrawDto?: CreateCryptoWithdrawDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WithdrawDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithdraw(createCryptoWithdrawDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawCryptoApi.createWithdraw']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to the selected crypto product for the withdraw flow.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
         * @param {string} [productCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cryptoWithdrawProductData(productCode?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CryptoWithdrawProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cryptoWithdrawProductData(productCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawCryptoApi.cryptoWithdrawProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get pending crypto withrawal orders for the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingCryptoWithdrawOrderDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingCryptoWithdrawOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingCryptoWithdrawOrderDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawCryptoApi.getPendingCryptoWithdrawOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WithdrawCryptoApi - factory interface
 * @export
 */
export const WithdrawCryptoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WithdrawCryptoApiFp(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a crypto withdrawal.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
         * @param {CreateCryptoWithdrawDto} [createCryptoWithdrawDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdraw(createCryptoWithdrawDto?: CreateCryptoWithdrawDto, options?: any): AxiosPromise<WithdrawDetailsDto> {
            return localVarFp.createWithdraw(createCryptoWithdrawDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to the selected crypto product for the withdraw flow.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
         * @param {string} [productCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cryptoWithdrawProductData(productCode?: string, options?: any): AxiosPromise<CryptoWithdrawProductDataDto> {
            return localVarFp.cryptoWithdrawProductData(productCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get pending crypto withrawal orders for the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingCryptoWithdrawOrderDetails(options?: any): AxiosPromise<Array<PendingCryptoWithdrawOrderDto>> {
            return localVarFp.getPendingCryptoWithdrawOrderDetails(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WithdrawCryptoApi - object-oriented interface
 * @export
 * @class WithdrawCryptoApi
 * @extends {BaseAPI}
 */
export class WithdrawCryptoApi extends BaseAPI {
    /**
     * 
     * @summary User can cancel an order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WithdrawCryptoApi
     */
    public cancel(orderId: string, options?: RawAxiosRequestConfig) {
        return WithdrawCryptoApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a crypto withdrawal.  If no ProductCode is passed in the object body, the value of ProductCode is defaulted to \"BTC\".
     * @param {CreateCryptoWithdrawDto} [createCryptoWithdrawDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawCryptoApi
     */
    public createWithdraw(createCryptoWithdrawDto?: CreateCryptoWithdrawDto, options?: RawAxiosRequestConfig) {
        return WithdrawCryptoApiFp(this.configuration).createWithdraw(createCryptoWithdrawDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to the selected crypto product for the withdraw flow.  If no productCode is passed in the query string, the value of productCode is defaulted to \"BTC\".
     * @param {string} [productCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawCryptoApi
     */
    public cryptoWithdrawProductData(productCode?: string, options?: RawAxiosRequestConfig) {
        return WithdrawCryptoApiFp(this.configuration).cryptoWithdrawProductData(productCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get pending crypto withrawal orders for the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawCryptoApi
     */
    public getPendingCryptoWithdrawOrderDetails(options?: RawAxiosRequestConfig) {
        return WithdrawCryptoApiFp(this.configuration).getPendingCryptoWithdrawOrderDetails(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WithdrawFiatApi - axios parameter creator
 * @export
 */
export const WithdrawFiatApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel: async (orderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cancel', 'orderId', orderId)
            const localVarPath = `/withdraw/fiat/{orderId}/cancel`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a fiat withdrawal
         * @param {CreateFiatWithdrawDto} [createFiatWithdrawDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawal: async (createFiatWithdrawDto?: CreateFiatWithdrawDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fiat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFiatWithdrawDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to EUR for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euroFiatWithdrawProductData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fiat/eur`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to GBP for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gbpFiatWithdrawProductData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fiat/gbp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get pending fiat withdrawal orders for the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingFiatWithdrawOrderDetails: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fiat/pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to USD for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usdFiatWithdrawProductData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fiat/usd`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get data specific to ZAR for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zarFiatWithdrawProductData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/withdraw/fiat/zar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WithdrawFiatApi - functional programming interface
 * @export
 */
export const WithdrawFiatApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WithdrawFiatApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async cancel(orderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancel(orderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.cancel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a fiat withdrawal
         * @param {CreateFiatWithdrawDto} [createFiatWithdrawDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createWithdrawal(createFiatWithdrawDto?: CreateFiatWithdrawDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WithdrawDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createWithdrawal(createFiatWithdrawDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.createWithdrawal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to EUR for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async euroFiatWithdrawProductData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EuroFiatWithdrawProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.euroFiatWithdrawProductData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.euroFiatWithdrawProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to GBP for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async gbpFiatWithdrawProductData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GbpFiatWithdrawProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.gbpFiatWithdrawProductData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.gbpFiatWithdrawProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get pending fiat withdrawal orders for the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPendingFiatWithdrawOrderDetails(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PendingFiatWithdrawOrderDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPendingFiatWithdrawOrderDetails(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.getPendingFiatWithdrawOrderDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to USD for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usdFiatWithdrawProductData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsdFiatWithdrawProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usdFiatWithdrawProductData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.usdFiatWithdrawProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get data specific to ZAR for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zarFiatWithdrawProductData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZarFiatWithdrawProductDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zarFiatWithdrawProductData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WithdrawFiatApi.zarFiatWithdrawProductData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WithdrawFiatApi - factory interface
 * @export
 */
export const WithdrawFiatApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WithdrawFiatApiFp(configuration)
    return {
        /**
         * 
         * @summary User can cancel an order
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancel(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancel(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a fiat withdrawal
         * @param {CreateFiatWithdrawDto} [createFiatWithdrawDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createWithdrawal(createFiatWithdrawDto?: CreateFiatWithdrawDto, options?: any): AxiosPromise<WithdrawDetailsDto> {
            return localVarFp.createWithdrawal(createFiatWithdrawDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to EUR for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        euroFiatWithdrawProductData(options?: any): AxiosPromise<EuroFiatWithdrawProductDataDto> {
            return localVarFp.euroFiatWithdrawProductData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to GBP for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        gbpFiatWithdrawProductData(options?: any): AxiosPromise<GbpFiatWithdrawProductDataDto> {
            return localVarFp.gbpFiatWithdrawProductData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get pending fiat withdrawal orders for the customer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPendingFiatWithdrawOrderDetails(options?: any): AxiosPromise<Array<PendingFiatWithdrawOrderDto>> {
            return localVarFp.getPendingFiatWithdrawOrderDetails(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to USD for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usdFiatWithdrawProductData(options?: any): AxiosPromise<UsdFiatWithdrawProductDataDto> {
            return localVarFp.usdFiatWithdrawProductData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get data specific to ZAR for the withdraw flow
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zarFiatWithdrawProductData(options?: any): AxiosPromise<ZarFiatWithdrawProductDataDto> {
            return localVarFp.zarFiatWithdrawProductData(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WithdrawFiatApi - object-oriented interface
 * @export
 * @class WithdrawFiatApi
 * @extends {BaseAPI}
 */
export class WithdrawFiatApi extends BaseAPI {
    /**
     * 
     * @summary User can cancel an order
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public cancel(orderId: string, options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).cancel(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a fiat withdrawal
     * @param {CreateFiatWithdrawDto} [createFiatWithdrawDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public createWithdrawal(createFiatWithdrawDto?: CreateFiatWithdrawDto, options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).createWithdrawal(createFiatWithdrawDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to EUR for the withdraw flow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public euroFiatWithdrawProductData(options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).euroFiatWithdrawProductData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to GBP for the withdraw flow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public gbpFiatWithdrawProductData(options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).gbpFiatWithdrawProductData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get pending fiat withdrawal orders for the customer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public getPendingFiatWithdrawOrderDetails(options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).getPendingFiatWithdrawOrderDetails(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to USD for the withdraw flow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public usdFiatWithdrawProductData(options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).usdFiatWithdrawProductData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get data specific to ZAR for the withdraw flow
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WithdrawFiatApi
     */
    public zarFiatWithdrawProductData(options?: RawAxiosRequestConfig) {
        return WithdrawFiatApiFp(this.configuration).zarFiatWithdrawProductData(options).then((request) => request(this.axios, this.basePath));
    }
}



